var _regeneratorRuntime = require("@babel/runtime/regenerator");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('vue'), require('lodash.get'), require('lodash.isequal'), require('lodash.map'), require('lodash.clonedeep'), require('lodash.intersection'), require('body-scroll-lock'), require('lodash.range'), require('lodash.kebabcase'), require('lodash.pick'), require('lodash.merge')) : typeof define === 'function' && define.amd ? define(['exports', 'vue', 'lodash.get', 'lodash.isequal', 'lodash.map', 'lodash.clonedeep', 'lodash.intersection', 'body-scroll-lock', 'lodash.range', 'lodash.kebabcase', 'lodash.pick', 'lodash.merge'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.VueTailwind = {}, global.Vue, global.get, global.isEqual, global.map, global.cloneDeep, global.intersection, global.bodyScrollLock, global.range, global.kebabCase, global.pick, global.merge));
})(this, function (exports, Vue, get, isEqual, map, cloneDeep, intersection, bodyScrollLock, range, kebabCase, pick, merge) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && _typeof(e) === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

  var get__default = /*#__PURE__*/_interopDefaultLegacy(get);

  var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);

  var map__default = /*#__PURE__*/_interopDefaultLegacy(map);

  var cloneDeep__default = /*#__PURE__*/_interopDefaultLegacy(cloneDeep);

  var intersection__default = /*#__PURE__*/_interopDefaultLegacy(intersection);

  var range__default = /*#__PURE__*/_interopDefaultLegacy(range);

  var kebabCase__default = /*#__PURE__*/_interopDefaultLegacy(kebabCase);

  var pick__default = /*#__PURE__*/_interopDefaultLegacy(pick);

  var merge__default = /*#__PURE__*/_interopDefaultLegacy(merge);

  var mergeClasses = function mergeClasses(classesA, classesB) {
    var a = classesA;
    var b = classesB; // Convert array of string classes to a single string

    if (Array.isArray(classesA) && classesA.every(function (className) {
      return typeof className === 'string' || !!className;
    })) {
      a = classesA.filter(function (className) {
        return !!className;
      }).join(' ');
    } // Convert array of string classes to a single string


    if (Array.isArray(classesB) && classesB.every(function (className) {
      return typeof className === 'string' || !!className;
    })) {
      b = classesB.filter(function (className) {
        return !!className;
      }).join(' ');
    }

    if (typeof a === 'string' && typeof b === 'string') {
      return "".concat(a, " ").concat(b);
    }

    if (typeof a === 'string' && Array.isArray(b)) {
      return [a].concat(b);
    }

    if (typeof b === 'string' && Array.isArray(a)) {
      return a.concat([b]);
    }

    if (Array.isArray(a) && Array.isArray(b)) {
      return a.concat(b);
    }

    return [a, b];
  };

  var Component = Vue__default['default'].extend({
    props: {
      classes: {
        type: [String, Array, Object],
        default: undefined
      },
      fixedClasses: {
        type: [String, Array, Object],
        default: undefined
      },
      variants: {
        type: Object,
        default: undefined
      },
      variant: {
        type: [String, Object],
        default: undefined
      }
    },
    computed: {
      componentClass: function componentClass() {
        return this.getElementCssClass();
      },
      activeVariant: function activeVariant() {
        var _this = this;

        if (!this.variant) {
          return undefined;
        }

        if (_typeof(this.variant) === 'object') {
          var truthyVariant = Object.keys(this.variant).find(function (variant) {
            return !!_this.variant[variant];
          });
          return truthyVariant || undefined;
        }

        return this.variant;
      }
    },
    methods: {
      getElementCssClass: function getElementCssClass(elementName) {
        var defaultClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var classes;

        if (elementName) {
          if (this.activeVariant) {
            var elementVariant = get__default['default'](this.variants, "".concat(this.activeVariant, ".").concat(elementName)); // If the variant exists but not for the element fallback to the default

            if (elementVariant === undefined && get__default['default'](this.variants, this.activeVariant) !== undefined) {
              classes = get__default['default'](this.classes, elementName, defaultClasses);
            } else {
              classes = elementVariant === undefined ? defaultClasses : elementVariant;
            }
          } else {
            classes = get__default['default'](this.classes, elementName, defaultClasses);
          }

          var fixedClasses = get__default['default'](this.fixedClasses, elementName);

          if (fixedClasses) {
            return mergeClasses(fixedClasses, classes);
          }

          return classes;
        }

        if (this.activeVariant) {
          classes = get__default['default'](this.variants, this.activeVariant, defaultClasses);
        } else {
          classes = this.classes === undefined ? defaultClasses : this.classes;
        }

        if (this.fixedClasses) {
          return mergeClasses(this.fixedClasses, classes);
        }

        return classes;
      }
    }
  });
  var HtmlInput = Component.extend({
    props: {
      id: {
        type: String,
        default: undefined
      },
      name: {
        type: String,
        default: undefined
      },
      disabled: {
        type: Boolean,
        default: undefined
      },
      readonly: {
        type: Boolean,
        default: undefined
      },
      autofocus: {
        type: Boolean,
        default: undefined
      },
      required: {
        type: Boolean,
        default: undefined
      },
      tabindex: {
        type: [String, Number],
        default: undefined
      }
    },
    methods: {
      getListeners: function getListeners(listeners) {
        return Object.assign(Object.assign({}, this.$listeners), listeners);
      }
    }
  });
  /* eslint-disable no-shadow */

  var Key;

  (function (Key) {
    Key[Key["LEFT"] = 37] = "LEFT";
    Key[Key["UP"] = 38] = "UP";
    Key[Key["RIGHT"] = 39] = "RIGHT";
    Key[Key["DOWN"] = 40] = "DOWN";
    Key[Key["ENTER"] = 13] = "ENTER";
    Key[Key["ESC"] = 27] = "ESC";
    Key[Key["SPACE"] = 32] = "SPACE";
    Key[Key["BACKSPACE"] = 8] = "BACKSPACE";
  })(Key || (Key = {}));

  var Key$1 = Key;
  var TCheckbox = HtmlInput.extend({
    name: 'TCheckbox',
    props: {
      value: {
        type: [String, Object, Number, Boolean, Array],
        default: true
      },
      uncheckedValue: {
        type: [String, Object, Number, Boolean, Array],
        default: false
      },
      indeterminate: {
        type: [Boolean, String],
        default: undefined
      },
      checked: {
        type: [Boolean, String],
        default: undefined
      },
      model: {
        // v-model
        type: [String, Object, Number, Boolean, Array],
        default: undefined
      },
      wrapped: {
        type: Boolean,
        default: false
      },
      wrapperTag: {
        type: String,
        default: 'label'
      },
      inputWrapperTag: {
        type: String,
        default: 'span'
      },
      labelTag: {
        type: String,
        default: 'span'
      },
      label: {
        type: [String, Number],
        default: undefined
      },
      classes: {
        type: [String, Array, Object],
        default: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed'
      }
    },
    data: function data() {
      return {
        localValue: this.model
      };
    },
    model: {
      prop: 'model',
      event: 'input'
    },
    render: function render(createElement) {
      var renderFun = this.render; // eslint-disable-next-line max-len

      var createWrappedFunc = this.renderWrapped;

      if (this.wrapped) {
        return createWrappedFunc(createElement);
      }

      return renderFun(createElement);
    },
    computed: {
      isChecked: {
        get: function get() {
          if (this.model === undefined) {
            return this.checked;
          }

          if (Array.isArray(this.model)) {
            return this.model.indexOf(this.value) >= 0;
          }

          return this.model === this.value;
        },
        set: function set(checked) {
          this.localValue = checked;
        }
      }
    },
    watch: {
      isChecked: function isChecked(_isChecked) {
        var input = this.getInput();

        if (input.checked !== _isChecked) {
          input.checked = _isChecked;
        }
      },
      indeterminate: function indeterminate(_indeterminate) {
        this.setIndeterminate(_indeterminate);
      },
      checked: function checked(_checked) {
        this.setChecked(_checked);
      }
    },
    methods: {
      getInput: function getInput() {
        return this.$refs.input;
      },
      renderWrapped: function renderWrapped(createElement) {
        var _this2 = this;

        var childElements = [];
        var input = this.render(createElement);
        var inputWrapperClass = this.getElementCssClass('inputWrapper');
        var checkedInputWrapperClass = this.getElementCssClass('inputWrapperChecked', this.getElementCssClass('inputWrapper'));
        childElements.push(createElement(this.inputWrapperTag, {
          ref: 'inputWrapper',
          class: this.isChecked ? checkedInputWrapperClass : inputWrapperClass
        }, [input]));
        var labelClass = this.getElementCssClass('label');
        var checkedLabelClass = this.getElementCssClass('labelChecked', this.getElementCssClass('label'));
        var label;

        if (this.$scopedSlots.default !== undefined) {
          label = this.$scopedSlots.default({
            isChecked: this.isChecked,
            value: this.isChecked ? this.value : this.uncheckedValue,
            label: this.label
          });
        } else {
          label = typeof this.label === 'number' ? String(this.label) : this.label;
        }

        childElements.push(createElement(this.labelTag, {
          ref: 'label',
          class: this.isChecked ? checkedLabelClass : labelClass
        }, label));
        var wrapperClass = this.getElementCssClass('wrapper');
        var checkedWrapperClass = this.getElementCssClass('wrapperChecked', this.getElementCssClass('wrapper'));
        return createElement(this.wrapperTag, {
          ref: 'wrapper',
          class: this.isChecked ? checkedWrapperClass : wrapperClass,
          attrs: {
            for: this.id,
            tabindex: this.tabindex,
            autofocus: this.autofocus
          },
          on: {
            keydown: function keydown(e) {
              if (e.keyCode === Key$1.SPACE) {
                _this2.wrapperSpaceHandler(e);
              }
            }
          }
        }, childElements);
      },
      render: function render(createElement) {
        return createElement('input', {
          class: this.wrapped ? this.getElementCssClass('input') : this.componentClass,
          ref: 'input',
          attrs: {
            checked: this.isChecked,
            value: this.value,
            id: this.id,
            type: 'checkbox',
            name: this.name,
            disabled: this.disabled,
            readonly: this.readonly,
            required: this.required,
            autofocus: !this.wrapped ? this.autofocus : undefined,
            tabindex: this.wrapped && this.tabindex !== undefined ? -1 : this.tabindex
          },
          on: this.getListeners({
            blur: this.blurHandler,
            focus: this.focusHandler,
            change: this.changeHandler,
            input: function input() {// Empty, overrides the input handler from the checkbox group
            }
          })
        });
      },
      wrapperSpaceHandler: function wrapperSpaceHandler(e) {
        e.preventDefault();
        this.click();
      },
      setIndeterminate: function setIndeterminate(indeterminate) {
        var input = this.getInput();
        input.indeterminate = indeterminate; // Emit update event to prop

        this.$emit('update:indeterminate', indeterminate);
      },
      setChecked: function setChecked(checked) {
        var input = this.getInput(); // this.localValue = checked;

        input.checked = !checked;
        input.click(); // Emit update event to prop

        this.$emit('update:checked', checked);
      },
      changeHandler: function changeHandler() {
        var input = this.getInput();
        var isChecked = input.checked;
        var localValue;

        if (Array.isArray(this.model)) {
          localValue = _toConsumableArray(this.model);
          var index = localValue.indexOf(this.value);

          if (isChecked && index < 0) {
            localValue.push(this.value);
          } else if (!isChecked && index >= 0) {
            localValue.splice(index, 1);
          }
        } else {
          localValue = isChecked ? this.value : this.uncheckedValue;
        }

        this.$emit('input', localValue);
        this.$emit('change', localValue);
        this.$emit('update:indeterminate', false);
        this.$emit('update:checked', isChecked);
      },
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
      },
      blur: function blur() {
        this.getInput().blur();
      },
      click: function click() {
        this.getInput().click();
      },
      focus: function focus(options) {
        this.getInput().focus(options);
      }
    }
  });
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }

    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  var checkIfTagShouldBeChecked = function checkIfTagShouldBeChecked(model, checked, value) {
    return model === undefined ? !!checked : isEqual__default['default'](model, value);
  };

  var TRadio = HtmlInput.extend({
    name: 'TRadio',
    props: {
      value: {
        type: [String, Object, Number, Boolean, Array],
        default: 'on'
      },
      checked: {
        type: [Boolean, String],
        default: false
      },
      model: {
        // v-model
        type: [String, Object, Number, Boolean, Array],
        default: undefined
      },
      wrapped: {
        type: Boolean,
        default: false
      },
      wrapperTag: {
        type: String,
        default: 'label'
      },
      inputWrapperTag: {
        type: String,
        default: 'span'
      },
      labelTag: {
        type: String,
        default: 'span'
      },
      label: {
        type: [String, Number],
        default: undefined
      },
      classes: {
        type: [String, Array, Object],
        default: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed'
      }
    },
    data: function data() {
      // const defaultValue = (this.model === undefined ? null : this.model);
      return {
        localValue: this.checked ? this.value : null
      };
    },
    model: {
      prop: 'model',
      event: 'input'
    },
    render: function render(createElement) {
      var renderFun = this.render; // eslint-disable-next-line max-len

      var createWrappedFunc = this.renderWrapped;

      if (this.wrapped) {
        return createWrappedFunc(createElement);
      }

      return renderFun(createElement);
    },
    watch: {
      model: function model(_model) {
        if (isEqual__default['default'](_model, this.localValue)) {
          return;
        }

        this.localValue = _model;
      },
      checked: function checked(_checked2) {
        var localValue = _checked2 ? this.value : null;

        if (!isEqual__default['default'](localValue, this.localValue)) {
          this.localValue = localValue;
        }
      },
      localValue: function localValue(_localValue) {
        if (isEqual__default['default'](this.model, _localValue)) {
          return;
        }

        this.$emit('input', _localValue);
        this.$emit('change', _localValue);
      },
      isChecked: function isChecked(_isChecked2) {
        var input = this.$refs.input;

        if (input && input.checked !== _isChecked2) {
          input.checked = _isChecked2;
        }
      }
    },
    computed: {
      isChecked: function isChecked() {
        return checkIfTagShouldBeChecked(this.model, this.checked, this.value);
      }
    },
    methods: {
      renderWrapped: function renderWrapped(createElement) {
        var _this3 = this;

        var childElements = [];
        var input = this.render(createElement);
        var inputWrapperClass = this.getElementCssClass('inputWrapper');
        var checkedInputWrapperClass = this.getElementCssClass('inputWrapperChecked', this.getElementCssClass('inputWrapper'));
        childElements.push(createElement(this.inputWrapperTag, {
          ref: 'inputWrapper',
          class: this.isChecked ? checkedInputWrapperClass : inputWrapperClass
        }, [input]));
        var labelClass = this.getElementCssClass('label');
        var checkedLabelClass = this.getElementCssClass('labelChecked', this.getElementCssClass('label'));
        var label;

        if (this.$scopedSlots.default !== undefined) {
          label = this.$scopedSlots.default({
            isChecked: this.isChecked,
            value: this.localValue,
            label: this.label
          });
        } else {
          label = typeof this.label === 'number' ? String(this.label) : this.label;
        }

        childElements.push(createElement(this.labelTag, {
          ref: 'label',
          class: this.isChecked ? checkedLabelClass : labelClass
        }, label));
        var wrapperClass = this.getElementCssClass('wrapper');
        var checkedWrapperClass = this.getElementCssClass('wrapperChecked', this.getElementCssClass('wrapper'));
        return createElement(this.wrapperTag, {
          ref: 'wrapper',
          class: this.isChecked ? checkedWrapperClass : wrapperClass,
          attrs: {
            for: this.id,
            tabindex: this.tabindex,
            autofocus: this.autofocus
          },
          on: {
            keydown: function keydown(e) {
              if ([Key$1.DOWN, Key$1.RIGHT].includes(e.keyCode)) {
                _this3.selectNextRadio(e);
              } else if ([Key$1.UP, Key$1.LEFT].includes(e.keyCode)) {
                _this3.selectPrevRadio(e);
              } else if (e.keyCode === Key$1.SPACE) {
                _this3.wrapperSpaceHandler(e);
              }
            }
          }
        }, childElements);
      },
      render: function render(createElement) {
        return createElement('input', {
          class: this.wrapped ? this.getElementCssClass('input') : this.componentClass,
          ref: 'input',
          attrs: {
            value: this.value,
            id: this.id,
            type: 'radio',
            checked: checkIfTagShouldBeChecked(this.model, this.checked, this.value),
            name: this.name,
            disabled: this.disabled,
            readonly: this.readonly,
            required: this.required,
            autofocus: !this.wrapped ? this.autofocus : undefined,
            tabindex: this.wrapped && this.tabindex !== undefined ? -1 : this.tabindex
          },
          on: this.getListeners({
            blur: this.blurHandler,
            focus: this.focusHandler,
            input: this.inputHandler
          })
        });
      },
      inputHandler: function inputHandler(e) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var target;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  target = e.target; // Only update the local value when the element is checked

                  if (target.checked) {
                    this.localValue = this.value;
                    this.sendInputEventToTheNotCheckedInputs();
                  }

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      },

      /**
       * We need to trigger the input event in all the inputs that are not checked
       * so we can update the `elementChecked` local property that is used to
       * change the classes of the wrapper div according to the state
       */
      sendInputEventToTheNotCheckedInputs: function sendInputEventToTheNotCheckedInputs() {
        var notCheckedEls = document.querySelectorAll("input[name=".concat(this.name, "]:not(:checked)"));
        notCheckedEls.forEach(function (el) {
          el.dispatchEvent(new Event('input'));
        });
      },
      selectPrevRadio: function selectPrevRadio(e) {
        var _this4 = this;

        e.preventDefault();
        var currentEl = this.$refs.input;
        var els = Array.from(document.querySelectorAll("input[name=".concat(this.name, "]")));
        var currentElementIndex = els.findIndex(function (radioInput) {
          return radioInput === _this4.$refs.input;
        });
        var prevElement = els[currentElementIndex - 1] || els[els.length - 1];

        if (prevElement !== currentEl && prevElement) {
          var wrapper = prevElement.parentNode ? prevElement.parentNode.parentNode : undefined;

          if (wrapper && wrapper.tabIndex >= 0) {
            wrapper.focus();
          } else {
            prevElement.focus();
          }
        }
      },
      selectNextRadio: function selectNextRadio(e) {
        var _this5 = this;

        e.preventDefault();
        var currentEl = this.$refs.input;
        var els = Array.from(document.querySelectorAll("input[name=".concat(this.name, "]")));
        var currentElementIndex = els.findIndex(function (radioInput) {
          return radioInput === _this5.$refs.input;
        });
        var nextElement = els[currentElementIndex + 1] || els[0];

        if (nextElement !== currentEl && nextElement) {
          var wrapper = nextElement.parentNode ? nextElement.parentNode.parentNode : undefined;

          if (wrapper && wrapper.tabIndex >= 0) {
            wrapper.focus();
          } else {
            nextElement.focus();
          }
        }
      },
      wrapperSpaceHandler: function wrapperSpaceHandler(e) {
        e.preventDefault();
        this.localValue = this.value;
      },
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
      },
      blur: function blur() {
        this.$refs.input.blur();
      },
      click: function click() {
        this.$refs.input.click();
      },
      focus: function focus(options) {
        this.$refs.input.focus(options);
      }
    }
  });
  var TextInput = HtmlInput.extend({
    props: {
      value: {
        type: [String, Number],
        default: undefined
      },
      autocomplete: {
        type: String,
        default: undefined
      },
      maxlength: {
        type: [String, Number],
        default: undefined
      },
      minlength: {
        type: [String, Number],
        default: undefined
      },
      multiple: {
        type: Boolean,
        default: undefined
      },
      pattern: {
        type: String,
        default: undefined
      },
      placeholder: {
        type: String,
        default: undefined
      },
      classes: {
        type: [String, Array, Object],
        default: undefined
      }
    },
    data: function data() {
      return {
        localValue: this.value,
        valueWhenFocus: null
      };
    },
    watch: {
      localValue: function localValue(_localValue2) {
        this.$emit('input', _localValue2);
      },
      value: function value(_value) {
        this.localValue = _value;
      }
    },
    methods: {
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);

        if (this.localValue !== this.valueWhenFocus) {
          this.$emit('change', this.localValue);
        }
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
        this.valueWhenFocus = this.localValue;
      },
      keyupHandler: function keyupHandler(e) {
        this.$emit('keyup', e);
      },
      keydownHandler: function keydownHandler(e) {
        this.$emit('keydown', e);
      },
      blur: function blur() {
        this.$el.blur();
      },
      click: function click() {
        this.$el.click();
      },
      focus: function focus(options) {
        this.$el.focus(options);
      },
      select: function select() {
        this.$el.select();
      },
      setSelectionRange: function setSelectionRange(start, end, direction) {
        this.$el.setSelectionRange(start, end, direction);
      },
      setRangeText: function setRangeText(replacement) {
        this.$el.setRangeText(replacement);
      }
    }
  });
  var TTextarea = TextInput.extend({
    name: 'TTextarea',
    props: {
      rows: {
        type: String,
        default: undefined
      },
      cols: {
        type: String,
        default: undefined
      },
      wrap: {
        type: String,
        default: 'soft'
      },
      classes: {
        type: [String, Array, Object],
        default: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50  disabled:opacity-50 disabled:cursor-not-allowed'
      }
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    methods: {
      render: function render(createElement) {
        return createElement('textarea', {
          class: this.componentClass,
          ref: 'input',
          domProps: {
            value: this.localValue
          },
          attrs: {
            id: this.id,
            name: this.name,
            disabled: this.disabled,
            readonly: this.readonly,
            autocomplete: this.autocomplete,
            autofocus: this.autofocus,
            required: this.required,
            placeholder: this.placeholder,
            pattern: this.pattern,
            multiple: this.multiple,
            minlength: this.minlength,
            maxlength: this.maxlength,
            wrap: this.wrap,
            rows: this.rows,
            cols: this.cols
          },
          on: this.getListeners({
            blur: this.blurHandler,
            focus: this.focusHandler,
            keyup: this.keyupHandler,
            keydown: this.keydownHandler,
            input: this.inputHandler
          })
        });
      },
      inputHandler: function inputHandler(e) {
        var target = e.target;
        this.$emit('input', target.value);
      }
    }
  });
  var TInput = TextInput.extend({
    name: 'TInput',
    props: {
      type: {
        type: String,
        default: 'text'
      },
      max: {
        type: [String, Number],
        default: undefined
      },
      min: {
        type: [String, Number],
        default: undefined
      },
      classes: {
        type: [String, Array, Object],
        default: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed'
      }
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    methods: {
      render: function render(createElement) {
        return createElement('input', {
          class: this.componentClass,
          ref: 'input',
          domProps: {
            value: this.localValue
          },
          attrs: {
            id: this.id,
            name: this.name,
            disabled: this.disabled,
            readonly: this.readonly,
            autocomplete: this.autocomplete,
            autofocus: this.autofocus,
            type: this.type,
            required: this.required,
            placeholder: this.placeholder,
            pattern: this.pattern,
            multiple: this.multiple,
            minlength: this.minlength,
            min: this.min,
            maxlength: this.maxlength,
            max: this.max
          },
          on: this.getListeners({
            blur: this.blurHandler,
            focus: this.focusHandler,
            keyup: this.keyupHandler,
            keydown: this.keydownHandler,
            input: this.inputHandler
          })
        });
      },
      inputHandler: function inputHandler(e) {
        var target = e.target;
        this.$emit('input', target.value);
      }
    }
  });

  var guessOptionValue = function guessOptionValue(option, valueAttribute) {
    if (valueAttribute) {
      return get__default['default'](option, valueAttribute);
    }

    return get__default['default'](option, 'value', get__default['default'](option, 'id', get__default['default'](option, 'text')));
  };

  var guessOptionText = function guessOptionText(option, textAttribute) {
    if (textAttribute) {
      return get__default['default'](option, textAttribute);
    }

    return get__default['default'](option, 'text', get__default['default'](option, 'label'));
  };

  var normalizeOption = function normalizeOption(option, textAttribute, valueAttribute) {
    if (typeof option === 'string' || typeof option === 'number' || typeof option === 'boolean') {
      return {
        value: option,
        text: option,
        raw: option
      };
    }

    if (option.children) {
      var children = option.children.map(function (childOption) {
        return normalizeOption(childOption);
      });
      return {
        value: guessOptionValue(option, valueAttribute),
        text: guessOptionText(option, textAttribute),
        children: children
      };
    }

    var normalizedOption = {
      value: guessOptionValue(option, valueAttribute),
      text: guessOptionText(option, textAttribute),
      raw: option
    };

    if (option.disabled !== undefined) {
      normalizedOption.disabled = option.disabled;
    }

    return normalizedOption;
  };

  var _normalizeOptions = function normalizeOptions(options, textAttribute, valueAttribute) {
    if (!options) {
      return [];
    }

    if (Array.isArray(options)) {
      return options.map(function (option) {
        return normalizeOption(option, textAttribute, valueAttribute);
      });
    }

    return map__default['default'](options, function (option, key) {
      return {
        value: key,
        text: option
      };
    });
  };

  var InputWithOptions = HtmlInput.extend({
    props: {
      value: {
        type: [String, Object, Number, Boolean],
        default: null
      },
      valueAttribute: {
        type: String,
        default: undefined
      },
      textAttribute: {
        type: String,
        default: undefined
      },
      options: {
        type: [Array, Object],
        default: undefined
      }
    },
    data: function data() {
      return {
        localValue: this.value
      };
    },
    computed: {
      normalizedOptions: function normalizedOptions() {
        return this.normalizeOptions(this.options);
      },
      flattenedOptions: function flattenedOptions() {
        return this.normalizedOptions.map(function (option) {
          if (option.children) {
            return option.children;
          }

          return option;
        }).flat();
      }
    },
    methods: {
      normalizeOptions: function normalizeOptions(options) {
        return _normalizeOptions(options, this.textAttribute, this.valueAttribute);
      }
    }
  });
  var MultipleInput = InputWithOptions.extend({
    props: {
      value: {
        type: [Array, String, Number, Boolean, Object],
        default: null
      },
      multiple: {
        type: Boolean,
        default: undefined
      }
    }
  });
  var TSelect = MultipleInput.extend({
    name: 'TSelect',
    props: {
      placeholder: {
        type: String,
        default: undefined
      },
      wrapped: {
        type: Boolean,
        default: false
      },
      classes: {
        type: [String, Array, Object],
        default: 'block w-full pl-3 pr-10 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed'
      }
    },
    data: function data() {
      return {
        localValue: this.value
      };
    },
    computed: {
      normalizedOptionsWithPlaceholder: function normalizedOptionsWithPlaceholder() {
        if (this.placeholder === undefined) {
          return this.normalizedOptions;
        }

        var normalizedOptions = this.normalizedOptions;
        var placeholder = [{
          value: null,
          text: this.placeholder
        }];
        return placeholder.concat(normalizedOptions);
      }
    },
    watch: {
      localValue: function localValue(_localValue3) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this.$emit('input', _localValue3);
                  _context2.next = 3;
                  return this.$nextTick();

                case 3:
                  this.$emit('change', _localValue3);

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      },
      value: function value(_value2) {
        this.localValue = _value2;
      }
    },
    render: function render(createElement) {
      var createSelectFunc = this.createSelect; // eslint-disable-next-line max-len

      var createSelectWrapperFunc = this.createSelectWrapper;

      if (this.wrapped) {
        return createSelectWrapperFunc(createElement);
      }

      return createSelectFunc(createElement);
    },
    methods: {
      createSelectWrapper: function createSelectWrapper(createElement) {
        var children = [this.createSelect(createElement)];

        if (!this.multiple) {
          if (this.$scopedSlots.arrowWrapper) {
            var arrowWrapper = this.$scopedSlots.arrowWrapper({
              className: this.getElementCssClass('arrowWrapper'),
              variant: this.variant,
              value: this.localValue
            });
            children.push(arrowWrapper);
          } else {
            children.push(this.createArrow(createElement));
          }
        }

        return createElement('div', {
          ref: 'selectWrapper',
          class: this.getElementCssClass('wrapper')
        }, children);
      },
      createArrow: function createArrow(createElement) {
        var subElements = [];

        if (this.$scopedSlots.arrow) {
          subElements.push(this.$scopedSlots.arrow({
            className: this.getElementCssClass('arrow'),
            variant: this.variant,
            value: this.localValue
          }));
        } else {
          subElements.push(createElement('svg', {
            attrs: {
              fill: 'currentColor',
              xmlns: 'http://www.w3.org/2000/svg',
              viewBox: '0 0 20 20'
            },
            class: this.getElementCssClass('arrow')
          }, [createElement('path', {
            attrs: {
              'clip-rule': 'evenodd',
              'fill-rule': 'evenodd',
              d: 'M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z'
            }
          })]));
        }

        return createElement('span', {
          ref: 'arrow',
          class: this.getElementCssClass('arrowWrapper')
        }, subElements);
      },
      createSelect: function createSelect(createElement) {
        return createElement('select', {
          ref: 'select',
          attrs: {
            id: this.id,
            autofocus: this.autofocus,
            disabled: this.disabled,
            name: this.name,
            required: this.required,
            multiple: this.multiple
          },
          class: this.wrapped ? this.getElementCssClass('input') : this.getElementCssClass(),
          on: this.getListeners({
            blur: this.blurHandler,
            focus: this.focusHandler,
            input: this.inputHandler
          })
        }, this.createOptions(createElement, this.value));
      },
      createOptions: function createOptions(createElement, value) {
        var _this6 = this;

        var options = this.normalizedOptionsWithPlaceholder;
        return options.map(function (option) {
          if (option.children) {
            return _this6.createOptgroup(createElement, option, value);
          }

          return _this6.createOption(createElement, option, value);
        });
      },
      createOptgroup: function createOptgroup(createElement, option, value) {
        var _this7 = this;

        var _a;

        return createElement('optgroup', {
          domProps: {
            label: guessOptionText(option, this.textAttribute)
          }
        }, (_a = option.children) === null || _a === void 0 ? void 0 : _a.map(function (opt) {
          return _this7.createOption(createElement, opt, value);
        }));
      },
      createOption: function createOption(createElement, option, value) {
        var isSelected = Array.isArray(value) ? value.includes(option.value) : value === option.value;
        return createElement('option', {
          domProps: {
            value: option.value,
            selected: isSelected,
            disabled: option.disabled
          }
        }, option.text);
      },
      inputHandler: function inputHandler(e) {
        var target = e.target;
        var value;

        if (this.multiple) {
          value = Array.from(target.selectedOptions).map(function (o) {
            return o.value;
          });
        } else {
          value = target.value;
        }

        this.localValue = value;
      },
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
      },
      blur: function blur() {
        this.$refs.select.blur();
      },
      focus: function focus(options) {
        this.$refs.select.focus(options);
      }
    }
  });
  var TButton = HtmlInput.extend({
    name: 'TButton',
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      text: {
        type: String,
        default: undefined
      },
      tagName: {
        type: String,
        default: 'button',
        validator: function validator(value) {
          return ['button', 'a'].indexOf(value) !== -1;
        }
      },
      type: {
        type: String,
        default: undefined
      },
      href: {
        type: String,
        default: null
      },
      to: {
        type: [String, Object],
        default: undefined
      },
      append: {
        type: Boolean,
        default: false
      },
      activeClass: {
        type: String,
        default: 'router-link-active'
      },
      exact: {
        type: Boolean,
        default: false
      },
      exactActiveClass: {
        type: String,
        default: 'router-link-exact-active'
      },
      event: {
        type: [String, Array],
        default: 'click'
      },
      data: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      method: {
        type: String,
        default: 'get'
      },
      replace: {
        type: Boolean,
        default: false
      },
      preserveScroll: {
        type: Boolean,
        default: false
      },
      preserveState: {
        type: Boolean,
        default: false
      },
      only: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      native: {
        type: Boolean,
        default: false
      },
      classes: {
        type: [String, Array, Object],
        default: 'block px-4 py-2 text-white transition duration-100 ease-in-out bg-blue-500 border border-transparent rounded shadow-sm hover:bg-blue-600 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50  disabled:opacity-50 disabled:cursor-not-allowed'
      }
    },
    computed: {
      isInertiaLinkComponentAvailable: function isInertiaLinkComponentAvailable() {
        return !!(this.$options.components && this.$options.components.InertiaLink);
      },
      isRouterLinkComponentAvailable: function isRouterLinkComponentAvailable() {
        return !!(this.$options.components && (this.$options.components.RouterLink || this.$options.components.NuxtLink));
      },

      /**
       * If we have the `to` defined and the routerLink or Nuxt link component is
       * available we can use it to create a router link
       *
       * @return {Boolean}
       */
      isARouterLink: function isARouterLink() {
        return this.to !== undefined && this.isRouterLinkComponentAvailable && !this.native;
      },

      /**
       * If we have the `href` defined and the InertiaLink component is available
       * we can use it to create an inertia link
       *
       * @return {Boolean}
       */
      isAnIntertiaLink: function isAnIntertiaLink() {
        return this.href !== null && this.tagName === 'a' && this.isInertiaLinkComponentAvailable && !this.native;
      },

      /**
       * The component to render according to the props
       * @return {String}
       */
      componentToRender: function componentToRender() {
        var _a;

        if (this.isARouterLink && this.$options.components) {
          return this.$options.components.NuxtLink || this.$options.components.RouterLink;
        }

        if (this.isAnIntertiaLink) {
          return (_a = this.$options.components) === null || _a === void 0 ? void 0 : _a.InertiaLink;
        }

        if (this.href) {
          return 'a';
        }

        return this.tagName;
      }
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    methods: {
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
      },
      clickHandler: function clickHandler(e) {
        this.$emit('click', e);
      },
      keydownHandler: function keydownHandler(e) {
        this.$emit('keydown', e);
      },
      mousedownHandler: function mousedownHandler(e) {
        this.$emit('mousedown', e);
      },
      blur: function blur() {
        this.$el.blur();
      },
      focus: function focus() {
        this.$el.focus();
      },
      inertiaLinkAttributes: function inertiaLinkAttributes() {
        return {
          data: this.data,
          href: this.href,
          method: this.method,
          replace: this.replace,
          preserveScroll: this.preserveScroll,
          preserveState: this.preserveState,
          only: this.only,
          id: this.id,
          value: this.value,
          autofocus: this.autofocus,
          disabled: this.disabled,
          name: this.name,
          type: this.type
        };
      },
      routerLinkAttributes: function routerLinkAttributes() {
        return {
          to: this.to,
          replace: this.replace,
          append: this.append,
          tag: this.tagName,
          activeClass: this.activeClass,
          exact: this.exact,
          event: this.event,
          exactActiveClass: this.exactActiveClass,
          id: this.id,
          value: this.value,
          autofocus: this.autofocus,
          disabled: this.disabled,
          name: this.name,
          type: this.type
        };
      },

      /**
       * Attrs according to the button type
       * @return {Object}
       */
      getAttributes: function getAttributes() {
        if (this.isAnIntertiaLink) {
          return this.inertiaLinkAttributes();
        }

        if (this.isARouterLink) {
          return this.routerLinkAttributes();
        }

        return {
          id: this.id,
          value: this.value,
          autofocus: this.autofocus,
          disabled: this.disabled,
          name: this.name,
          href: this.href,
          type: this.type
        };
      },
      render: function render(createElement) {
        return createElement(this.componentToRender, {
          attrs: this.getAttributes(),
          class: this.componentClass,
          on: this.getListeners({
            click: this.clickHandler,
            focus: this.focusHandler,
            blur: this.blurHandler,
            keydown: this.keydownHandler,
            mousedown: this.mousedownHandler
          })
        }, this.text === undefined ? this.$slots.default : this.text);
      }
    }
  });

  var TRichSelectRenderer = /*#__PURE__*/function () {
    function TRichSelectRenderer(createElement, component) {
      _classCallCheck(this, TRichSelectRenderer);

      this.createElement = createElement;
      this.component = component;
    }

    _createClass(TRichSelectRenderer, [{
      key: "render",
      value: function render() {
        return this.createWrapper();
      }
      /**
       * Div that wraps the whole component
       */

    }, {
      key: "createWrapper",
      value: function createWrapper() {
        return this.createElement('div', {
          ref: 'wrapper',
          class: this.component.getElementCssClass('wrapper')
        }, [this.createSelectButtonWrapper(), this.createDropdown()]);
      }
      /**
       * Div that wraps the button that is used as a select box
       */

    }, {
      key: "createSelectButtonWrapper",
      value: function createSelectButtonWrapper() {
        var subElements = [this.createSelectButton()];
        var hasSelectedOption = this.component.multiple ? this.component.selectedOptions.filter(function (o) {
          return !o.disabled;
        }).length > 0 : !!(this.component.selectedOption && !this.component.selectedOption.disabled);

        if (this.component.clearable && hasSelectedOption && !this.component.disabled) {
          subElements.push(this.createSelectButtonClearButton());
        }

        return this.createElement('div', {
          ref: 'buttonWrapper',
          class: this.component.getElementCssClass('buttonWrapper')
        }, subElements);
      }
      /**
       * The button that is used a select box
       */

    }, {
      key: "createSelectButton",
      value: function createSelectButton() {
        var _this8 = this;

        var subElements = [];

        if (this.component.multiple && this.component.selectedOptions.length) {
          if (this.component.$scopedSlots.label) {
            subElements.push(this.component.$scopedSlots.label({
              query: this.component.query,
              options: this.component.selectedOptions,
              className: this.component.getElementCssClass('selectButtonLabel')
            }));
          } else {
            subElements.push(this.createSelectButtonLabel());
          }
        } else if (!this.component.multiple && this.component.selectedOption) {
          if (this.component.$scopedSlots.label) {
            subElements.push(this.component.$scopedSlots.label({
              query: this.component.query,
              option: this.component.selectedOption,
              className: this.component.getElementCssClass('selectButtonLabel')
            }));
          } else {
            subElements.push(this.createSelectButtonLabel());
          }
        } else {
          subElements.push(this.createSelectButtonPlaceholder());
        }

        var hasSelectedOption = this.component.multiple ? this.component.selectedOptions.length > 0 : !!this.component.selectedOption;

        if (!(this.component.clearable && hasSelectedOption) && !this.component.disabled) {
          subElements.push.apply(subElements, _toConsumableArray(this.createSelectButtonIcon()));
        }

        if (this.component.multiple) {
          var hiddenInputs = this.component.selectedOptions.map(function (option) {
            return _this8.createElement('input', {
              attrs: {
                type: 'hidden',
                value: option.value,
                name: _this8.component.name
              }
            });
          });
          return this.createElement('div', {
            ref: 'tagsContainer',
            attrs: {
              tabindex: this.component.tabindex || 0
            },
            class: this.component.getElementCssClass('selectButton'),
            on: {
              click: this.component.clickHandler,
              focus: this.component.focusHandler,
              keydown: function keydown(e) {
                if (e.keyCode === Key$1.DOWN) {
                  _this8.component.arrowDownHandler(e);
                } else if (e.keyCode === Key$1.UP) {
                  _this8.component.arrowUpHandler(e);
                } else if (e.keyCode === Key$1.ENTER) {
                  _this8.component.enterHandler(e);
                } else if (e.keyCode === Key$1.ESC) {
                  _this8.component.escapeHandler(e);
                }
              },
              blur: this.component.blurHandler,
              mousedown: function mousedown(e) {
                e.preventDefault();
              }
            }
          }, subElements.concat(hiddenInputs));
        }

        return this.createElement('button', {
          ref: 'selectButton',
          attrs: {
            type: 'button',
            value: this.component.localValue,
            id: this.component.id,
            autofocus: this.component.autofocus,
            disabled: this.component.disabled,
            name: this.component.name
          },
          class: this.component.getElementCssClass('selectButton'),
          on: {
            click: this.component.clickHandler,
            focus: this.component.focusHandler,
            keydown: function keydown(e) {
              if (e.keyCode === Key$1.DOWN) {
                _this8.component.arrowDownHandler(e);
              } else if (e.keyCode === Key$1.UP) {
                _this8.component.arrowUpHandler(e);
              } else if (e.keyCode === Key$1.ENTER) {
                _this8.component.enterHandler(e);
              } else if (e.keyCode === Key$1.ESC) {
                _this8.component.escapeHandler(e);
              }
            },
            blur: this.component.blurHandler,
            mousedown: function mousedown(e) {
              e.preventDefault();
            }
          }
        }, subElements);
      }
    }, {
      key: "createSelectButtonLabel",
      value: function createSelectButtonLabel() {
        var _this9 = this;

        if (this.component.multiple) {
          return this.createElement('div', {
            class: this.component.getElementCssClass('selectButtonTagWrapper')
          }, this.component.selectedOptions.map(function (selectedOption, index) {
            return _this9.createElement('button', {
              class: _this9.component.getElementCssClass('selectButtonTag'),
              attrs: {
                tabindex: _this9.component.tagsAreFocusable && !selectedOption.disabled ? '0' : '-1',
                type: 'button',
                disabled: selectedOption.disabled ? true : undefined
              },
              on: {
                click: function click(e) {
                  e.stopPropagation();

                  if (selectedOption.disabled) {
                    return;
                  }

                  _this9.component.selectTag(e.currentTarget);
                },
                blur: function blur(e) {
                  _this9.component.unselectTag(e.currentTarget);
                },
                focus: function focus(e) {
                  _this9.component.selectTag(e.currentTarget);
                },
                keydown: function keydown(e) {
                  if (e.keyCode === Key$1.BACKSPACE) {
                    _this9.component.unselectOptionAtIndex(index);
                  }
                }
              }
            }, [_this9.createElement('span', {
              class: _this9.component.getElementCssClass('selectButtonTagText')
            }, selectedOption ? selectedOption.text : ''), [selectedOption.disabled ? null : _this9.createElement('span', {
              class: _this9.component.getElementCssClass('selectButtonTagDeleteButton'),
              attrs: {
                tabindex: -1
              },
              on: {
                click: function click(e) {
                  e.stopPropagation();

                  _this9.component.unselectOptionAtIndex(index);
                }
              }
            }, [_this9.createElement('svg', {
              class: _this9.component.getElementCssClass('selectButtonTagDeleteButtonIcon'),
              attrs: {
                fill: 'currentColor',
                viewBox: '0 0 20 20',
                xmlns: 'http://www.w3.org/2000/svg'
              }
            }, [_this9.createElement('path', {
              attrs: {
                'fill-rule': 'evenodd',
                evenodd: 'evenodd',
                d: 'M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
              }
            })])])]]);
          }));
        }

        return this.createElement('span', {
          ref: 'selectButtonLabel',
          class: this.component.getElementCssClass('selectButtonLabel')
        }, this.component.selectedOption ? this.component.selectedOption.text : '');
      }
    }, {
      key: "createSelectButtonPlaceholder",
      value: function createSelectButtonPlaceholder() {
        var domProps = {};

        if (!this.component.placeholder) {
          domProps.innerHTML = '&nbsp;';
        }

        return this.createElement('span', {
          ref: 'selectButtonPlaceholder',
          class: this.component.getElementCssClass('selectButtonPlaceholder'),
          domProps: domProps
        }, this.component.placeholder || undefined);
      }
    }, {
      key: "createSelectButtonIcon",
      value: function createSelectButtonIcon() {
        if (this.component.$scopedSlots.arrow) {
          return this.component.$scopedSlots.arrow({
            className: this.component.getElementCssClass('selectButtonIcon'),
            variant: this.component.variant,
            value: this.component.localValue
          });
        }

        return [this.createElement('svg', {
          ref: 'selectButtonIcon',
          attrs: {
            fill: 'currentColor',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20'
          },
          class: this.component.getElementCssClass('selectButtonIcon')
        }, [this.createElement('path', {
          attrs: {
            'clip-rule': 'evenodd',
            'fill-rule': 'evenodd',
            d: 'M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z'
          }
        })])];
      }
    }, {
      key: "createSelectButtonClearButton",
      value: function createSelectButtonClearButton() {
        return this.createElement('button', {
          ref: 'selectButtonClearButton',
          class: this.component.getElementCssClass('selectButtonClearButton'),
          attrs: {
            type: 'button',
            tabindex: -1
          },
          on: {
            click: this.component.clearButtonClickHandler
          }
        }, [this.createElement('svg', {
          attrs: {
            fill: 'currentColor',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20'
          },
          class: this.component.getElementCssClass('selectButtonClearIcon')
        }, [this.createElement('polygon', {
          attrs: {
            points: '10 8.58578644 2.92893219 1.51471863 1.51471863 2.92893219 8.58578644 10 1.51471863 17.0710678 2.92893219 18.4852814 10 11.4142136 17.0710678 18.4852814 18.4852814 17.0710678 11.4142136 10 18.4852814 2.92893219 17.0710678 1.51471863 10 8.58578644'
          }
        })])]);
      }
      /**
       * Div that wraps the search box
       */

    }, {
      key: "createSearchBoxWrapper",
      value: function createSearchBoxWrapper() {
        return this.createElement('div', {
          ref: 'searchWrapper',
          class: this.component.getElementCssClass('searchWrapper')
        }, [this.createSearchBox()]);
      }
      /**
       * Filter search box
       */

    }, {
      key: "createSearchBox",
      value: function createSearchBox() {
        var _this10 = this;

        return this.createElement('input', {
          ref: 'searchBox',
          class: this.component.getElementCssClass('searchBox'),
          domProps: {
            value: this.component.query
          },
          attrs: {
            placeholder: this.component.searchBoxPlaceholder
          },
          on: {
            keydown: function keydown(e) {
              if (e.keyCode === Key$1.DOWN) {
                _this10.component.arrowDownHandler(e);
              } else if (e.keyCode === Key$1.UP) {
                _this10.component.arrowUpHandler(e);
              } else if (e.keyCode === Key$1.ENTER) {
                _this10.component.enterHandler(e);
              } else if (e.keyCode === Key$1.ESC) {
                _this10.component.escapeHandler(e);
              }
            },
            blur: this.component.blurHandler,
            input: this.component.searchInputHandler
          }
        });
      }
    }, {
      key: "getMinimumInputLengthText",
      value: function getMinimumInputLengthText() {
        if (typeof this.component.minimumInputLengthText === 'function') {
          return this.component.minimumInputLengthText(this.component.minimumInputLength, this.component.query);
        }

        return this.component.minimumInputLengthText;
      }
      /**
       * The div used as dropdown with the options and the search box
       */

    }, {
      key: "createDropdown",
      value: function createDropdown() {
        var subElements = [];

        if (this.component.shouldShowSearchbox) {
          subElements.push(this.createSearchBoxWrapper());
        }

        if (this.component.$scopedSlots.dropdownUp) {
          subElements.push(this.component.$scopedSlots.dropdownUp({
            query: this.component.query,
            selectedOption: this.component.selectedOption,
            options: this.component.filteredOptions
          }));
        }

        if (this.component.searching && !this.component.nextPage) {
          if (this.component.$scopedSlots.searchingText) {
            subElements.push(this.component.$scopedSlots.searchingText({
              text: this.component.searchingText,
              query: this.component.query,
              className: this.component.getElementCssClass('dropdownFeedback')
            }));
          } else {
            subElements.push(this.createDropdownFeedback(this.component.searchingText));
          }
        } else if (this.component.minimumInputLength !== undefined && this.component.query.length < this.component.minimumInputLength) {
          var minInputLengthText = this.getMinimumInputLengthText();
          subElements.push(this.createDropdownFeedback(minInputLengthText));
        } else if (!this.component.filteredOptions.length) {
          if (this.component.$scopedSlots.noResults) {
            subElements.push(this.component.$scopedSlots.noResults({
              text: this.component.noResultsText,
              query: this.component.query,
              className: this.component.getElementCssClass('dropdownFeedback')
            }));
          } else {
            subElements.push(this.createDropdownFeedback(this.component.noResultsText));
          }
        }

        if (this.component.filteredOptions.length) {
          subElements.push(this.createOptionsList(this.component.filteredOptions));
        }

        if (this.component.searching && this.component.nextPage) {
          if (this.component.$scopedSlots.loadingMoreResultsText) {
            subElements.push(this.component.$scopedSlots.loadingMoreResultsText({
              text: this.component.loadingMoreResultsText,
              nextPage: this.component.nextPage,
              query: this.component.query,
              className: this.component.getElementCssClass('loadingMoreResults')
            }));
          } else {
            subElements.push(this.createLoadingMoreResults(this.component.loadingMoreResultsText));
          }
        }

        if (this.component.$scopedSlots.dropdownDown) {
          subElements.push(this.component.$scopedSlots.dropdownDown({
            query: this.component.query,
            selectedOption: this.component.selectedOption,
            options: this.component.filteredOptions
          }));
        }

        return this.createElement('transition', {
          props: {
            enterClass: this.component.getElementCssClass('enterClass'),
            enterActiveClass: this.component.getElementCssClass('enterActiveClass'),
            enterToClass: this.component.getElementCssClass('enterToClass'),
            leaveClass: this.component.getElementCssClass('leaveClass'),
            leaveActiveClass: this.component.getElementCssClass('leaveActiveClass'),
            leaveToClass: this.component.getElementCssClass('leaveToClass')
          }
        }, this.component.show ? [this.createElement('div', {
          ref: 'dropdown',
          class: this.component.getElementCssClass('dropdown')
        }, subElements)] : undefined);
      }
      /**
       * Options list wrapper
       */

    }, {
      key: "createOptionsList",
      value: function createOptionsList(options) {
        return this.createElement('ul', {
          ref: 'optionsList',
          class: this.component.getElementCssClass('optionsList'),
          style: {
            maxHeight: this.component.normalizedHeight
          },
          on: {
            scroll: this.component.listScrollHandler
          }
        }, this.createOptions(options));
      }
      /**
       * Dropdown feedback
       * @param text
       */

    }, {
      key: "createDropdownFeedback",
      value: function createDropdownFeedback(text) {
        return this.createElement('div', {
          ref: 'dropdownFeedback',
          class: this.component.getElementCssClass('dropdownFeedback')
        }, text);
      }
      /**
       * Dropdown feedback
       * @param text
       */

    }, {
      key: "createLoadingMoreResults",
      value: function createLoadingMoreResults(text) {
        return this.createElement('div', {
          ref: 'loadingMoreResults',
          class: this.component.getElementCssClass('loadingMoreResults')
        }, text);
      }
      /**
       * List of options
       */

    }, {
      key: "createOptions",
      value: function createOptions(options) {
        var _this11 = this;

        var index = -1;
        return options.map(function (option) {
          if (option.children) {
            return [option].concat(_toConsumableArray(option.children));
          }

          return option;
        }).flat().map(function (option) {
          if (option.children) {
            return _this11.createOptgroup(option);
          }

          index += 1;
          return _this11.createOption(option, index);
        });
      }
      /**
       * Creates an optgroup element
       * @param option
       * @param index
       */

    }, {
      key: "createOptgroup",
      value: function createOptgroup(optgroup) {
        return this.createElement('li', {
          attrs: {
            'data-type': 'optgroup'
          },
          class: this.component.getElementCssClass('optgroup')
        }, guessOptionText(optgroup, this.component.textAttribute));
      }
      /**
       * Builds an option element
       * @param option
       * @param index
       */

    }, {
      key: "createOption",
      value: function createOption(option, index) {
        var _this12 = this;

        var isSelected = this.component.optionHasValue(option, this.component.localValue);
        var isHighlighted = this.component.highlighted === index;
        var className;

        if (option.disabled) {
          className = this.component.getElementCssClass('disabledOption');
        } else if (isHighlighted && isSelected) {
          className = this.component.getElementCssClass('selectedHighlightedOption');
        } else if (isHighlighted) {
          className = this.component.getElementCssClass('highlightedOption');
        } else if (isSelected) {
          className = this.component.getElementCssClass('selectedOption');
        } else {
          className = this.component.getElementCssClass('option');
        }

        var subElements = [];

        if (this.component.$scopedSlots.option) {
          subElements.push(this.component.$scopedSlots.option({
            index: index,
            isHighlighted: isHighlighted,
            isSelected: isSelected,
            option: option,
            query: this.component.query,
            className: this.component.getElementCssClass('optionContent')
          }));
        } else {
          subElements.push(this.createOptionContent(option, isSelected));
        }

        return this.createElement('li', {
          ref: 'option',
          class: className,
          attrs: {
            'data-type': 'option'
          },
          on: {
            mouseover: function mouseover() {
              _this12.component.highlighted = index;
            },
            mouseleave: function mouseleave() {
              _this12.component.highlighted = null;
            },
            mousedown: function mousedown(e) {
              e.preventDefault();
            },
            click: function click(e) {
              e.preventDefault();

              if (option.disabled) {
                return;
              }

              _this12.component.selectOption(option);
            }
          }
        }, subElements);
      }
    }, {
      key: "createOptionContent",
      value: function createOptionContent(option, isSelected) {
        var subElements = [this.createOptionLabel(option)];

        if (isSelected) {
          subElements.push(this.createOptionSelectedIcon());
        }

        return this.createElement('div', {
          ref: 'optionContent',
          class: this.component.getElementCssClass('optionContent')
        }, subElements);
      }
    }, {
      key: "createOptionLabel",
      value: function createOptionLabel(option) {
        return this.createElement('span', {
          ref: 'optionLabel',
          class: this.component.getElementCssClass('optionLabel')
        }, option.text);
      }
    }, {
      key: "createOptionSelectedIcon",
      value: function createOptionSelectedIcon() {
        return this.createElement('svg', {
          ref: 'selectedIcon',
          attrs: {
            fill: 'currentColor',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20'
          },
          class: this.component.getElementCssClass('selectedIcon')
        }, [this.createElement('polygon', {
          attrs: {
            points: '0 11 2 9 7 14 18 3 20 5 7 18'
          }
        })]);
      }
    }]);

    return TRichSelectRenderer;
  }();

  var TRichSelect = MultipleInput.extend({
    name: 'TRichSelect',
    render: function render(createElement) {
      var createSelectFunc = this.createSelect;
      return createSelectFunc(createElement);
    },
    props: {
      delay: {
        type: Number,
        default: 250
      },
      fetchOptions: {
        type: Function,
        default: undefined
      },
      minimumResultsForSearch: {
        type: Number,
        default: undefined
      },
      minimumInputLength: {
        type: Number,
        default: undefined
      },
      minimumInputLengthText: {
        type: [Function, String],
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        default: function _default(minimumInputLength, _query) {
          return "Please enter ".concat(minimumInputLength, " or more characters");
        }
      },
      hideSearchBox: {
        type: Boolean,
        default: false
      },
      openOnFocus: {
        type: Boolean,
        default: true
      },
      closeOnSelect: {
        type: Boolean,
        default: true
      },
      selectOnClose: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: undefined
      },
      searchBoxPlaceholder: {
        type: String,
        default: 'Search...'
      },
      noResultsText: {
        type: String,
        default: 'No results found'
      },
      searchingText: {
        type: String,
        default: 'Searching...'
      },
      loadingMoreResultsText: {
        type: String,
        default: 'Loading more results...'
      },
      maxHeight: {
        type: [String, Number],
        default: 300
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {
            wrapper: 'relative',
            buttonWrapper: 'inline-block relative w-full',
            selectButton: 'w-full flex text-left justify-between items-center',
            selectButtonLabel: 'block truncate',
            selectButtonTagWrapper: 'flex flex-wrap overflow-hidden',
            selectButtonTag: 'bg-blue-500 block disabled:cursor-not-allowed disabled:opacity-50 duration-100 ease-in-out focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded shadow-sm text-sm text-white transition whitespace-nowrap m-0.5 max-w-full overflow-hidden h-8 flex items-center',
            selectButtonTagText: 'px-3',
            selectButtonTagDeleteButton: '-ml-1.5 h-full hover:bg-blue-600 hover:shadow-sm inline-flex items-center px-2 transition',
            selectButtonTagDeleteButtonIcon: 'w-3 h-3',
            selectButtonPlaceholder: 'block truncate',
            selectButtonIcon: 'fill-current flex-shrink-0 ml-1 h-4 w-4',
            selectButtonClearButton: 'flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6',
            selectButtonClearIcon: 'fill-current h-3 w-3',
            dropdown: 'absolute w-full z-10',
            dropdownFeedback: '',
            loadingMoreResults: '',
            optionsList: 'overflow-auto',
            searchWrapper: 'inline-block w-full',
            searchBox: 'inline-block w-full',
            optgroup: '',
            option: 'cursor-pointer',
            disabledOption: 'opacity-50 cursor-not-allowed',
            highlightedOption: 'cursor-pointer',
            selectedOption: 'cursor-pointer',
            selectedHighlightedOption: 'cursor-pointer',
            optionContent: '',
            optionLabel: 'truncate block',
            selectedIcon: 'fill-current h-4 w-4',
            enterClass: '',
            enterActiveClass: '',
            enterToClass: '',
            leaveClass: '',
            leaveActiveClass: '',
            leaveToClass: ''
          };
        }
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            wrapper: '',
            buttonWrapper: '',
            selectButton: 'px-3 py-2 text-black transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
            selectButtonLabel: '',
            selectButtonTagWrapper: '-mx-2 -my-2.5 py-1 pr-8',
            selectButtonTag: 'bg-blue-500 block disabled:cursor-not-allowed disabled:opacity-50 duration-100 ease-in-out focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded shadow-sm text-sm text-white transition whitespace-nowrap m-0.5 max-w-full overflow-hidden h-8 flex items-center',
            selectButtonTagText: 'px-3',
            selectButtonTagDeleteButton: '-ml-1.5 h-full hover:bg-blue-600 hover:shadow-sm inline-flex items-center px-2 transition',
            selectButtonTagDeleteButtonIcon: '',
            selectButtonPlaceholder: 'text-gray-400',
            selectButtonIcon: 'text-gray-600',
            selectButtonClearButton: 'hover:bg-blue-100 text-gray-600 rounded transition duration-100 ease-in-out',
            selectButtonClearIcon: '',
            dropdown: '-mt-1 bg-white border-b border-gray-300 border-l border-r rounded-b shadow-sm',
            dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
            loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
            optionsList: '',
            searchWrapper: 'p-2 placeholder-gray-400',
            searchBox: 'px-3 py-2 bg-gray-50 text-sm rounded border focus:outline-none focus:shadow-outline border-gray-300',
            optgroup: 'text-gray-400 uppercase text-xs py-1 px-2 font-semibold',
            option: '',
            disabledOption: '',
            highlightedOption: 'bg-blue-100',
            selectedOption: 'font-semibold bg-gray-100 bg-blue-500 font-semibold text-white',
            selectedHighlightedOption: 'font-semibold bg-gray-100 bg-blue-600 font-semibold text-white',
            optionContent: 'flex justify-between items-center px-3 py-2',
            optionLabel: '',
            selectedIcon: '',
            enterClass: 'opacity-0',
            enterActiveClass: 'transition ease-out duration-100',
            enterToClass: 'opacity-100',
            leaveClass: 'opacity-100',
            leaveActiveClass: 'transition ease-in duration-75',
            leaveToClass: 'opacity-0'
          };
        }
      }
    },
    data: function data() {
      return {
        hasFocus: false,
        show: false,
        localValue: this.value,
        highlighted: null,
        query: '',
        filteredOptions: [],
        selectedOption: undefined,
        selectedOptions: [],
        searching: false,
        delayTimeout: undefined,
        nextPage: undefined,
        tagsAreFocusable: false
      };
    },
    created: function created() {
      var _this13 = this;

      if (Array.isArray(this.value)) {
        this.selectedOptions = this.value.map(function (value) {
          return _this13.findOptionByValue(value);
        }).filter(function (option) {
          return !!option;
        });
      } else if (!this.selectedOption || this.selectedOption.value !== this.value) {
        this.selectedOption = this.findOptionByValue(this.value);
      }
    },
    updated: function updated() {
      if (typeof this.selectedOption === 'undefined' || !Array.isArray(this.value) && this.selectedOption.value !== this.value && this.value !== null) {
        this.selectedOption = this.findOptionByValue(this.value);
      }
    },
    watch: {
      normalizedOptions: {
        handler: function handler() {
          this.query = '';
          this.filterOptions('');
        },
        immediate: true
      },
      query: function query(_query2) {
        this.nextPage = undefined;
        this.filterOptions(_query2);
      },
      localValue: function localValue(_localValue4) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var _this14 = this;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (Array.isArray(_localValue4)) {
                    this.selectedOptions = _localValue4.map(function (value) {
                      return _this14.findOptionByValue(value);
                    }).filter(function (option) {
                      return !!option;
                    });
                  } else if (!this.selectedOption || this.selectedOption.value !== _localValue4) {
                    this.selectedOption = this.findOptionByValue(_localValue4);
                  }

                  this.$emit('input', _localValue4);
                  _context3.next = 4;
                  return this.$nextTick();

                case 4:
                  this.$emit('change', _localValue4);

                  if (this.closeOnSelect) {
                    this.hideOptions();
                  }

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
      },
      value: function value(_value3) {
        this.localValue = _value3;
      },
      highlighted: function highlighted(_highlighted) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(_highlighted === null)) {
                    _context4.next = 2;
                    break;
                  }

                  return _context4.abrupt("return");

                case 2:
                  _context4.next = 4;
                  return this.$nextTick();

                case 4:
                  this.scrollToHighlightedOption();

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
      },
      show: function show(_show) {
        if (_show) {
          if (this.shouldShowSearchbox) {
            this.focusSearchBox();
          }

          if (!this.atLeastOneValidOptionExists) {
            this.highlighted = null;
            return;
          }

          this.highlighted = this.selectedOptionIndex !== undefined ? this.selectedOptionIndex : this.findNextOptionIndex();
        }
      },
      shouldShowSearchbox: function shouldShowSearchbox(_shouldShowSearchbox) {
        if (_shouldShowSearchbox && this.show) {
          this.focusSearchBox();
        }
      }
    },
    computed: {
      usesAjax: function usesAjax() {
        return !!this.fetchOptions;
      },
      shouldShowSearchbox: function shouldShowSearchbox() {
        var showSearchbox = !this.hideSearchBox;
        var hasQuery = !!this.query;
        var hasMinResultsSetting = typeof this.minimumResultsForSearch === 'undefined';
        var hasminimumResultsForSearch = hasMinResultsSetting || hasQuery || (this.usesAjax ? this.filteredflattenedOptions.length >= this.minimumResultsForSearch : this.normalizedOptions.length >= this.minimumResultsForSearch);
        return showSearchbox && hasminimumResultsForSearch;
      },
      hasMinimumInputLength: function hasMinimumInputLength() {
        return this.minimumInputLength === undefined || this.query.length >= this.minimumInputLength;
      },
      flattenedOptions: function flattenedOptions() {
        return this.normalizedOptions.map(function (option) {
          if (option.children) {
            return option.children;
          }

          return option;
        }).flat();
      },
      filteredflattenedOptions: function filteredflattenedOptions() {
        return this.filteredOptions.map(function (option) {
          if (option.children) {
            return option.children;
          }

          return option;
        }).flat();
      },
      atLeastOneValidOptionExists: function atLeastOneValidOptionExists() {
        return this.filteredflattenedOptions.some(function (option) {
          return !option.disabled;
        });
      },
      normalizedHeight: function normalizedHeight() {
        if (/^\d+$/.test(String(this.maxHeight))) {
          return "".concat(this.maxHeight, "px");
        }

        return String(this.maxHeight);
      },
      selectedOptionIndex: function selectedOptionIndex() {
        var _this15 = this;

        var selectedOption;

        if (this.multiple) {
          selectedOption = this.selectedOptions.length >= 1 ? this.selectedOptions[this.selectedOptions.length - 1] : undefined;
        } else {
          selectedOption = this.selectedOption;
        }

        if (!selectedOption) {
          return undefined;
        }

        var index = this.filteredflattenedOptions.findIndex(function (option) {
          return _this15.optionHasValue(option, selectedOption.value);
        });
        return index >= 0 ? index : undefined;
      },
      highlightedOption: function highlightedOption() {
        if (typeof this.highlighted === 'number') {
          return this.filteredflattenedOptions[this.highlighted];
        }

        return undefined;
      }
    },
    methods: {
      // eslint-disable-next-line max-len
      findOptionByValue: function findOptionByValue(value) {
        var _this16 = this;

        if (this.usesAjax) {
          // When using ajax results the filtered options are that ones that were
          // fetched with the `fetchOptions` method. Since those can change, we
          // also need to check the `selectedOptions` array that contains the
          // already selected ones.
          return [].concat(_toConsumableArray(this.filteredflattenedOptions), _toConsumableArray(this.selectedOptions)).find(function (option) {
            return _this16.optionHasValue(option, value);
          });
        }

        return this.flattenedOptions.find(function (option) {
          return _this16.optionHasValue(option, value);
        });
      },
      // eslint-disable-next-line max-len
      optionHasValue: function optionHasValue(option, value) {
        return Array.isArray(value) ? value.includes(option.value) : value === option.value;
      },
      createSelect: function createSelect(createElement) {
        return new TRichSelectRenderer(createElement, this).render();
      },
      filterOptions: function filterOptions(query) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var _this17 = this;

          var options;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (this.hasMinimumInputLength) {
                    _context6.next = 3;
                    break;
                  }

                  this.filteredOptions = [];
                  return _context6.abrupt("return");

                case 3:
                  if (this.fetchOptions) {
                    _context6.next = 8;
                    break;
                  }

                  options = cloneDeep__default['default'](this.normalizedOptions);
                  this.filteredOptions = this.queryFilter(options);

                  if (this.filteredOptions.length) {
                    this.highlighted = 0;
                  } else {
                    this.highlighted = null;
                  }

                  return _context6.abrupt("return");

                case 8:
                  this.searching = true;

                  if (this.delayTimeout) {
                    clearTimeout(this.delayTimeout);
                  }

                  this.delayTimeout = setTimeout(function () {
                    return __awaiter(_this17, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                      var _yield$this$getFilter, results, hasMorePages, currentOptionsListLength;

                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              _context5.prev = 0;
                              _context5.next = 3;
                              return this.getFilterPromise(query);

                            case 3:
                              _yield$this$getFilter = _context5.sent;
                              results = _yield$this$getFilter.results;
                              hasMorePages = _yield$this$getFilter.hasMorePages;

                              if (this.nextPage) {
                                currentOptionsListLength = this.filteredOptions.length;
                                this.filteredOptions = this.filteredOptions.concat(this.normalizeOptions(results)); // Ux: When the last item is highlighted highlight the next one, make
                                // special sense when using keyboard

                                if (this.highlighted === currentOptionsListLength - 1) {
                                  this.highlighted = currentOptionsListLength;
                                }
                              } else {
                                this.filteredOptions = this.normalizeOptions(results);

                                if (this.filteredOptions.length) {
                                  this.highlighted = 0;
                                } else {
                                  this.highlighted = null;
                                }
                              }

                              if (hasMorePages) {
                                this.nextPage = this.nextPage === undefined ? 2 : this.nextPage + 1;
                              } else {
                                this.nextPage = undefined;
                              }

                              _context5.next = 14;
                              break;

                            case 10:
                              _context5.prev = 10;
                              _context5.t0 = _context5["catch"](0);
                              this.$emit('fetch-error', _context5.t0);
                              this.filteredOptions = [];

                            case 14:
                              this.searching = false;
                              this.delayTimeout = undefined;

                            case 16:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5, this, [[0, 10]]);
                    }));
                  }, this.delay);

                case 11:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
      },
      getFilterPromise: function getFilterPromise(query) {
        return Promise.resolve(this.fetchOptions(query, this.nextPage));
      },
      listEndReached: function listEndReached() {
        if (!this.nextPage || this.searching) {
          return;
        }

        this.filterOptions(this.query);
      },
      queryFilter: function queryFilter(options) {
        var _this18 = this;

        if (!this.query) {
          return options;
        }

        return options.map(function (option) {
          if (option.children) {
            var newOption = Object.assign(Object.assign({}, option), {
              children: _this18.queryFilter(option.children)
            });
            return newOption;
          }

          return option;
        }).filter(function (option) {
          var foundText = String(option.text).toUpperCase().trim().includes(_this18.query.toUpperCase().trim());
          var hasChildren = option.children && option.children.length > 0;
          return hasChildren || foundText;
        });
      },
      hideOptions: function hideOptions() {
        this.show = false;

        if (this.selectOnClose && this.highlightedOption) {
          this.selectOption(this.highlightedOption, false);
        }
      },
      showOptions: function showOptions() {
        this.show = true;
      },
      toggleOptions: function toggleOptions() {
        if (this.show) {
          this.hideOptions();
        } else {
          this.showOptions();
        }
      },
      focusSearchBox: function focusSearchBox() {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var searchBox;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this.$nextTick();

                case 2:
                  searchBox = this.getSearchBox();
                  searchBox.focus();
                  searchBox.select();

                case 5:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
      },
      blurHandler: function blurHandler(e) {
        var shouldHideOptions = true;
        var clickedElement = e.relatedTarget;

        if (clickedElement) {
          var wrapper = this.$refs.wrapper;
          var isChild = wrapper.contains(clickedElement);
          var clickedATag = false;

          if (this.multiple) {
            clickedATag = this.$refs.tagsContainer.contains(clickedElement);
          }

          if (isChild && !clickedATag) {
            shouldHideOptions = false;
          }
        }

        if (clickedElement !== this.$refs.selectButton && !shouldHideOptions && this.getSearchBox()) {
          this.focusSearchBox();
          return;
        }

        if (shouldHideOptions) {
          this.hideOptions();
        }

        this.$emit('blur', e);
        this.hasFocus = false;
      },
      focusHandler: function focusHandler(e) {
        this.hasFocus = true;

        if (this.openOnFocus) {
          this.showOptions();
        }

        this.$emit('focus', e);
      },
      clickHandler: function clickHandler(e) {
        if (!this.show && !this.hasFocus) {
          if (this.multiple) {
            this.getTagsContainer().focus();
          } else {
            this.getButton().focus();
          }

          if (!this.openOnFocus) {
            this.showOptions();
          }
        } else {
          this.toggleOptions();
        }

        this.$emit('click', e);
      },
      findNextOptionIndex: function findNextOptionIndex() {
        var currentOptionIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var endReached = currentOptionIndex !== null && currentOptionIndex + 1 >= this.filteredflattenedOptions.length;
        var nextOptionIndex;

        if (currentOptionIndex === null || endReached) {
          nextOptionIndex = 0;
        } else {
          nextOptionIndex = currentOptionIndex + 1;
        }

        var nextOption = this.filteredflattenedOptions[nextOptionIndex];

        if (!nextOption || nextOption.disabled) {
          return this.findNextOptionIndex(nextOptionIndex);
        }

        return nextOptionIndex;
      },
      findPrevOptionIndex: function findPrevOptionIndex(currentOptionIndex) {
        var beginningReached = currentOptionIndex === null || currentOptionIndex - 1 < 0;
        var prevOptionIndex;

        if (currentOptionIndex === null || beginningReached) {
          prevOptionIndex = this.filteredflattenedOptions.length - 1;
        } else {
          prevOptionIndex = currentOptionIndex - 1;
        }

        var prevOption = this.filteredflattenedOptions[prevOptionIndex];

        if (!prevOption || prevOption.disabled) {
          return this.findPrevOptionIndex(prevOptionIndex);
        }

        return prevOptionIndex;
      },
      arrowUpHandler: function arrowUpHandler(e) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  e.preventDefault();

                  if (this.show) {
                    _context8.next = 4;
                    break;
                  }

                  this.showOptions();
                  return _context8.abrupt("return");

                case 4:
                  if (this.atLeastOneValidOptionExists) {
                    _context8.next = 7;
                    break;
                  }

                  this.highlighted = null;
                  return _context8.abrupt("return");

                case 7:
                  this.highlighted = this.findPrevOptionIndex(this.highlighted);

                case 8:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
      },
      arrowDownHandler: function arrowDownHandler(e) {
        e.preventDefault();

        if (!this.show) {
          this.showOptions();
          return;
        }

        if (!this.atLeastOneValidOptionExists) {
          this.highlighted = null;
          return;
        }

        var nextOptionIndex = this.findNextOptionIndex(this.highlighted);
        var endReached = nextOptionIndex >= this.filteredflattenedOptions.length;

        if (endReached && this.usesAjax && this.nextPage) {
          this.listEndReached();
        } else {
          this.highlighted = nextOptionIndex;
        }
      },
      listScrollHandler: function listScrollHandler(e) {
        var el = e.target;

        if (el.scrollTop === el.scrollHeight - el.offsetHeight) {
          this.listEndReached();
        }
      },
      scrollToHighlightedOption: function scrollToHighlightedOption() {
        var behavior = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';

        if (this.$refs.optionsList && typeof this.highlighted === 'number') {
          var list = this.$refs.optionsList;
          var li = list.querySelectorAll('li[data-type=option]')[this.highlighted];

          if (li.scrollIntoView) {
            li.scrollIntoView({
              block: 'nearest',
              behavior: behavior
            });
          }
        }
      },
      escapeHandler: function escapeHandler(e) {
        e.preventDefault();
        this.hideOptions();
      },
      enterHandler: function enterHandler(e) {
        if (!this.show) {
          return;
        }

        if (this.highlighted !== null) {
          e.preventDefault();
          this.selectOption(this.highlightedOption);
        }
      },
      searchInputHandler: function searchInputHandler(e) {
        var target = e.target;
        this.query = target.value;
      },
      getButton: function getButton() {
        return this.$refs.selectButton;
      },
      getTagsContainer: function getTagsContainer() {
        return this.$refs.tagsContainer;
      },
      getSearchBox: function getSearchBox() {
        return this.$refs.searchBox;
      },
      selectOption: function selectOption(option) {
        var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
          var optionValue, valueIndex, selectedOptionIndex;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  optionValue = option.value;

                  if (this.multiple) {
                    if (Array.isArray(this.localValue)) {
                      valueIndex = this.localValue.findIndex(function (value) {
                        return isEqual__default['default'](value, optionValue);
                      });

                      if (valueIndex >= 0) {
                        this.localValue.splice(valueIndex, 1);
                        selectedOptionIndex = this.selectedOptions.findIndex(function (o) {
                          return o.value === optionValue;
                        });

                        if (selectedOptionIndex >= 0) {
                          this.unselectOptionAtIndex(selectedOptionIndex);
                          this.selectedOptions.splice(selectedOptionIndex, 1);
                        }
                      } else {
                        this.localValue.push(optionValue);
                        this.selectedOptions.push(option);
                      }
                    } else {
                      this.localValue = [optionValue];
                      this.selectedOptions.push(option);
                    }
                  } else {
                    if (this.localValue !== optionValue) {
                      this.localValue = optionValue;
                    }

                    this.selectedOption = option;
                  }

                  _context9.next = 4;
                  return this.$nextTick();

                case 4:
                  if (focus) {
                    if (!this.closeOnSelect && this.shouldShowSearchbox) {
                      this.getSearchBox().focus();
                    } else {
                      if (this.multiple) {
                        this.getTagsContainer().focus();
                      } else {
                        this.getButton().focus();
                      }

                      if (this.closeOnSelect && this.show) {
                        this.hideOptions();
                      }
                    }
                  }

                case 5:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));
      },
      unselectOptionAtIndex: function unselectOptionAtIndex(index) {
        var selectedOption = this.selectedOptions[index];
        var valueIndex = this.localValue.findIndex(function (value) {
          return isEqual__default['default'](value, selectedOption.value);
        });

        if (valueIndex >= 0) {
          this.localValue.splice(valueIndex, 1);
        }
      },
      clearButtonClickHandler: function clearButtonClickHandler(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.multiple) {
          this.localValue = this.selectedOptions.filter(function (o) {
            return !!o.disabled;
          }).map(function (o) {
            return o.value;
          });
        } else {
          this.localValue = null;
        }

        this.query = '';
      },
      blur: function blur() {
        var el = this.hideSearchBox ? this.$refs.selectButton : this.$refs.searchBox;
        el.blur();
      },
      focus: function focus(options) {
        var el = this.$refs.selectButton;
        el.focus(options);
      },
      selectTag: function selectTag(tag) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  this.tagsAreFocusable = true; // Wait until the tag has `tabindex`

                  _context10.next = 3;
                  return this.$nextTick();

                case 3:
                  tag.focus();

                case 4:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
      },
      unselectTag: function unselectTag() {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  this.tagsAreFocusable = false;

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));
      }
    }
  });
  var TInputGroup = Component.extend({
    name: 'TInputGroup',
    props: {
      inputName: {
        type: String,
        default: undefined
      },
      label: {
        type: String,
        default: undefined
      },
      description: {
        type: String,
        default: undefined
      },
      feedback: {
        type: String,
        default: undefined
      },
      sortedElements: {
        type: Array,
        default: function _default() {
          return ['label', 'default', 'feedback', 'description'];
        },
        validator: function validator(value) {
          var expectedValues = ['default', 'description', 'feedback', 'label'];
          return value.length === intersection__default['default'](value, expectedValues).length;
        }
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            wrapper: '',
            label: 'block',
            body: '',
            feedback: 'text-gray-400 text-sm',
            description: 'text-gray-400 text-sm'
          };
        }
      }
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    computed: {
      /**
       * Only render the elements that has a prop or a slot (always the default prop)
       * @return {Array}
       */
      elementsToRender: function elementsToRender() {
        var props = this.$props;
        var slots = this.$slots;
        return this.sortedElements.filter(function (e) {
          return e === 'default' || !!props[e] || !!slots[e];
        });
      }
    },
    methods: {
      render: function render(createElement) {
        var _this19 = this;

        return createElement('div', {
          ref: 'wrapper',
          class: this.getElementCssClass('wrapper')
        }, this.elementsToRender.map(function (elementName) {
          return createElement(_this19.getTagName(elementName), {
            ref: elementName,
            class: _this19.getElementCssClass(elementName === 'default' ? 'body' : elementName),
            attrs: {
              for: elementName === 'label' ? _this19.inputName : undefined
            },
            slot: elementName
          }, _this19.$slots[elementName] || _this19.$props[elementName]);
        }));
      },

      /**
       * Get the tag name according to the slot name
       * @param  {String} slotName
       * @return {String}
       */
      getTagName: function getTagName(slotName) {
        switch (slotName) {
          case 'label':
            return 'label';

          default:
            return 'div';
        }
      }
    }
  });
  var TCard = Component.extend({
    name: 'TCard',
    props: {
      tagName: {
        type: String,
        default: 'div'
      },
      header: {
        type: String,
        default: undefined
      },
      footer: {
        type: String,
        default: undefined
      },
      noBody: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            wrapper: 'border rounded shadow-sm bg-white border-gray-100',
            body: 'p-3',
            header: 'border-b border-gray-100 p-3 rounded-t',
            footer: 'border-gray-100 border-t p-3 rounded-b'
          };
        }
      }
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    methods: {
      render: function render(createElement) {
        return createElement(this.tagName, {
          class: this.getElementCssClass('wrapper')
        }, this.renderChilds(createElement));
      },
      renderChilds: function renderChilds(createElement) {
        if (this.noBody) {
          return this.$slots.default;
        }

        var childs = [];

        if (!!this.$slots.header || this.header !== undefined) {
          childs.push(createElement('div', {
            ref: 'header',
            class: this.getElementCssClass('header')
          }, this.$slots.header || this.header));
        }

        childs.push(createElement('div', {
          ref: 'body',
          class: this.getElementCssClass('body')
        }, this.$slots.default));

        if (!!this.$slots.footer || this.footer !== undefined) {
          childs.push(createElement('div', {
            ref: 'footer',
            class: this.getElementCssClass('footer')
          }, this.$slots.footer || this.footer));
        }

        return childs;
      }
    }
  });
  var TAlert = Component.extend({
    name: 'TAlert',
    props: {
      tagName: {
        type: String,
        default: 'div'
      },
      bodyTagName: {
        type: String,
        default: 'div'
      },
      dismissible: {
        type: Boolean,
        default: true
      },
      show: {
        type: Boolean,
        default: false
      },
      timeout: {
        type: Number,
        default: undefined
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            wrapper: 'relative flex items-center p-4 bg-blue-50 border-l-4 border-blue-500 rounded shadow-sm',
            body: 'flex-grow',
            close: 'absolute relative flex items-center justify-center flex-shrink-0 w-6 h-6 ml-4 text-blue-500 transition duration-100 ease-in-out rounded hover:bg-blue-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            closeIcon: 'fill-current h-4 w-4'
          };
        }
      }
    },
    data: function data() {
      return {
        localShow: this.show
      };
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    watch: {
      show: function show(_show2) {
        this.localShow = _show2;
      },
      localShow: function localShow(_localShow) {
        this.$emit('update:show', _localShow);

        if (this.localShow) {
          this.$emit('shown');

          if (this.timeout) {
            this.initTimeout();
          }
        } else {
          this.$emit('hidden');
        }
      }
    },
    mounted: function mounted() {
      if (this.localShow && this.timeout) {
        this.initTimeout();
      }
    },
    methods: {
      render: function render(createElement) {
        if (!this.localShow) {
          return createElement();
        }

        return createElement(this.tagName, {
          class: this.getElementCssClass('wrapper')
        }, !this.dismissible ? [createElement(this.bodyTagName, {
          ref: 'body',
          class: this.getElementCssClass('body')
        }, this.$slots.default)] : [createElement(this.bodyTagName, {
          ref: 'body',
          class: this.getElementCssClass('body')
        }, this.$slots.default), createElement('button', {
          ref: 'close',
          class: this.getElementCssClass('close'),
          attrs: {
            type: 'button'
          },
          on: {
            click: this.hide
          }
        }, this.$slots.close || [createElement('svg', {
          attrs: {
            fill: 'currentColor',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20'
          },
          class: this.getElementCssClass('closeIcon')
        }, [createElement('path', {
          attrs: {
            'clip-rule': 'evenodd',
            'fill-rule': 'evenodd',
            d: 'M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
          }
        })])])]);
      },
      initTimeout: function initTimeout() {
        var _this20 = this;

        setTimeout(function () {
          _this20.hide();
        }, this.timeout);
      },
      hide: function hide() {
        this.localShow = false;
      }
    }
  });
  var TModal = Component.extend({
    name: 'TModal',
    props: {
      name: {
        type: String,
        default: undefined
      },
      value: {
        type: Boolean,
        default: false
      },
      header: {
        type: String,
        default: undefined
      },
      footer: {
        type: String,
        default: undefined
      },
      clickToClose: {
        type: Boolean,
        default: true
      },
      escToClose: {
        type: Boolean,
        default: true
      },
      noBody: {
        type: Boolean,
        default: false
      },
      hideCloseButton: {
        type: Boolean,
        default: false
      },
      disableBodyScroll: {
        type: Boolean,
        default: true
      },
      bodyScrollLockOptions: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      focusOnOpen: {
        type: Boolean,
        default: true
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {
            overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed',
            wrapper: 'relative mx-auto',
            modal: 'overflow-visible relative ',
            close: 'flex items-center justify-center'
          };
        }
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            overlay: 'z-40 bg-black bg-opacity-50',
            wrapper: 'z-50 max-w-lg px-3 py-12',
            modal: 'bg-white shadow rounded',
            body: 'p-3',
            header: 'border-b border-gray-100 p-3 rounded-t',
            footer: 'bg-gray-100 p-3 rounded-b',
            close: 'bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            closeIcon: 'fill-current h-4 w-4',
            overlayEnterClass: 'opacity-0',
            overlayEnterActiveClass: 'transition ease-out duration-100',
            overlayEnterToClass: 'opacity-100',
            overlayLeaveClass: 'opacity-100',
            overlayLeaveActiveClass: 'transition ease-in duration-75',
            overlayLeaveToClass: 'opacity-0',
            enterClass: '',
            enterActiveClass: '',
            enterToClass: '',
            leaveClass: '',
            leaveActiveClass: '',
            leaveToClass: ''
          };
        }
      }
    },
    data: function data() {
      return {
        overlayShow: this.value,
        modalShow: this.value,
        params: undefined,
        preventAction: false
      };
    },
    watch: {
      value: function value(_value4) {
        if (_value4) {
          this.show();
        } else {
          this.hide();
        }
      },
      overlayShow: function overlayShow(shown) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  this.$emit('input', shown);
                  this.$emit('change', shown);
                  _context12.next = 4;
                  return this.$nextTick();

                case 4:
                  if (shown) {
                    this.modalShow = true;
                  } else {
                    this.closed();
                  }

                case 5:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this);
        }));
      },
      modalShow: function modalShow(shown) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.next = 2;
                  return this.$nextTick();

                case 2:
                  if (!shown) {
                    this.overlayShow = false;
                  } else {
                    this.opened();
                  }

                case 3:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));
      }
    },
    created: function created() {
      var _this21 = this;

      if (this.name && this.$modal) {
        this.$modal.$on("show-".concat(this.name), function () {
          var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

          _this21.show(params);
        });
        this.$modal.$on("hide-".concat(this.name), function () {
          _this21.hide();
        });
      }
    },
    mounted: function mounted() {
      if (this.overlayShow) {
        this.prepareDomForModal();
      }
    },
    beforeDestroy: function beforeDestroy() {
      var overlay = this.getOverlay();

      if (this.disableBodyScroll && overlay) {
        overlay.focus();
        bodyScrollLock.enableBodyScroll(overlay);
      }
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    methods: {
      render: function render(createElement) {
        return createElement('transition', {
          props: {
            enterClass: this.getElementCssClass('overlayEnterClass'),
            enterActiveClass: this.getElementCssClass('overlayEnterActiveClass'),
            enterToClass: this.getElementCssClass('overlayEnterToClass'),
            leaveClass: this.getElementCssClass('overlayLeaveClass'),
            leaveActiveClass: this.getElementCssClass('overlayLeaveActiveClass'),
            leaveToClass: this.getElementCssClass('overlayLeaveToClass')
          }
        }, this.overlayShow ? [createElement('div', {
          ref: 'overlay',
          attrs: {
            tabindex: 0
          },
          class: this.getElementCssClass('overlay'),
          on: {
            keyup: this.keyupHandler,
            click: this.clickHandler
          }
        }, [this.renderWrapper(createElement)])] : undefined);
      },
      renderWrapper: function renderWrapper(createElement) {
        return createElement('div', {
          ref: 'wrapper',
          class: this.getElementCssClass('wrapper')
        }, [this.renderModal(createElement)]);
      },
      renderModal: function renderModal(createElement) {
        return createElement('transition', {
          props: {
            enterClass: this.getElementCssClass('enterClass'),
            enterActiveClass: this.getElementCssClass('enterActiveClass'),
            enterToClass: this.getElementCssClass('enterToClass'),
            leaveClass: this.getElementCssClass('leaveClass'),
            leaveActiveClass: this.getElementCssClass('leaveActiveClass'),
            leaveToClass: this.getElementCssClass('leaveToClass')
          }
        }, this.modalShow ? [createElement('div', {
          ref: 'modal',
          class: this.getElementCssClass('modal')
        }, this.renderChilds(createElement))] : undefined);
      },
      renderChilds: function renderChilds(createElement) {
        if (this.noBody) {
          return this.$slots.default;
        }

        var childs = [];

        if (!this.hideCloseButton) {
          childs.push(createElement('button', {
            ref: 'close',
            class: this.getElementCssClass('close'),
            attrs: {
              type: 'button'
            },
            on: {
              click: this.hide
            }
          }, this.$slots.button || [createElement('svg', {
            attrs: {
              fill: 'currentColor',
              xmlns: 'http://www.w3.org/2000/svg',
              viewBox: '0 0 20 20'
            },
            class: this.getElementCssClass('closeIcon')
          }, [createElement('path', {
            attrs: {
              'clip-rule': 'evenodd',
              'fill-rule': 'evenodd',
              d: 'M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
            }
          })])]));
        }

        if (!!this.$slots.header || this.header !== undefined) {
          childs.push(createElement('div', {
            ref: 'header',
            class: this.getElementCssClass('header')
          }, this.$slots.header || this.header));
        }

        childs.push(createElement('div', {
          ref: 'body',
          class: this.getElementCssClass('body')
        }, this.$slots.default));

        if (!!this.$slots.footer || this.footer !== undefined) {
          childs.push(createElement('div', {
            ref: 'footer',
            class: this.getElementCssClass('footer')
          }, this.$slots.footer || this.footer));
        }

        return childs;
      },
      clickHandler: function clickHandler(e) {
        if (e.target === this.$refs.overlay) {
          this.outsideClick();
        }
      },
      keyupHandler: function keyupHandler(e) {
        if (e.keyCode === Key$1.ESC && this.escToClose) {
          this.hide();
        }
      },
      beforeOpen: function beforeOpen() {
        this.$emit('before-open', {
          params: this.params,
          cancel: this.cancel
        });
      },
      opened: function opened() {
        this.$emit('opened', {
          params: this.params
        });
        this.prepareDomForModal();
      },
      beforeClose: function beforeClose() {
        if (this.disableBodyScroll) {
          var overlay = this.getOverlay();

          if (overlay) {
            overlay.focus();
            bodyScrollLock.enableBodyScroll(overlay);
          }
        }

        this.$emit('before-close', {
          cancel: this.cancel
        });
      },
      closed: function closed() {
        this.$emit('closed');
      },
      prepareDomForModal: function prepareDomForModal() {
        var overlay = this.getOverlay();

        if (!overlay) {
          return;
        }

        if (this.disableBodyScroll) {
          bodyScrollLock.disableBodyScroll(overlay, this.bodyScrollLockOptions);
        }

        if (this.focusOnOpen) {
          overlay.focus();
        }
      },
      hide: function hide() {
        this.beforeClose();

        if (!this.preventAction) {
          this.modalShow = false;
        } else {
          this.preventAction = false;
        }
      },
      show: function show() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        this.params = params;
        this.beforeOpen();

        if (!this.preventAction) {
          this.overlayShow = true;
        } else {
          this.preventAction = false;
        }
      },
      cancel: function cancel() {
        this.preventAction = true;
      },
      outsideClick: function outsideClick() {
        if (this.clickToClose) {
          this.hide();
        }
      },
      getOverlay: function getOverlay() {
        return this.$refs.overlay;
      }
    }
  });
  var TDropdown = Component.extend({
    name: 'TDropdown',
    props: {
      text: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: undefined
      },
      tagName: {
        type: String,
        default: 'div'
      },
      dropdownWrapperTagName: {
        type: String,
        default: 'div'
      },
      dropdownTagName: {
        type: String,
        default: 'div'
      },
      toggleOnFocus: {
        type: Boolean,
        default: false
      },
      toggleOnClick: {
        type: Boolean,
        default: true
      },
      toggleOnHover: {
        type: Boolean,
        default: false
      },
      hideOnLeaveTimeout: {
        type: Number,
        default: 250
      },
      show: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            button: 'block px-4 py-2 text-white transition duration-100 ease-in-out bg-blue-500 border border-transparent rounded shadow-sm hover:bg-blue-600 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
            wrapper: 'inline-flex flex-col',
            dropdownWrapper: 'relative z-10',
            dropdown: 'origin-top-left absolute left-0 w-56 rounded shadow bg-white mt-1',
            enterClass: 'opacity-0 scale-95',
            enterActiveClass: 'transition transform ease-out duration-100',
            enterToClass: 'opacity-100 scale-100',
            leaveClass: 'opacity-100 scale-100',
            leaveActiveClass: 'transition transform ease-in duration-75',
            leaveToClass: 'opacity-0 scale-95'
          };
        }
      }
    },
    data: function data() {
      return {
        localShow: this.show,
        hasFocus: false,
        hideOnLeaveTimeoutHolder: null
      };
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    watch: {
      show: function show(_show3) {
        this.localShow = _show3;
      },
      localShow: function localShow(_localShow2) {
        this.$emit('update:show', _localShow2);

        if (_localShow2) {
          this.$emit('shown');
        } else {
          this.$emit('hidden');
        }
      }
    },
    methods: {
      render: function render(createElement) {
        var defaultSlot = this.$scopedSlots.default ? this.$scopedSlots.default({
          hide: this.doHide,
          show: this.doShow,
          toggle: this.doToggle,
          blurHandler: this.blurHandler
        }) : null;
        var triggerSlot = this.$scopedSlots.trigger ? this.$scopedSlots.trigger({
          isShown: this.localShow,
          hide: this.doHide,
          hideIfFocusOutside: this.hideIfFocusOutside,
          show: this.doShow,
          toggle: this.doToggle,
          mousedownHandler: this.mousedownHandler,
          focusHandler: this.focusHandler,
          blurHandler: this.blurHandler,
          keydownHandler: this.keydownHandler,
          disabled: this.disabled
        }) : createElement('button', {
          ref: 'button',
          attrs: {
            type: 'button',
            disabled: this.disabled
          },
          class: this.getElementCssClass('button'),
          on: {
            keydown: this.keydownHandler,
            mousedown: this.mousedownHandler,
            focus: this.focusHandler,
            blur: this.blurHandler
          }
        }, this.$slots.button || this.text);
        var subElements = [triggerSlot, createElement('transition', {
          props: {
            enterClass: this.getElementCssClass('enterClass'),
            enterActiveClass: this.getElementCssClass('enterActiveClass'),
            enterToClass: this.getElementCssClass('enterToClass'),
            leaveClass: this.getElementCssClass('leaveClass'),
            leaveActiveClass: this.getElementCssClass('leaveActiveClass'),
            leaveToClass: this.getElementCssClass('leaveToClass')
          }
        }, this.localShow ? [createElement(this.dropdownWrapperTagName, {
          ref: 'dropdownWrapper',
          class: this.getElementCssClass('dropdownWrapper'),
          attrs: {
            tabindex: -1
          },
          on: {
            focus: this.focusHandler,
            blur: this.blurHandler
          }
        }, [createElement(this.dropdownTagName, {
          ref: 'dropdown',
          class: this.getElementCssClass('dropdown')
        }, defaultSlot)])] : undefined)];
        return createElement(this.tagName, {
          ref: 'wrapper',
          class: this.getElementCssClass('wrapper'),
          on: {
            mouseover: this.mouseoverHandler,
            mouseleave: this.mouseleaveHandler
          }
        }, subElements);
      },
      blurEventTargetIsChild: function blurEventTargetIsChild(e) {
        var blurredElement = e.relatedTarget;

        if (blurredElement) {
          var wrapper = this.$refs.wrapper;
          return wrapper.contains(blurredElement);
        }

        return false;
      },
      focusEventTargetIsChild: function focusEventTargetIsChild(e) {
        var focusedElement = e.target;

        if (focusedElement) {
          var wrapper = this.$refs.wrapper;
          return wrapper.contains(focusedElement);
        }

        return false;
      },
      escapeHandler: function escapeHandler() {
        this.doHide();
      },
      mousedownHandler: function mousedownHandler() {
        if (this.toggleOnClick) {
          this.doToggle();
        }
      },
      focusHandler: function focusHandler(e) {
        if (!this.hasFocus && this.focusEventTargetIsChild(e)) {
          this.hasFocus = true;
          this.$emit('focus', e);
        }

        if (this.toggleOnFocus) {
          this.doShow();
        }
      },
      blurHandler: function blurHandler(e) {
        if (this.hasFocus && !this.blurEventTargetIsChild(e)) {
          this.hasFocus = false;
          this.$emit('blur', e);
        }

        if (this.toggleOnFocus || this.toggleOnClick) {
          this.hideIfFocusOutside(e);
        }
      },
      keydownHandler: function keydownHandler(e) {
        if ([Key$1.ENTER, Key$1.SPACE].includes(e.keyCode)) {
          this.mousedownHandler();
        } else if (e.keyCode === Key$1.ESC) {
          this.escapeHandler();
        }

        this.$emit('keydown', e);
      },
      mouseleaveHandler: function mouseleaveHandler() {
        var _this22 = this;

        if (!this.toggleOnHover) {
          return;
        }

        if (!this.hideOnLeaveTimeout) {
          this.doHide();
          return;
        }

        this.hideOnLeaveTimeoutHolder = setTimeout(function () {
          _this22.doHide();

          _this22.hideOnLeaveTimeoutHolder = null;
        }, this.hideOnLeaveTimeout);
      },
      mouseoverHandler: function mouseoverHandler() {
        if (!this.toggleOnHover) {
          return;
        }

        if (this.hideOnLeaveTimeout && this.hideOnLeaveTimeoutHolder) {
          clearTimeout(this.hideOnLeaveTimeoutHolder);
          this.hideOnLeaveTimeoutHolder = null;
        }

        this.doShow();
      },
      doHide: function doHide() {
        this.localShow = false;
      },
      hideIfFocusOutside: function hideIfFocusOutside(e) {
        if (!(e instanceof Event)) {
          throw new Error('the method hideIfFocusOutside expects an instance of `Event` as parameter');
        }

        if (!this.blurEventTargetIsChild(e)) {
          this.doHide();
        }
      },
      doShow: function doShow() {
        this.localShow = true;
      },
      doToggle: function doToggle() {
        if (this.localShow) {
          this.doHide();
        } else {
          this.doShow();
        }
      },
      blur: function blur() {
        var el = this.$refs.button;
        el.blur();
      },
      focus: function focus(options) {
        var el = this.$refs.button;
        el.focus(options);
      }
    }
  });
  var TPagination = Component.extend({
    name: 'TPagination',
    props: {
      value: {
        type: Number,
        default: null
      },
      tagName: {
        type: String,
        default: 'ul'
      },
      elementTagName: {
        type: String,
        default: 'li'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 20,
        validator: function validator(value) {
          return value > 0;
        }
      },
      totalItems: {
        type: Number,
        default: 0,
        validator: function validator(value) {
          return value >= 0;
        }
      },
      limit: {
        type: Number,
        default: 5,
        validator: function validator(value) {
          return value >= 0;
        }
      },
      prevLabel: {
        type: String,
        default: '&lsaquo;'
      },
      nextLabel: {
        type: String,
        default: '&rsaquo;'
      },
      firstLabel: {
        type: String,
        default: '&laquo;'
      },
      lastLabel: {
        type: String,
        default: '&raquo;'
      },
      ellipsisLabel: {
        type: String,
        default: '&hellip;'
      },
      hideFirstLastControls: {
        type: Boolean,
        default: false
      },
      hidePrevNextControls: {
        type: Boolean,
        default: false
      },
      hideEllipsis: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            wrapper: 'table border-collapse text-center bg-white mx-auto shadow-sm',
            element: 'w-8 h-8 border border-gray-200 table-cell hover:border-blue-100',
            activeElement: 'w-8 h-8 border border-blue-500 table-cell hover:border-blue-600',
            disabledElement: 'w-8 h-8 border border-gray-200 table-cell',
            ellipsisElement: 'w-8 h-8 border border-gray-200 hidden md:table-cell',
            activeButton: 'bg-blue-500 w-full h-full text-white hover:bg-blue-600 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            disabledButton: 'opacity-25 w-full h-full cursor-not-allowed transition duration-100 ease-in-out',
            button: 'hover:bg-blue-100 w-full h-full transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            ellipsis: ''
          };
        }
      }
    },
    render: function render(createElement) {
      var createComponentFunc = this.createComponent;
      return createComponentFunc(createElement);
    },
    data: function data() {
      return {
        currentPage: this.value
      };
    },
    computed: {
      totalPages: function totalPages() {
        if (this.perPage <= 0) {
          return 0;
        }

        return Math.ceil(this.totalItems / this.perPage);
      },
      pageButtons: function pageButtons() {
        var _this23 = this;

        var from1 = Number(this.currentPage) - Math.round(this.limit / 2) + 1;
        var from2 = this.totalPages + 1 - this.limit;
        var from = Math.max(Math.min(from1, from2), 1);
        var to = Math.min(from + this.limit - 1, this.totalPages);
        return range__default['default'](from, to + 1).map(function (page) {
          if (!_this23.hideEllipsis && page === from && from > 1) {
            return 'less';
          }

          if (!_this23.hideEllipsis && page === to && to < _this23.totalPages) {
            return 'more';
          }

          return String(page);
        });
      },
      prevIsDisabled: function prevIsDisabled() {
        return this.disabled || this.currentPage === null || this.currentPage <= 1;
      },
      nextIsDisabled: function nextIsDisabled() {
        return this.disabled || this.currentPage === null || this.currentPage >= this.totalPages;
      }
    },
    watch: {
      value: function value(_value5) {
        this.currentPage = _value5;
      },
      currentPage: function currentPage(_currentPage) {
        this.$emit('input', _currentPage);
        this.$emit('change', _currentPage);
      }
    },
    methods: {
      createComponent: function createComponent(createElement) {
        var _this24 = this;

        var subElements = [];

        if (!this.hideFirstLastControls) {
          subElements.push(this.createControl(createElement, this.firstLabel, this.prevIsDisabled, false, this.goToFirstPage));
        }

        if (!this.hidePrevNextControls) {
          subElements.push(this.createControl(createElement, this.prevLabel, this.prevIsDisabled, false, this.goToPrevPage));
        }

        this.pageButtons.forEach(function (page) {
          if (page === 'less' || page === 'more') {
            subElements.push(_this24.createControl(createElement, _this24.ellipsisLabel));
          } else {
            subElements.push(_this24.createControl(createElement, page, false, _this24.isPageActive(Number(page)), function () {
              return _this24.selectPage(Number(page));
            }));
          }
        });

        if (!this.hidePrevNextControls) {
          subElements.push(this.createControl(createElement, this.nextLabel, this.nextIsDisabled, false, this.goToNextPage));
        }

        if (!this.hideFirstLastControls) {
          subElements.push(this.createControl(createElement, this.lastLabel, this.nextIsDisabled, false, this.goToLastPage));
        }

        return createElement(this.tagName, {
          class: this.getElementCssClass('wrapper')
        }, subElements);
      },
      // eslint-disable-next-line max-len
      createControl: function createControl(createElement, text) {
        var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var active = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var clickHandler = arguments.length > 4 ? arguments[4] : undefined;
        var className = '';

        if (!clickHandler) {
          className = this.getElementCssClass('ellipsisElement');
        } else if (disabled) {
          className = this.getElementCssClass('disabledElement');
        } else if (active) {
          className = this.getElementCssClass('activeElement');
        } else {
          className = this.getElementCssClass('element');
        }

        return createElement(this.elementTagName, {
          class: className
        }, [this.createControlButton(createElement, text, disabled, active, clickHandler)]);
      },
      // eslint-disable-next-line max-len
      createControlButton: function createControlButton(createElement, text) {
        var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var active = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var clickHandler = arguments.length > 4 ? arguments[4] : undefined;

        if (!clickHandler) {
          return createElement('span', {
            class: this.getElementCssClass('ellipsis'),
            domProps: {
              innerHTML: text
            }
          });
        }

        var className = '';
        var attrs = {};

        if (disabled) {
          className = this.getElementCssClass('disabledButton');
          attrs.disabled = true;
        } else if (active) {
          className = this.getElementCssClass('activeButton');
        } else {
          className = this.getElementCssClass('button');
        }

        return createElement('button', {
          class: className,
          on: {
            click: clickHandler
          },
          attrs: attrs,
          domProps: {
            disabled: disabled ? true : undefined,
            innerHTML: text
          }
        });
      },
      selectPage: function selectPage(page) {
        this.currentPage = page;
      },
      goToPrevPage: function goToPrevPage() {
        this.currentPage = this.currentPage === null ? 1 : Math.max(this.currentPage - 1, 1);
      },
      goToNextPage: function goToNextPage() {
        this.currentPage = this.currentPage === null ? this.totalPages : Math.min(this.currentPage + 1, this.totalPages);
      },
      goToFirstPage: function goToFirstPage() {
        this.currentPage = 1;
      },
      goToLastPage: function goToLastPage() {
        this.currentPage = this.totalPages;
      },
      isPageActive: function isPageActive(page) {
        return page === this.currentPage;
      }
    }
  });
  var TTag = Component.extend({
    name: 'TTag',
    props: {
      text: {
        type: String,
        default: undefined
      },
      tagName: {
        type: String,
        default: 'div'
      }
    },
    render: function render(createElement) {
      var renderFun = this.render;
      return renderFun(createElement);
    },
    methods: {
      render: function render(createElement) {
        return createElement(this.tagName, {
          class: this.componentClass
        }, this.text === undefined ? this.$slots.default : this.text);
      }
    }
  });
  var TRadioGroup = InputWithOptions.extend({
    name: 'TRadioGroup',
    props: {
      groupWrapperTag: {
        type: String,
        default: 'div'
      },
      wrapperTag: {
        type: String,
        default: 'label'
      },
      inputWrapperTag: {
        type: String,
        default: 'span'
      },
      labelTag: {
        type: String,
        default: 'span'
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            groupWrapper: 'flex flex-col',
            label: '',
            input: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
            inputWrapper: 'inline-flex',
            wrapper: 'inline-flex items-center space-x-2'
          };
        }
      }
    },
    data: function data() {
      return {
        localValue: this.value
      };
    },
    watch: {
      localValue: function localValue(_localValue5) {
        this.$emit('input', _localValue5);
        this.$emit('change', _localValue5);
      },
      value: function value(_value6) {
        this.localValue = _value6;
      }
    },
    render: function render(createElement) {
      var createRadioGroupFunc = this.createRadioGroup;
      return createRadioGroupFunc(createElement);
    },
    methods: {
      createRadioGroup: function createRadioGroup(createElement) {
        return createElement(this.groupWrapperTag, {
          ref: 'wrapper',
          class: this.getElementCssClass('groupWrapper')
        }, this.createRadioOptions(createElement));
      },
      createRadioOptions: function createRadioOptions(createElement) {
        var _this25 = this;

        var options = this.normalizedOptions;
        return options.map(function (option, index) {
          return _this25.createRadioOption(createElement, option, index);
        });
      },
      createRadioOption: function createRadioOption(createElement, option, index) {
        var _this26 = this;

        return createElement(TRadio, {
          props: {
            id: this.buildId(option, index),
            name: this.name,
            tabindex: this.tabindex,
            disabled: this.disabled,
            autofocus: this.autofocus,
            required: this.required,
            model: this.localValue,
            label: option.text,
            wrapped: true,
            value: option.value,
            checked: this.value === option.value,
            variant: this.variant,
            classes: this.classes,
            fixedClasses: this.fixedClasses,
            variants: this.variants,
            wrapperTag: this.wrapperTag,
            inputWrapperTag: this.inputWrapperTag,
            labelTag: this.labelTag
          },
          scopedSlots: {
            default: this.$scopedSlots.default
          },
          on: {
            blur: this.blurHandler,
            focus: this.focusHandler,
            input: function input(value) {
              if (isEqual__default['default'](value, option.value)) {
                _this26.inputHandler(option.value);
              }
            }
          }
        });
      },
      buildId: function buildId(option, index) {
        var parts = [];

        if (this.id) {
          parts.push(this.id);
        } else if (this.name) {
          parts.push(this.name);
        }

        if (['string', 'number'].includes(_typeof(option.value))) {
          parts.push(kebabCase__default['default'](String(option.value)));
        } else {
          parts.push(index);
        }

        return parts.join('-');
      },
      inputHandler: function inputHandler(value) {
        this.$emit('input', value);
      },
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
      }
    }
  });
  var TCheckboxGroup = InputWithOptions.extend({
    name: 'TCheckboxGroup',
    props: {
      groupWrapperTag: {
        type: String,
        default: 'div'
      },
      wrapperTag: {
        type: String,
        default: 'label'
      },
      inputWrapperTag: {
        type: String,
        default: 'span'
      },
      labelTag: {
        type: String,
        default: 'span'
      },
      value: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            groupWrapper: 'flex flex-col',
            label: '',
            input: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
            inputWrapper: 'inline-flex',
            wrapper: 'inline-flex items-center space-x-2'
          };
        }
      }
    },
    data: function data() {
      return {
        localValue: this.value
      };
    },
    watch: {
      localValue: function localValue(_localValue6) {
        this.$emit('input', _localValue6);
        this.$emit('change', _localValue6);
      },
      value: function value(_value7) {
        this.localValue = _value7;
      }
    },
    render: function render(createElement) {
      var createRadioGroupFunc = this.createRadioGroup;
      return createRadioGroupFunc(createElement);
    },
    methods: {
      createRadioGroup: function createRadioGroup(createElement) {
        return createElement(this.groupWrapperTag, {
          ref: 'wrapper',
          class: this.getElementCssClass('groupWrapper')
        }, this.createRadioOptions(createElement));
      },
      createRadioOptions: function createRadioOptions(createElement) {
        var _this27 = this;

        var options = this.normalizedOptions;
        return options.map(function (option, index) {
          return _this27.createRadioOption(createElement, option, index);
        });
      },
      createRadioOption: function createRadioOption(createElement, option, index) {
        return createElement(TCheckbox, {
          props: {
            id: this.buildId(option, index),
            name: this.name,
            tabindex: this.tabindex,
            disabled: this.disabled,
            autofocus: this.autofocus,
            required: this.required,
            model: this.localValue,
            label: option.text,
            wrapped: true,
            value: option.value,
            checked: this.value === option.value,
            variant: this.variant,
            classes: this.classes,
            fixedClasses: this.fixedClasses,
            variants: this.variants,
            wrapperTag: this.wrapperTag,
            inputWrapperTag: this.inputWrapperTag,
            labelTag: this.labelTag
          },
          scopedSlots: {
            default: this.$scopedSlots.default
          },
          on: {
            blur: this.blurHandler,
            focus: this.focusHandler,
            input: this.inputHandler
          }
        });
      },
      buildId: function buildId(option, index) {
        var parts = [];

        if (this.id) {
          parts.push(this.id);
        } else if (this.name) {
          parts.push(this.name);
        }

        if (['string', 'number'].includes(_typeof(option.value))) {
          parts.push(kebabCase__default['default'](String(option.value)));
        } else {
          parts.push(index);
        }

        return parts.join('-');
      },
      inputHandler: function inputHandler(value) {
        this.localValue = value;
      },
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
      }
    }
  });
  var TTable = Component.extend({
    name: 'TTable',
    props: {
      data: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      headers: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      footerData: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      hideHeader: {
        type: Boolean,
        default: false
      },
      showFooter: {
        type: Boolean,
        default: false
      },
      responsive: {
        type: Boolean,
        default: false
      },
      responsiveBreakpoint: {
        type: Number,
        default: 768
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            table: 'min-w-full divide-y divide-gray-100 shadow-sm border-gray-200 border',
            thead: '',
            theadTr: '',
            theadTh: 'px-3 py-2 font-semibold text-left bg-gray-100 border-b',
            tbody: 'bg-white divide-y divide-gray-100',
            tr: '',
            td: 'px-3 py-2 whitespace-no-wrap',
            tfoot: '',
            tfootTr: '',
            tfootTd: ''
          };
        }
      }
    },
    data: function data() {
      return {
        ready: !this.responsive,
        windowWidth: null
      };
    },
    computed: {
      renderResponsive: function renderResponsive() {
        var windowWidth = this.windowWidth;
        return this.responsive && windowWidth && windowWidth < this.responsiveBreakpoint;
      },
      normalizedHeaders: function normalizedHeaders() {
        return this.headers.map(function (header) {
          if (typeof header === 'string') {
            return {
              text: header
            };
          }

          return header;
        });
      },
      normalizedFooterData: function normalizedFooterData() {
        return this.footerData.map(function (footer) {
          if (typeof footer === 'string') {
            return {
              text: footer
            };
          }

          return footer;
        });
      },
      headersValues: function headersValues() {
        return this.headers.filter(function (h) {
          return h.value;
        }).map(function (h) {
          return h.value;
        });
      },
      showHeader: function showHeader() {
        return !this.hideHeader;
      }
    },
    mounted: function mounted() {
      // If responsive we will need to calculate the windowWidth
      if (this.responsive) {
        this.windowWidth = window.innerWidth; // If responsive we want to show the table until we know the window size

        this.ready = true;
        window.addEventListener('resize', this.resizeListener);
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.responsive) {
        window.removeEventListener('resize', this.resizeListener);
      }
    },
    render: function render(createElement) {
      var renderFun = this.renderTable;
      return renderFun(createElement);
    },
    methods: {
      resizeListener: function resizeListener() {
        this.windowWidth = window.innerWidth;
      },
      renderTable: function renderTable(createElement) {
        if (!this.ready) {
          return createElement();
        }

        var childElements = []; // The responsive version doesnt have header

        if (!this.renderResponsive) {
          childElements.push(this.renderThead(createElement));
        }

        childElements.push(this.renderTbody(createElement));

        if (this.showFooter || this.$scopedSlots.tfoot) {
          childElements.push(this.renderTfoot(createElement));
        }

        return createElement('table', {
          ref: 'table',
          class: this.getElementCssClass('table')
        }, childElements);
      },
      renderThead: function renderThead(createElement) {
        var trClass = this.getElementCssClass('theadTr');
        var thClass = this.getElementCssClass('theadTh');
        var theadClass = this.getElementCssClass('thead');

        if (this.$scopedSlots.thead) {
          var thead = this.$scopedSlots.thead({
            theadClass: theadClass,
            trClass: trClass,
            thClass: thClass,
            data: this.normalizedHeaders
          });

          if (thead) {
            return thead;
          }
        }

        if (!this.showHeader) {
          return createElement();
        }

        var ths = this.normalizedHeaders.map(function (header) {
          return createElement('th', {
            attrs: {
              id: header.id
            },
            class: header.className ? [thClass, header.className] : thClass
          }, header.text);
        });
        return createElement('thead', {
          class: theadClass
        }, [createElement('tr', {
          class: trClass
        }, ths)]);
      },
      renderTfoot: function renderTfoot(createElement) {
        var trClass = this.getElementCssClass('tfootTr');
        var tdClass = this.getElementCssClass('tfootTd');
        var tfootClass = this.getElementCssClass('tfoot');

        if (this.$scopedSlots.tfoot) {
          var tfoot = this.$scopedSlots.tfoot({
            tfootClass: tfootClass,
            trClass: trClass,
            tdClass: tdClass,
            data: this.normalizedFooterData,
            headers: this.normalizedHeaders,
            renderResponsive: this.renderResponsive
          });

          if (tfoot) {
            return tfoot;
          }
        }

        var tds = this.normalizedFooterData.map(function (footer) {
          return createElement('td', {
            attrs: {
              id: footer.id
            },
            class: footer.className ? [tdClass, footer.className] : tdClass
          }, footer.text);
        });
        return createElement('tfoot', {
          class: tfootClass
        }, [createElement('tr', {
          class: trClass
        }, tds)]);
      },
      renderTbody: function renderTbody(createElement) {
        if (this.$scopedSlots.tbody) {
          var tbody = this.$scopedSlots.tbody({
            tbodyClass: this.getElementCssClass('tbody'),
            trClass: this.getElementCssClass('tr'),
            tdClass: this.getElementCssClass('td'),
            data: this.data,
            headers: this.normalizedHeaders,
            renderResponsive: this.renderResponsive
          });

          if (tbody) {
            return tbody;
          }
        }

        return createElement('tbody', {
          class: this.getElementCssClass('tbody')
        }, this.renderRows(createElement));
      },
      renderRows: function renderRows(createElement) {
        var _this28 = this;

        return this.data.map(function (row, rowIndex) {
          if (_this28.$scopedSlots.row) {
            var tableRow = _this28.$scopedSlots.row({
              rowIndex: rowIndex,
              row: row,
              trClass: _this28.getElementCssClass('tr'),
              tdClass: _this28.getElementCssClass('td')
            });

            if (tableRow) {
              return tableRow;
            }
          }

          return createElement('tr', {
            class: _this28.getElementCssClass('tr')
          }, _this28.renderCols(createElement, row, rowIndex));
        });
      },
      renderCols: function renderCols(createElement, row, rowIndex) {
        var _this29 = this;

        var columns = this.getRowColumns(row);

        if (_typeof(columns) === 'object') {
          return Object.keys(columns).map(function (columnIndex) {
            var text = columns[columnIndex];
            return _this29.renderCol(createElement, text, rowIndex, columnIndex);
          });
        }

        return columns.map(function (text, columnIndex) {
          return _this29.renderCol(createElement, text, rowIndex, columnIndex);
        });
      },
      renderCol: function renderCol(createElement, text, rowIndex, columnIndex) {
        if (this.$scopedSlots.column) {
          var tableColumn = this.$scopedSlots.column({
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            text: text,
            tdClass: this.getElementCssClass('td')
          });

          if (tableColumn) {
            return tableColumn;
          }
        }

        return createElement('td', {
          class: this.getElementCssClass('td')
        }, text);
      },
      getRowColumns: function getRowColumns(row) {
        if (!this.headersValues.length) {
          return row;
        }

        if (_typeof(row) === 'object') {
          return pick__default['default'](row, this.headersValues);
        }

        return {};
      }
    }
  });
  var English = {
    weekdays: {
      shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    },
    months: {
      shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      longhand: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: function ordinal(nth) {
      var s = nth % 100;
      if (s > 3 && s < 21) return 'th';

      switch (s % 10) {
        case 1:
          return 'st';

        case 2:
          return 'nd';

        case 3:
          return 'rd';

        default:
          return 'th';
      }
    },
    rangeSeparator: ' to ',
    weekAbbreviation: 'Wk',
    amPM: ['AM', 'PM'],
    yearAriaLabel: 'Year',
    monthAriaLabel: 'Month',
    hourAriaLabel: 'Hour',
    minuteAriaLabel: 'Minute',
    time24hr: false,
    timeLabel: 'Time',
    okLabel: 'Ok'
  };

  var pad = function pad(number) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return "000".concat(number).slice(length * -1);
  };

  var int = function int(bool) {
    return bool === true ? 1 : 0;
  }; // Credits to https://github.com/flatpickr/flatpickr/blob/master/src/utils/formatting.ts


  var doNothing = function doNothing() {
    return undefined;
  };

  var monthToStr = function monthToStr(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? 'shorthand' : 'longhand'][monthNumber];
  };

  var revFormat = {
    D: doNothing,
    F: function F(dateObj, monthName, locale) {
      dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function G(dateObj, hour) {
      dateObj.setHours(parseFloat(hour));
    },
    H: function H(dateObj, hour) {
      dateObj.setHours(parseFloat(hour));
    },
    J: function J(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    K: function K(dateObj, amPM, locale) {
      dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], 'i').test(amPM)));
    },
    M: function M(dateObj, shortMonth, locale) {
      dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function S(dateObj, seconds) {
      dateObj.setSeconds(parseFloat(seconds));
    },
    U: function U(_, unixSeconds) {
      return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function W(dateObj, weekNum, locale) {
      var weekNumber = parseInt(weekNum, 10);
      var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
      date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
      return date;
    },
    Y: function Y(dateObj, year) {
      dateObj.setFullYear(parseFloat(year));
    },
    Z: function Z(_, ISODate) {
      return new Date(ISODate);
    },
    d: function d(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    h: function h(dateObj, hour) {
      dateObj.setHours(parseFloat(hour));
    },
    i: function i(dateObj, minutes) {
      dateObj.setMinutes(parseFloat(minutes));
    },
    j: function j(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    l: doNothing,
    m: function m(dateObj, month) {
      dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function n(dateObj, month) {
      dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function s(dateObj, seconds) {
      dateObj.setSeconds(parseFloat(seconds));
    },
    u: function u(_, unixMillSeconds) {
      return new Date(parseFloat(unixMillSeconds));
    },
    w: doNothing,
    y: function y(dateObj, year) {
      dateObj.setFullYear(2000 + parseFloat(year));
    }
  };
  var tokenRegex = {
    D: '(\\w+)',
    F: '(\\w+)',
    G: '(\\d\\d|\\d)',
    H: '(\\d\\d|\\d)',
    J: '(\\d\\d|\\d)\\w+',
    K: '',
    M: '(\\w+)',
    S: '(\\d\\d|\\d)',
    U: '(.+)',
    W: '(\\d\\d|\\d)',
    Y: '(\\d{4})',
    Z: '(.+)',
    d: '(\\d\\d|\\d)',
    h: '(\\d\\d|\\d)',
    i: '(\\d\\d|\\d)',
    j: '(\\d\\d|\\d)',
    l: '(\\w+)',
    m: '(\\d\\d|\\d)',
    n: '(\\d\\d|\\d)',
    s: '(\\d\\d|\\d)',
    u: '(.+)',
    w: '(\\d\\d|\\d)',
    y: '(\\d{2})'
  };
  var formats = {
    // get the date in UTC
    Z: function Z(date) {
      return date.toISOString();
    },
    // weekday name, short, e.g. Thu
    D: function D(date, locale) {
      return locale.weekdays.shorthand[formats.w(date, locale)];
    },
    // full month name e.g. January
    F: function F(date, locale) {
      return monthToStr(formats.n(date, locale) - 1, false, locale);
    },
    // padded hour 1-12
    G: function G(date, locale) {
      return pad(formats.h(date, locale));
    },
    // hours with leading zero e.g. 03
    H: function H(date) {
      return pad(date.getHours());
    },
    // day (1-30) with ordinal suffix e.g. 1st, 2nd
    J: function J(date, locale) {
      return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    // AM/PM
    K: function K(date, locale) {
      return locale.amPM[int(date.getHours() > 11)];
    },
    // shorthand month e.g. Jan, Sep, Oct, etc
    M: function M(date, locale) {
      return monthToStr(date.getMonth(), true, locale);
    },
    // seconds 00-59
    S: function S(date) {
      return pad(date.getSeconds());
    },
    // unix timestamp
    U: function U(date) {
      return date.getTime() / 1000;
    },
    W: function W(givenDate) {
      // return options.getWeek(date);
      var date = new Date(givenDate.getTime());
      date.setHours(0, 0, 0, 0); // Thursday in current week decides the year.

      date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7); // January 4 is always in week 1.

      var week1 = new Date(date.getFullYear(), 0, 4); // Adjust to Thursday in week 1 and count number of weeks from date to week1.

      return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    // full year e.g. 2016, padded (0001-9999)
    Y: function Y(date) {
      return pad(date.getFullYear(), 4);
    },
    // day in month, padded (01-30)
    d: function d(date) {
      return pad(date.getDate());
    },
    // hour from 1-12 (am/pm)
    h: function h(date) {
      return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    // minutes, padded with leading zero e.g. 09
    i: function i(date) {
      return pad(date.getMinutes());
    },
    // day in month (1-30)
    j: function j(date) {
      return date.getDate();
    },
    // weekday name, full, e.g. Thursday
    l: function l(date, locale) {
      return locale.weekdays.longhand[date.getDay()];
    },
    // padded month number (01-12)
    m: function m(date) {
      return pad(date.getMonth() + 1);
    },
    // the month number (1-12)
    n: function n(date) {
      return date.getMonth() + 1;
    },
    // seconds 0-59
    s: function s(date) {
      return date.getSeconds();
    },
    // Unix Milliseconds
    u: function u(date) {
      return date.getTime();
    },
    // number of the day of the week
    w: function w(date) {
      return date.getDay();
    },
    // last two digits of year e.g. 16 for 2016
    y: function y(date) {
      return String(date.getFullYear()).substring(2);
    }
  };

  var formatDate = function formatDate(dateObj, format, customLocale) {
    if (!dateObj) {
      return '';
    }

    var locale = customLocale || English;
    return format.split('').map(function (char, i, arr) {
      if (formats[char] && arr[i - 1] !== '\\') {
        return formats[char](dateObj, locale);
      }

      if (char !== '\\') {
        return char;
      }

      return '';
    }).join('');
  };

  var parseDate = function parseDate(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y-m-d H:i:S';
    var timeless = arguments.length > 2 ? arguments[2] : undefined;
    var customLocale = arguments.length > 3 ? arguments[3] : undefined;

    if (date !== 0 && !date) {
      return undefined;
    }

    var locale = customLocale || English;
    var localeTokenRegex = Object.assign({}, tokenRegex);
    localeTokenRegex.K = "(".concat(locale.amPM[0], "|").concat(locale.amPM[1], "|").concat(locale.amPM[0].toLowerCase(), "|").concat(locale.amPM[1].toLowerCase(), ")");
    var parsedDate;
    var dateOrig = date;

    if (date instanceof Date) {
      parsedDate = new Date(date.getTime());
    } else if (typeof date !== 'string' && date.toFixed !== undefined // timestamp
    ) {
      // create a copy
      parsedDate = new Date(date);
    } else if (typeof date === 'string') {
      // if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
      //   const defaultDateFormat =
      //     flatpickr.defaultConfig.dateFormat || defaultOptions.dateFormat;
      //   formats.dateFormat =
      //     userConfig.noCalendar || timeMode
      //       ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
      //       : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
      // }
      var datestr = String(date).trim();

      if (datestr === 'today') {
        parsedDate = new Date(); // eslint-disable-next-line no-param-reassign

        timeless = true;
      } else if (/Z$/.test(datestr) || /GMT$/.test(datestr) // datestrings w/ timezone
      ) {
        parsedDate = new Date(date);
      } else {
        parsedDate = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0); // parsedDate = !config || !config.noCalendar
        //   ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
        //   : (new Date(new Date().setHours(0, 0, 0, 0)) as Date);

        var matched;
        var ops = [];

        for (var i = 0, matchIndex = 0, regexStr = ''; i < format.length; i += 1) {
          var token2 = format[i];
          var isBackSlash = token2 === '\\';
          var escaped = format[i - 1] === '\\' || isBackSlash;

          if (localeTokenRegex[token2] && !escaped) {
            regexStr += localeTokenRegex[token2];
            var match = new RegExp(regexStr).exec(date);

            if (match) {
              matched = true;
              ops[token2 !== 'Y' ? 'push' : 'unshift']({
                fn: revFormat[token2],
                val: match[matchIndex += 1]
              });
            }
          } else if (!isBackSlash) {
            regexStr += '.'; // don't really care
          } // eslint-disable-next-line no-loop-func


          ops.forEach(function (op) {
            var fn = op.fn;
            var val = op.val;
            parsedDate = fn(parsedDate, String(val), locale) || parsedDate;
          });
        }

        parsedDate = matched ? parsedDate : undefined;
      }
    }
    /* istanbul ignore next */
    // eslint-disable-next-line no-restricted-globals


    if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
      throw new Error("Invalid date provided: ".concat(dateOrig));
    }

    if (timeless === true) {
      parsedDate.setHours(0, 0, 0, 0);
    }

    return parsedDate;
  };
  /**
   * Compute the difference in dates, measured in ms
   */


  function compareDates(date1, date2) {
    var timeless = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (timeless !== false) {
      return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    }

    return date1.getTime() - date2.getTime();
  }

  var extractLocaleFromProps = function extractLocaleFromProps(localeName, locales, defaultLocale) {
    var availableLocales = Object.keys(locales);
    var find = availableLocales.find(function (l) {
      return l === localeName;
    });
    var locale = find && locales[find] ? locales[find] : defaultLocale;
    return merge__default['default'](cloneDeep__default['default'](English), locale);
  };

  var buildDateParser = function buildDateParser(locale, customDateParser) {
    return function (date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y-m-d H:i:S';
      var timeless = arguments.length > 2 ? arguments[2] : undefined;

      if (customDateParser) {
        return customDateParser(date, format, timeless, locale);
      }

      return parseDate(date, format, timeless, locale);
    };
  };

  var buildDateFormatter = function buildDateFormatter(locale, customDateFormatter) {
    return function (date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y-m-d H:i:S';

      if (customDateFormatter) {
        return customDateFormatter(date, format, locale);
      }

      return formatDate(date, format, locale);
    };
  };
  /**
   * it two dates are in the same month
   */


  function isSameMonth(date1, date2) {
    return !!date1 && !!date2 && date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
  }
  /**
   * it two dates are in the same day
   */


  function isSameDay(date1, date2) {
    return isSameMonth(date1, date2) && (date1 === null || date1 === void 0 ? void 0 : date1.getDate()) === (date2 === null || date2 === void 0 ? void 0 : date2.getDate());
  }

  function dayIsPartOfTheConditions(day, condition, dateParser, dateFormat) {
    if (!day) {
      return false;
    }

    if (typeof condition === 'function') {
      return condition(day);
    }

    if (typeof condition === 'string' || condition instanceof String) {
      var disabledDate = dateParser(condition, dateFormat);
      return isSameDay(disabledDate, day);
    }

    if (condition instanceof Date) {
      return isSameDay(condition, day);
    }

    if (Array.isArray(condition)) {
      return condition.some(function (c) {
        return dayIsPartOfTheConditions(day, c, dateParser, dateFormat);
      });
    }

    return false;
  }

  function dateIsOutOfRange(date, min, max) {
    var dateParser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var dateFormat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var minDate;

    if (typeof min === 'string' || min instanceof String) {
      if (!dateParser) {
        throw new Error('strings needs a date parser');
      }

      if (!dateFormat) {
        throw new Error('strings needs a date format');
      }

      minDate = dateParser(min, dateFormat);
    } else {
      minDate = min;
    }

    var maxDate;

    if (typeof max === 'string' || max instanceof String) {
      if (!dateParser) {
        throw new Error('strings needs a date parser');
      }

      if (!dateFormat) {
        throw new Error('strings needs a date format');
      }

      maxDate = dateParser(max, dateFormat);
    } else {
      maxDate = max;
    }

    var time = date.getTime();

    if (minDate && maxDate) {
      return time < minDate.getTime() || time > maxDate.getTime();
    }

    if (minDate) {
      return time < minDate.getTime();
    }

    if (maxDate) {
      return time > maxDate.getTime();
    }

    return false;
  }

  function addDays(date) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var result = new Date(date);
    result.setDate(result.getDate() + amount);
    return result;
  }

  function addMonths(date) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var newDate = new Date(date.valueOf());
    newDate.setMonth(date.getMonth() + amount); // Means the current day has less days so the extra month is
    // in the following month

    if (newDate.getDate() !== date.getDate()) {
      // Assign the last day of previous month
      newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 0);
    }

    return newDate;
  }

  function addYears(date) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var newDate = new Date(date.valueOf());
    newDate.setFullYear(date.getFullYear() + amount); // Means the current day has less days so the extra month is
    // in the following month

    if (newDate.getDate() !== date.getDate()) {
      // Assign the last day of previous month
      newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 0);
    }

    return newDate;
  }

  function _lastDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  var getYearsRange = function getYearsRange(date, yearsPerView) {
    var currentYear = date.getFullYear();
    var from = currentYear - Math.floor(currentYear % yearsPerView);
    var to = from + yearsPerView - 1;
    return [from, to];
  };

  var CalendarView;

  (function (CalendarView) {
    CalendarView["Day"] = "day";
    CalendarView["Month"] = "month";
    CalendarView["Year"] = "year";
  })(CalendarView || (CalendarView = {}));

  var TDatepickerNavigator = Vue__default['default'].extend({
    name: 'TDatepickerNavigator',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      value: {
        type: Date,
        default: null
      },
      showSelector: {
        type: Boolean,
        default: true
      },
      currentView: {
        type: String,
        default: CalendarView.Day,
        validator: function validator(value) {
          return [CalendarView.Day, CalendarView.Month, CalendarView.Year].includes(value);
        }
      },
      parse: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      },
      dateFormat: {
        type: String,
        required: true
      },
      yearsPerView: {
        type: Number,
        required: true
      },
      maxDate: {
        type: [Date, String],
        default: undefined
      },
      minDate: {
        type: [Date, String],
        default: undefined
      },
      locale: {
        type: Object,
        required: true
      }
    },
    data: function data() {
      return {
        localValue: new Date(this.value.valueOf())
      };
    },
    computed: {
      isDayView: function isDayView() {
        return this.currentView === CalendarView.Day;
      },
      isYearView: function isYearView() {
        return this.currentView === CalendarView.Year;
      },
      isMonthView: function isMonthView() {
        return this.currentView === CalendarView.Month;
      },
      nextDate: function nextDate() {
        return this.getNextDate();
      },
      prevDate: function prevDate() {
        return this.getPrevDate();
      },
      prevButtonIsDisabled: function prevButtonIsDisabled() {
        return !this.prevDate;
      },
      nextButtonIsDisabled: function nextButtonIsDisabled() {
        return !this.nextDate;
      },
      nextButtonAriaLabel: function nextButtonAriaLabel() {
        if (this.isDayView) {
          return "Next ".concat(this.locale.yearAriaLabel);
        }

        return "Next ".concat(this.locale.yearAriaLabel);
      },
      prevButtonAriaLabel: function prevButtonAriaLabel() {
        if (this.isDayView) {
          return "Prev ".concat(this.locale.yearAriaLabel);
        }

        return "Prev ".concat(this.locale.yearAriaLabel);
      }
    },
    watch: {
      value: function value(_value8) {
        this.localValue = new Date(_value8.valueOf());
      }
    },
    methods: {
      getNextDate: function getNextDate() {
        var nextDate;

        if (this.currentView === CalendarView.Day) {
          nextDate = this.getNextMonth();
        } else if (this.currentView === CalendarView.Month) {
          nextDate = this.getNextYear();
        } else if (this.currentView === CalendarView.Year) {
          nextDate = this.getNextYearGroup();
        }

        return nextDate;
      },
      getPrevDate: function getPrevDate() {
        var prevDate;

        if (this.currentView === CalendarView.Day) {
          prevDate = this.getPrevMonth();
        } else if (this.currentView === CalendarView.Month) {
          prevDate = this.getPrevYear();
        } else if (this.currentView === CalendarView.Year) {
          prevDate = this.getPrevYearGroup();
        }

        return prevDate;
      },
      inputHandler: function inputHandler(newDate) {
        this.$emit('input', newDate);
      },
      clickHandler: function clickHandler() {
        if (this.currentView === CalendarView.Day) {
          this.$emit('update-view', CalendarView.Month);
        } else if (this.currentView === CalendarView.Month) {
          this.$emit('update-view', CalendarView.Year);
        } else if (this.currentView === CalendarView.Year) {
          this.$emit('update-view', CalendarView.Day);
        }
      },
      next: function next() {
        if (this.nextDate) {
          this.inputHandler(this.nextDate);
        }
      },
      prev: function prev() {
        if (this.prevDate) {
          this.inputHandler(this.prevDate);
        }
      },
      getPrevMonth: function getPrevMonth() {
        var prevMonth = addMonths(this.localValue, -1);
        var dateParser = this.parse;

        if (!dateIsOutOfRange(prevMonth, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
          return prevMonth;
        }

        var day = prevMonth.getDate();
        var dateToTry = prevMonth;
        var validDate;
        day = prevMonth.getDate();

        var lastDay = _lastDayOfMonth(prevMonth).getDate();

        do {
          dateToTry = addDays(dateToTry, 1);
          day += 1;

          if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
            validDate = dateToTry;
          }
        } while (day <= lastDay && !validDate);

        if (!validDate) {
          day = prevMonth.getDate();

          do {
            dateToTry = addDays(dateToTry, -1);
            day -= 1;

            if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
              validDate = dateToTry;
            }
          } while (day >= 1 && !validDate);
        }

        return validDate;
      },
      getNextMonth: function getNextMonth() {
        var nextMonth = addMonths(this.localValue, 1);
        var dateParser = this.parse;

        if (!dateIsOutOfRange(nextMonth, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
          return nextMonth;
        }

        var day = nextMonth.getDate();
        var dateToTry = nextMonth;
        var validDate;

        do {
          dateToTry = addDays(dateToTry, -1);
          day -= 1;

          if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
            validDate = dateToTry;
          }
        } while (day >= 1 && !validDate);

        if (!validDate) {
          day = nextMonth.getDate();

          var lastDay = _lastDayOfMonth(nextMonth).getDate();

          do {
            dateToTry = addDays(dateToTry, 1);
            day += 1;

            if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
              validDate = dateToTry;
            }
          } while (day <= lastDay && !validDate);
        }

        return validDate;
      },
      getPrevYear: function getPrevYear() {
        var prevYear = addYears(this.localValue, -1);
        var dateParser = this.parse;

        if (!dateIsOutOfRange(prevYear, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
          return prevYear;
        }

        var validDate;
        var dateToTry = prevYear;
        var year = prevYear.getFullYear();

        do {
          dateToTry = addDays(dateToTry, 1);

          if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
            validDate = dateToTry;
          }
        } while (dateToTry.getFullYear() === year && !validDate);

        if (!validDate) {
          do {
            dateToTry = addDays(dateToTry, -1);

            if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
              validDate = dateToTry;
            }
          } while (dateToTry.getFullYear() === year && !validDate);
        }

        return validDate;
      },
      getNextYear: function getNextYear() {
        var nextYear = addYears(this.localValue, 1);
        var dateParser = this.parse;

        if (!dateIsOutOfRange(nextYear, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
          return nextYear;
        }

        var validDate;
        var dateToTry = nextYear;
        var year = nextYear.getFullYear();

        do {
          dateToTry = addDays(dateToTry, -1);

          if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
            validDate = dateToTry;
          }
        } while (dateToTry.getFullYear() === year && !validDate);

        if (!validDate) {
          do {
            dateToTry = addDays(dateToTry, 1);

            if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
              validDate = dateToTry;
            }
          } while (dateToTry.getFullYear() === year && !validDate);
        }

        return validDate;
      },
      getPrevYearGroup: function getPrevYearGroup() {
        var prevYear = addYears(this.localValue, -this.yearsPerView);
        var dateParser = this.parse;

        if (!dateIsOutOfRange(prevYear, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
          return prevYear;
        }

        var validDate;
        var dateToTry = prevYear;
        var year = prevYear.getFullYear();

        do {
          dateToTry = addDays(dateToTry, this.yearsPerView);

          if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
            validDate = dateToTry;
          }
        } while (dateToTry.getFullYear() === year && !validDate);

        if (!validDate) {
          do {
            dateToTry = addDays(dateToTry, -this.yearsPerView);

            if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
              validDate = dateToTry;
            }
          } while (dateToTry.getFullYear() === year && !validDate);
        }

        return validDate;
      },
      getNextYearGroup: function getNextYearGroup() {
        var nextYear = addYears(this.localValue, this.yearsPerView);
        var dateParser = this.parse;

        if (!dateIsOutOfRange(nextYear, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
          return nextYear;
        }

        var validDate;
        var dateToTry = nextYear;
        var year = nextYear.getFullYear();

        do {
          dateToTry = addDays(dateToTry, -this.yearsPerView);

          if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
            validDate = dateToTry;
          }
        } while (dateToTry.getFullYear() === year && !validDate);

        if (!validDate) {
          do {
            dateToTry = addDays(dateToTry, this.yearsPerView);

            if (!dateIsOutOfRange(dateToTry, this.minDate, this.maxDate, dateParser, this.dateFormat)) {
              validDate = dateToTry;
            }
          } while (dateToTry.getFullYear() === year && !validDate);
        }

        return validDate;
      }
    },
    render: function render(createElement) {
      var subElements = [];

      if (this.showSelector) {
        var buttonElements = [];

        if (this.currentView === CalendarView.Day) {
          buttonElements.push(createElement('span', {
            class: this.getElementCssClass('navigatorViewButtonMonthName')
          }, this.formatNative(this.localValue, 'F')));
        }

        if (this.currentView === CalendarView.Month || this.currentView === CalendarView.Day) {
          buttonElements.push(createElement('span', {
            class: this.getElementCssClass('navigatorViewButtonYear')
          }, this.formatNative(this.localValue, 'Y')));
        }

        if (this.currentView !== CalendarView.Year) {
          buttonElements.push(createElement('svg', {
            attrs: {
              fill: 'currentColor',
              xmlns: 'http://www.w3.org/2000/svg',
              viewBox: '0 0 20 20'
            },
            class: this.getElementCssClass('navigatorViewButtonIcon')
          }, [createElement('polygon', {
            attrs: {
              points: '12.9497475 10.7071068 13.6568542 10 8 4.34314575 6.58578644 5.75735931 10.8284271 10 6.58578644 14.2426407 8 15.6568542 12.9497475 10.7071068'
            }
          })]));
        } else {
          buttonElements.push(createElement('svg', {
            attrs: {
              fill: 'currentColor',
              xmlns: 'http://www.w3.org/2000/svg',
              viewBox: '0 0 20 20'
            },
            class: this.getElementCssClass('navigatorViewButtonBackIcon')
          }, [createElement('polygon', {
            attrs: {
              points: '7.05025253 9.29289322 6.34314575 10 12 15.6568542 13.4142136 14.2426407 9.17157288 10 13.4142136 5.75735931 12 4.34314575'
            }
          })]));
          buttonElements.push(createElement('span', {
            class: this.getElementCssClass('navigatorViewButtonYearRange')
          }, getYearsRange(this.localValue, this.yearsPerView).join(' - ')));
        }

        subElements.push(createElement('button', {
          attrs: {
            type: 'button',
            class: this.getElementCssClass('navigatorViewButton'),
            tabindex: -1
          },
          on: {
            click: this.clickHandler
          }
        }, buttonElements));
      } else {
        subElements.push(createElement('span', {
          attrs: {
            class: this.getElementCssClass('navigatorLabel')
          }
        }, [createElement('span', {
          class: this.getElementCssClass('navigatorLabelMonth')
        }, this.formatNative(this.localValue, 'F')), createElement('span', {
          class: this.getElementCssClass('navigatorLabelYear')
        }, this.formatNative(this.localValue, 'Y'))]));
      }

      if (this.showSelector) {
        subElements.push(createElement('button', {
          ref: 'prev',
          attrs: {
            'aria-label': this.prevButtonAriaLabel,
            type: 'button',
            class: this.getElementCssClass('navigatorPrevButton'),
            tabindex: -1,
            disabled: this.prevButtonIsDisabled ? true : undefined
          },
          on: {
            click: this.prev
          }
        }, [createElement('svg', {
          attrs: {
            fill: 'none',
            viewBox: '0 0 24 24',
            stroke: 'currentColor'
          },
          class: this.getElementCssClass('navigatorPrevButtonIcon')
        }, [createElement('path', {
          attrs: {
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'stroke-width': 2,
            d: 'M15 19l-7-7 7-7'
          }
        })])]));
        subElements.push(createElement('button', {
          ref: 'next',
          attrs: {
            'aria-label': this.nextButtonAriaLabel,
            type: 'button',
            class: this.getElementCssClass('navigatorNextButton'),
            tabindex: -1,
            disabled: this.nextButtonIsDisabled ? true : undefined
          },
          on: {
            click: this.next
          }
        }, [createElement('svg', {
          attrs: {
            fill: 'none',
            viewBox: '0 0 24 24',
            stroke: 'currentColor'
          },
          class: this.getElementCssClass('navigatorNextButtonIcon')
        }, [createElement('path', {
          attrs: {
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'stroke-width': 2,
            d: 'M9 5l7 7-7 7'
          }
        })])]));
      }

      return createElement('div', {
        class: this.getElementCssClass('navigator')
      }, subElements);
    }
  });
  var TDatepickerTrigger = Vue__default['default'].extend({
    name: 'TDatepickerTrigger',
    props: {
      id: {
        type: String,
        default: undefined
      },
      name: {
        type: String,
        default: undefined
      },
      disabled: {
        type: Boolean,
        default: undefined
      },
      readonly: {
        type: Boolean,
        default: undefined
      },
      autofocus: {
        type: Boolean,
        default: undefined
      },
      required: {
        type: Boolean,
        default: undefined
      },
      tabindex: {
        type: [String, Number],
        default: undefined
      },
      inputName: {
        type: String,
        default: undefined
      },
      placeholder: {
        type: String,
        default: undefined
      },
      show: {
        type: Function,
        default: undefined
      },
      hideIfFocusOutside: {
        type: Function,
        default: undefined
      },
      conjunction: {
        type: String,
        required: true
      },
      multiple: {
        type: Boolean,
        required: true
      },
      range: {
        type: Boolean,
        required: true
      },
      clearable: {
        type: Boolean,
        required: true
      },
      locale: {
        type: Object,
        required: true
      },
      userFormatedDate: {
        type: [String, Array],
        required: true
      },
      formatedDate: {
        type: [String, Array],
        required: true
      },
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      hasFocus: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      hasValue: function hasValue() {
        if (Array.isArray(this.value)) {
          return this.value.length > 0;
        }

        return !!this.value;
      }
    },
    methods: {
      clearButtonClickHandler: function clearButtonClickHandler(e) {
        this.$emit('clear', e);
      }
    },
    render: function render(createElement) {
      var _this30 = this;

      var formattedDate = this.formatedDate;
      var formText = '';

      if (Array.isArray(this.userFormatedDate)) {
        var conjunction = this.range ? this.locale.rangeSeparator : this.conjunction;
        formText = this.userFormatedDate.join(conjunction);
      } else {
        formText = this.userFormatedDate;
      }

      var subElements = [createElement('input', {
        ref: 'input',
        class: this.getElementCssClass('input'),
        attrs: {
          // Prevents
          readonly: !this.hasFocus ? this.readonly : true,
          inputmode: 'none',
          id: this.id,
          name: this.name,
          disabled: this.disabled,
          autocomplete: 'off',
          autofocus: this.autofocus,
          type: 'text',
          required: this.required,
          placeholder: this.placeholder,
          tabindex: this.tabindex,
          value: formText
        },
        on: {
          click: function click(e) {
            if (_this30.show) {
              _this30.show();
            }

            _this30.$emit('click', e);
          },
          input: function input(e) {
            _this30.$emit('input', e);
          },
          keydown: function keydown(e) {
            _this30.$emit('keydown', e);
          },
          blur: function blur(e) {
            if (_this30.hideIfFocusOutside) {
              _this30.hideIfFocusOutside(e);
            }

            _this30.$emit('blur', e);
          },
          focus: function focus(e) {
            if (_this30.show) {
              _this30.show();
            }

            _this30.$emit('focus', e);
          }
        }
      })];

      if (this.clearable && this.hasValue) {
        var clearButtonSlot = this.$scopedSlots.clearButton ? this.$scopedSlots.clearButton({
          className: this.getElementCssClass('clearButtonIcon'),
          formatedDate: this.formatedDate,
          userFormatedDate: this.userFormatedDate,
          value: this.value,
          activeDate: this.activeDate
        }) : [createElement('svg', {
          attrs: {
            fill: 'currentColor',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20'
          },
          class: this.getElementCssClass('clearButtonIcon')
        }, [createElement('polygon', {
          attrs: {
            points: '10 8.58578644 2.92893219 1.51471863 1.51471863 2.92893219 8.58578644 10 1.51471863 17.0710678 2.92893219 18.4852814 10 11.4142136 17.0710678 18.4852814 18.4852814 17.0710678 11.4142136 10 18.4852814 2.92893219 17.0710678 1.51471863 10 8.58578644'
          }
        })])];
        subElements.push(createElement('button', {
          ref: 'clearButton',
          class: this.getElementCssClass('clearButton'),
          attrs: {
            type: 'button',
            tabindex: -1
          },
          on: {
            click: this.clearButtonClickHandler
          }
        }, clearButtonSlot));
      }

      if (this.multiple) {
        var dates = Array.isArray(formattedDate) ? formattedDate : [formattedDate];
        var hiddenInputs = dates.map(function (date) {
          return createElement('input', {
            attrs: {
              type: 'hidden',
              value: date,
              name: _this30.name,
              disabled: _this30.disabled,
              readonly: _this30.readonly,
              required: _this30.required
            }
          });
        });
        subElements.push.apply(subElements, _toConsumableArray(hiddenInputs));
      } else {
        subElements.push(createElement('input', {
          attrs: {
            type: 'hidden',
            value: Array.isArray(formattedDate) ? formattedDate.join(this.conjunction) : formattedDate,
            name: this.name,
            disabled: this.disabled,
            readonly: this.readonly,
            required: this.required
          }
        }));
      }

      return createElement('div', {
        class: this.getElementCssClass('inputWrapper')
      }, subElements);
    }
  });
  var TDatepickerViewsViewCalendarDaysDay = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewCalendarDaysDay',
    props: {
      day: {
        type: Date,
        required: true
      },
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      activeMonth: {
        type: Date,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      parse: {
        type: Function,
        required: true
      },
      format: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      },
      dateFormat: {
        type: String,
        required: true
      },
      userFormat: {
        type: String,
        required: true
      },
      showDaysForOtherMonth: {
        type: Boolean,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      disabledDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      highlightDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      maxDate: {
        type: [Date, String],
        default: undefined
      },
      minDate: {
        type: [Date, String],
        default: undefined
      },
      range: {
        type: Boolean,
        required: true
      },
      dateWithoutTime: {
        type: Date,
        default: null
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf()),
        localActiveMonth: new Date(this.activeMonth.valueOf())
      };
    },
    computed: {
      isSelected: function isSelected() {
        var d1 = this.getDay();
        var d2 = this.getSelectedDay();

        if (d2 instanceof Date) {
          return isSameDay(d1, d2);
        }

        if (Array.isArray(d2)) {
          return d2.some(function (d) {
            return isSameDay(d, d1);
          });
        }

        return false;
      },
      isActive: function isActive() {
        var d1 = this.getDay();
        var d2 = this.localActiveDate;
        return isSameDay(d1, d2);
      },
      isToday: function isToday() {
        var d1 = this.getDay();
        var d2 = new Date();
        return isSameDay(d1, d2);
      },
      isDisabled: function isDisabled() {
        var day = this.getDay();
        var disabledDates = this.disabledDates;
        var dateParser = this.parse;
        return dateIsOutOfRange(day, this.minDate, this.maxDate, dateParser, this.dateFormat) || dayIsPartOfTheConditions(day, disabledDates, dateParser, this.dateFormat);
      },
      isHighlighted: function isHighlighted() {
        var day = this.getDay();
        var highlightDates = this.highlightDates;
        var dateParser = this.parse;
        return dayIsPartOfTheConditions(day, highlightDates, dateParser, this.dateFormat);
      },
      isForAnotherMonth: function isForAnotherMonth() {
        var d1 = this.localActiveMonth;
        var d2 = this.getDay();
        return d1.getFullYear() !== d2.getFullYear() || d1.getMonth() !== d2.getMonth();
      },
      isInRange: function isInRange() {
        if (!this.range || !Array.isArray(this.value)) {
          return false;
        }

        var _this$value = _slicedToArray(this.value, 2),
            from = _this$value[0],
            to = _this$value[1];

        if (from && to) {
          return !dateIsOutOfRange(this.getDay(), addDays(from, 1), addDays(to, -1));
        }

        return false;
      },
      isFirstDayOfRange: function isFirstDayOfRange() {
        if (!this.range || !Array.isArray(this.value)) {
          return false;
        }

        var _this$value2 = _slicedToArray(this.value, 1),
            from = _this$value2[0];

        return from && isSameDay(from, this.getDay());
      },
      isLastDayOfRange: function isLastDayOfRange() {
        if (!this.range || !Array.isArray(this.value)) {
          return false;
        }

        var _this$value3 = _slicedToArray(this.value, 2),
            to = _this$value3[1];

        return to && isSameDay(to, this.getDay());
      },
      dayFormatted: function dayFormatted() {
        return this.formatNative(this.getDay(), 'j');
      },
      ariaLabel: function ariaLabel() {
        return this.format(this.getDay(), this.userFormat);
      },
      dateFormatted: function dateFormatted() {
        return this.format(this.getDay(), 'Y-m-d');
      }
    },
    watch: {
      activeDate: function activeDate(_activeDate) {
        this.localActiveDate = new Date(_activeDate.valueOf());
      },
      activeMonth: function activeMonth(_activeMonth) {
        this.localActiveMonth = new Date(_activeMonth.valueOf());
      }
    },
    methods: {
      getClass: function getClass() {
        if (this.isForAnotherMonth) {
          return this.getElementCssClass('otherMonthDay');
        }

        if (this.isFirstDayOfRange) {
          return this.getElementCssClass('inRangeFirstDay');
        }

        if (this.isLastDayOfRange) {
          return this.getElementCssClass('inRangeLastDay');
        }

        if (this.isInRange) {
          return this.getElementCssClass('inRangeDay');
        }

        if (this.isSelected) {
          return this.getElementCssClass('selectedDay');
        }

        if (this.isActive && this.showActiveDate) {
          return this.getElementCssClass('activeDay');
        }

        if (this.isHighlighted) {
          return this.getElementCssClass('highlightedDay');
        }

        if (this.isToday) {
          return this.getElementCssClass('today');
        }

        return this.getElementCssClass('day');
      },
      getDay: function getDay() {
        return this.day;
      },
      getSelectedDay: function getSelectedDay() {
        if (this.dateWithoutTime !== null) {
          return this.dateWithoutTime;
        }

        return this.value;
      }
    },
    render: function render(createElement) {
      var _this31 = this;

      if (this.isForAnotherMonth && !this.showDaysForOtherMonth) {
        return createElement('span', {
          class: this.getElementCssClass('emptyDay')
        }, '');
      }

      var daySlot = this.$scopedSlots.day ? this.$scopedSlots.day({
        dayFormatted: this.dayFormatted,
        isForAnotherMonth: this.isForAnotherMonth,
        isFirstDayOfRange: this.isFirstDayOfRange,
        isLastDayOfRange: this.isLastDayOfRange,
        isInRange: this.isInRange,
        isSelected: this.isSelected,
        isActive: this.isActive,
        isHighlighted: this.isHighlighted,
        isToday: this.isToday,
        day: this.getDay(),
        activeDate: this.activeDate,
        value: this.value
      }) : this.dayFormatted;
      return createElement('button', {
        class: this.getClass(),
        attrs: {
          'aria-label': this.ariaLabel,
          'aria-current': this.isToday ? 'date' : undefined,
          'data-date': this.dateFormatted,
          type: 'button',
          tabindex: -1,
          disabled: this.isDisabled ? true : undefined
        },
        on: {
          click: function click(e) {
            return _this31.$emit('click', e);
          }
        }
      }, daySlot);
    }
  });
  var TDatepickerViewsViewCalendarDays = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewCalendarDays',
    props: {
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      activeMonth: {
        type: Date,
        required: true
      },
      weekStart: {
        type: Number,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      parse: {
        type: Function,
        required: true
      },
      format: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      },
      userFormat: {
        type: String,
        required: true
      },
      dateFormat: {
        type: String,
        required: true
      },
      showDaysForOtherMonth: {
        type: Boolean,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      disabledDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      highlightDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      maxDate: {
        type: [Date, String],
        default: undefined
      },
      minDate: {
        type: [Date, String],
        default: undefined
      },
      range: {
        type: Boolean,
        required: true
      },
      timepicker: {
        type: Boolean,
        required: true
      },
      dateWithoutTime: {
        type: Date,
        default: null
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf()),
        localActiveMonth: new Date(this.activeMonth.valueOf())
      };
    },
    computed: {
      firstDayOfMonth: function firstDayOfMonth() {
        var localActiveDate = new Date(this.localActiveMonth.valueOf());
        localActiveDate.setDate(1);
        return localActiveDate;
      },
      lastDayOfMonth: function lastDayOfMonth() {
        return _lastDayOfMonth(this.localActiveMonth);
      },
      firstDayOfPrevMonth: function firstDayOfPrevMonth() {
        return new Date(this.localActiveMonth.getFullYear(), this.localActiveMonth.getMonth() - 1, 1);
      },
      lastDayOfPrevMonth: function lastDayOfPrevMonth() {
        var localActiveDate = new Date(this.localActiveMonth.valueOf());
        localActiveDate.setDate(0);
        return localActiveDate;
      },
      firstDayOfNextMonth: function firstDayOfNextMonth() {
        var localActiveDate = new Date(this.localActiveMonth.valueOf());
        localActiveDate.setDate(1);
        localActiveDate.setMonth(this.localActiveMonth.getMonth() + 1);
        return localActiveDate;
      },
      monthDays: function monthDays() {
        var _this32 = this;

        return Array.from({
          length: this.lastDayOfMonth.getDate()
        }, function (_x, i) {
          return i + 1;
        }).map(function (day) {
          return _this32.getDay(_this32.localActiveMonth, day);
        });
      },
      prevMonthDays: function prevMonthDays() {
        var _this33 = this;

        var prevMonthTotalDays = this.firstDayOfMonth.getDay() - this.weekStart;

        if (prevMonthTotalDays < 0) {
          prevMonthTotalDays = 7 + prevMonthTotalDays;
        }

        return Array.from({
          length: prevMonthTotalDays
        }, function (_x, i) {
          return _this33.lastDayOfPrevMonth.getDate() - i;
        }).reverse().map(function (day) {
          return _this33.getDay(_this33.firstDayOfPrevMonth, day);
        });
      },
      nextMonthDays: function nextMonthDays() {
        var _this34 = this;

        var nextMonthTotalDays = 7 - this.monthDays.concat(this.prevMonthDays).length % 7;

        if (nextMonthTotalDays === 7) {
          return [];
        }

        return Array.from({
          length: nextMonthTotalDays
        }, function (_x, i) {
          return i + 1;
        }).map(function (day) {
          return _this34.getDay(_this34.firstDayOfNextMonth, day);
        });
      },
      days: function days() {
        var prevMonthDays = this.prevMonthDays;
        var monthDays = this.monthDays;
        var nextMonthDays = this.nextMonthDays;
        return prevMonthDays.concat(monthDays, nextMonthDays);
      }
    },
    watch: {
      activeDate: function activeDate(_activeDate2) {
        this.localActiveDate = new Date(_activeDate2.valueOf());
      },
      activeMonth: function activeMonth(_activeMonth2) {
        this.localActiveMonth = new Date(_activeMonth2.valueOf());
      }
    },
    methods: {
      getDay: function getDay(date, dayNumber) {
        var day = new Date(date.valueOf());
        day.setDate(dayNumber);
        return day;
      }
    },
    render: function render(createElement) {
      var _this35 = this;

      return createElement('div', {
        class: this.getElementCssClass('calendarDaysWrapper')
      }, this.days.map(function (day) {
        return createElement('span', {
          class: _this35.getElementCssClass('calendarDaysDayWrapper')
        }, [createElement(TDatepickerViewsViewCalendarDaysDay, {
          props: {
            day: day,
            value: _this35.value,
            activeDate: _this35.localActiveDate,
            activeMonth: _this35.localActiveMonth,
            getElementCssClass: _this35.getElementCssClass,
            parse: _this35.parse,
            format: _this35.format,
            formatNative: _this35.formatNative,
            dateFormat: _this35.dateFormat,
            userFormat: _this35.userFormat,
            showDaysForOtherMonth: _this35.showDaysForOtherMonth,
            showActiveDate: _this35.showActiveDate,
            disabledDates: _this35.disabledDates,
            highlightDates: _this35.highlightDates,
            minDate: _this35.minDate,
            maxDate: _this35.maxDate,
            range: _this35.range,
            dateWithoutTime: _this35.dateWithoutTime
          },
          scopedSlots: _this35.$scopedSlots,
          on: {
            click: function click() {
              if (_this35.timepicker) {
                _this35.$emit('input-date', day);
              } else {
                _this35.$emit('input', day);
              }
            }
          }
        })]);
      }));
    }
  });
  var TDatepickerViewsViewCalendarHeaders = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewCalendarHeaders',
    props: {
      weekStart: {
        type: Number,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      }
    },
    computed: {
      weekDays: function weekDays() {
        var _this36 = this;

        return Array.from({
          length: 7
        }, function (_x, i) {
          var weekDay = _this36.weekStart + i;

          if (weekDay >= 7) {
            return weekDay - 7;
          }

          return weekDay;
        }).map(this.getWeekDayName);
      }
    },
    methods: {
      getWeekDayName: function getWeekDayName(weekDay) {
        var date = new Date();
        date.setDate((date.getDate() + (7 + weekDay - date.getDay())) % 7);
        return this.formatNative(date, 'D');
      }
    },
    render: function render(createElement) {
      var _this37 = this;

      return createElement('div', {
        class: this.getElementCssClass('calendarHeaderWrapper')
      }, this.weekDays.map(function (weekDayName) {
        return createElement('span', {
          class: _this37.getElementCssClass('calendarHeaderWeekDay')
        }, weekDayName);
      }));
    }
  });
  var TDatepickerViewsViewCalendar = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewCalendar',
    props: {
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      activeMonth: {
        type: Date,
        required: true
      },
      weekStart: {
        type: Number,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      parse: {
        type: Function,
        required: true
      },
      format: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      },
      dateFormat: {
        type: String,
        required: true
      },
      userFormat: {
        type: String,
        required: true
      },
      monthsPerView: {
        type: Number,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      disabledDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      highlightDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      maxDate: {
        type: [Date, String],
        default: undefined
      },
      minDate: {
        type: [Date, String],
        default: undefined
      },
      range: {
        type: Boolean,
        required: true
      },
      showDaysForOtherMonth: {
        type: Boolean,
        required: true
      },
      timepicker: {
        type: Boolean,
        required: true
      },
      dateWithoutTime: {
        type: Date,
        default: null
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf()),
        localActiveMonth: new Date(this.activeMonth.valueOf())
      };
    },
    watch: {
      activeDate: function activeDate(_activeDate3) {
        this.localActiveDate = new Date(_activeDate3.valueOf());
      },
      activeMonth: function activeMonth(_activeMonth3) {
        this.localActiveMonth = new Date(_activeMonth3.valueOf());
      }
    },
    render: function render(createElement) {
      var _this38 = this;

      return createElement('div', {
        class: this.getElementCssClass('calendarWrapper')
      }, [createElement(TDatepickerViewsViewCalendarHeaders, {
        props: {
          weekStart: this.weekStart,
          getElementCssClass: this.getElementCssClass,
          formatNative: this.formatNative
        }
      }), createElement(TDatepickerViewsViewCalendarDays, {
        ref: 'days',
        props: {
          value: this.value,
          activeDate: this.localActiveDate,
          activeMonth: this.localActiveMonth,
          weekStart: this.weekStart,
          getElementCssClass: this.getElementCssClass,
          parse: this.parse,
          format: this.format,
          formatNative: this.formatNative,
          userFormat: this.userFormat,
          dateFormat: this.dateFormat,
          showDaysForOtherMonth: this.monthsPerView > 1 ? false : this.showDaysForOtherMonth,
          showActiveDate: this.showActiveDate,
          disabledDates: this.disabledDates,
          highlightDates: this.highlightDates,
          minDate: this.minDate,
          maxDate: this.maxDate,
          range: this.range,
          timepicker: this.timepicker,
          dateWithoutTime: this.dateWithoutTime
        },
        scopedSlots: this.$scopedSlots,
        on: {
          input: function input(date) {
            return _this38.$emit('input', date);
          },
          'input-date': function inputDate(date) {
            return _this38.$emit('input-date', date);
          }
        }
      })]);
    }
  });
  var TDatepickerViewsViewMonthsMonth = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewMonthsMonth',
    props: {
      month: {
        type: Date,
        required: true
      },
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      isSelected: function isSelected() {
        var d1 = this.getMonth();
        var d2 = this.value;

        if (d2 instanceof Date) {
          return isSameMonth(d1, d2);
        }

        if (Array.isArray(d2)) {
          return d2.some(function (d) {
            return isSameMonth(d, d1);
          });
        }

        return false;
      },
      isActive: function isActive() {
        var d1 = this.getMonth();
        var d2 = this.activeDate;
        return isSameMonth(d1, d2);
      },
      monthFormatted: function monthFormatted() {
        return this.formatNative(this.getMonth(), 'M');
      }
    },
    methods: {
      getClass: function getClass() {
        if (this.isSelected) {
          return this.getElementCssClass('selectedMonth');
        }

        if (this.isActive && this.showActiveDate) {
          return this.getElementCssClass('activeMonth');
        }

        return this.getElementCssClass('month');
      },
      getMonth: function getMonth() {
        return this.month;
      }
    },
    render: function render(createElement) {
      var _this39 = this;

      var monthSlot = this.$scopedSlots.month ? this.$scopedSlots.month({
        monthFormatted: this.monthFormatted,
        isSelected: this.isSelected,
        isActive: this.isActive,
        month: this.getMonth(),
        activeDate: this.activeDate,
        value: this.value
      }) : this.monthFormatted;
      return createElement('button', {
        class: this.getClass(),
        attrs: {
          'aria-label': this.formatNative(this.getMonth(), 'F, Y'),
          'data-date': this.formatNative(this.getMonth(), 'Y-m'),
          type: 'button',
          tabindex: -1
        },
        on: {
          click: function click(e) {
            return _this39.$emit('click', e);
          }
        }
      }, monthSlot);
    }
  });
  var TDatepickerViewsViewMonths = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewMonths',
    props: {
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf())
      };
    },
    computed: {
      months: function months() {
        var _this40 = this;

        return Array.from({
          length: 12
        }, function (_x, i) {
          return i;
        }).map(function (monthNumber) {
          return _this40.getMonth(monthNumber);
        });
      }
    },
    watch: {
      activeDate: function activeDate(_activeDate4) {
        this.localActiveDate = new Date(_activeDate4.valueOf());
      }
    },
    methods: {
      getMonth: function getMonth(monthNumber) {
        var newDate = new Date(this.localActiveDate.valueOf());
        newDate.setMonth(monthNumber); // Means the current day has less days so the extra month is
        // in the following month

        if (newDate.getDate() !== this.localActiveDate.getDate()) {
          // Assign the last day of previous month
          newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 0);
        }

        return newDate;
      }
    },
    render: function render(createElement) {
      var _this41 = this;

      return createElement('div', {
        class: this.getElementCssClass('monthWrapper')
      }, this.months.map(function (month) {
        return createElement(TDatepickerViewsViewMonthsMonth, {
          props: {
            month: month,
            value: _this41.value,
            activeDate: _this41.localActiveDate,
            getElementCssClass: _this41.getElementCssClass,
            showActiveDate: _this41.showActiveDate,
            formatNative: _this41.formatNative
          },
          scopedSlots: _this41.$scopedSlots,
          on: {
            click: function click() {
              return _this41.$emit('input', month);
            }
          }
        });
      }));
    }
  });
  var TDatepickerViewsViewYearsYear = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewYearsYear',
    props: {
      year: {
        type: Date,
        required: true
      },
      activeDate: {
        type: Date,
        required: true
      },
      value: {
        type: [Date, Array],
        default: null
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf())
      };
    },
    computed: {
      isSelected: function isSelected() {
        var d1 = this.getYear();
        var d2 = this.value;

        if (d2 instanceof Date) {
          return d1.getFullYear() === d2.getFullYear();
        }

        if (Array.isArray(d2)) {
          return d2.some(function (d) {
            return d.getFullYear() === d1.getFullYear();
          });
        }

        return false;
      },
      isActive: function isActive() {
        var d1 = this.getYear();
        var d2 = this.activeDate;
        return d2 && d1.getFullYear() === d2.getFullYear();
      },
      yearFormatted: function yearFormatted() {
        return this.formatNative(this.getYear(), 'Y');
      }
    },
    watch: {
      activeDate: function activeDate(_activeDate5) {
        this.localActiveDate = new Date(_activeDate5.valueOf());
      }
    },
    methods: {
      getClass: function getClass() {
        if (this.isSelected) {
          return this.getElementCssClass('selectedYear');
        }

        if (this.isActive && this.showActiveDate) {
          return this.getElementCssClass('activeYear');
        }

        return this.getElementCssClass('year');
      },
      getYear: function getYear() {
        return this.year;
      }
    },
    render: function render(createElement) {
      var _this42 = this;

      var yearSlot = this.$scopedSlots.year ? this.$scopedSlots.year({
        yearFormatted: this.yearFormatted,
        isSelected: this.isSelected,
        isActive: this.isActive,
        year: this.getYear(),
        activeDate: this.activeDate,
        value: this.value
      }) : this.yearFormatted;
      return createElement('button', {
        class: this.getClass(),
        attrs: {
          'aria-label': this.yearFormatted,
          'data-date': this.yearFormatted,
          type: 'button',
          tabindex: -1
        },
        on: {
          click: function click(e) {
            return _this42.$emit('click', e);
          }
        }
      }, yearSlot);
    }
  });
  var TDatepickerViewsViewYears = Vue__default['default'].extend({
    name: 'TDatepickerViewsViewYears',
    props: {
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      yearsPerView: {
        type: Number,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf())
      };
    },
    computed: {
      years: function years() {
        var _this43 = this;

        var _getYearsRange = getYearsRange(this.localActiveDate, this.yearsPerView),
            _getYearsRange2 = _slicedToArray(_getYearsRange, 1),
            initialYear = _getYearsRange2[0];

        return Array.from({
          length: this.yearsPerView
        }, function (_x, i) {
          return i;
        }).map(function (year) {
          return _this43.getYear(initialYear + year);
        });
      }
    },
    watch: {
      activeDate: function activeDate(_activeDate6) {
        this.localActiveDate = new Date(_activeDate6.valueOf());
      }
    },
    methods: {
      getYear: function getYear(year) {
        var newDate = new Date(this.localActiveDate.valueOf());
        newDate.setFullYear(year); // Means the current day has less days so the extra month is
        // in the following month

        if (newDate.getDate() !== this.localActiveDate.getDate()) {
          // Assign the last day of previous month
          newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 0);
        }

        return newDate;
      }
    },
    render: function render(createElement) {
      var _this44 = this;

      return createElement('div', {
        class: this.getElementCssClass('yearWrapper')
      }, this.years.map(function (year) {
        return createElement(TDatepickerViewsViewYearsYear, {
          props: {
            year: year,
            activeDate: _this44.localActiveDate,
            value: _this44.value,
            getElementCssClass: _this44.getElementCssClass,
            showActiveDate: _this44.showActiveDate,
            formatNative: _this44.formatNative
          },
          scopedSlots: _this44.$scopedSlots,
          on: {
            click: function click() {
              return _this44.$emit('input', year);
            }
          }
        });
      }));
    }
  });
  var TDatepickerViewsView = Vue__default['default'].extend({
    name: 'TDatepickerViewsView',
    props: {
      value: {
        type: [Date, Array],
        default: null
      },
      activeMonth: {
        type: Date,
        required: true
      },
      activeDate: {
        type: Date,
        required: true
      },
      weekStart: {
        type: Number,
        required: true
      },
      lang: {
        type: String,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      },
      parse: {
        type: Function,
        required: true
      },
      format: {
        type: Function,
        required: true
      },
      userFormat: {
        type: String,
        required: true
      },
      dateFormat: {
        type: String,
        required: true
      },
      monthsPerView: {
        type: Number,
        required: true
      },
      monthIndex: {
        type: Number,
        required: true
      },
      currentView: {
        type: String,
        required: true
      },
      yearsPerView: {
        type: Number,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      showDaysForOtherMonth: {
        type: Boolean,
        required: true
      },
      disabledDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      highlightDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      maxDate: {
        type: [Date, String],
        default: undefined
      },
      minDate: {
        type: [Date, String],
        default: undefined
      },
      range: {
        type: Boolean,
        required: true
      },
      locale: {
        type: Object,
        required: true
      },
      timepicker: {
        type: Boolean,
        required: true
      },
      dateWithoutTime: {
        type: Date,
        default: null
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf()),
        localActiveMonth: new Date(this.activeMonth.valueOf())
      };
    },
    computed: {
      isFirstMonth: function isFirstMonth() {
        return this.monthIndex === 0;
      },
      isLastMonth: function isLastMonth() {
        return this.monthIndex === this.monthsPerView - 1;
      },
      showMonthName: function showMonthName() {
        return this.monthsPerView > 1;
      }
    },
    watch: {
      activeDate: function activeDate(_activeDate7) {
        this.localActiveDate = new Date(_activeDate7.valueOf());
      },
      activeMonth: function activeMonth(_activeMonth4) {
        this.localActiveMonth = new Date(_activeMonth4.valueOf());
      }
    },
    methods: {
      inputHandler: function inputHandler(date) {
        this.resetView();
        this.$emit('input', date);
      },
      inputDateHandler: function inputDateHandler(date) {
        this.$emit('input-date', date);
      },
      viewInputActiveDateHandler: function viewInputActiveDateHandler(date) {
        this.resetView();
        this.inputActiveDateHandler(date);
      },
      inputActiveDateHandler: function inputActiveDateHandler(date) {
        this.$emit('input-active-date', date);
        this.resetFocus();
      },
      resetFocus: function resetFocus() {
        this.$emit('reset-focus');
      },
      resetView: function resetView() {
        this.$emit('reset-view');
      }
    },
    render: function render(createElement) {
      var _this45 = this;

      var subElements = [];
      subElements.push(createElement(TDatepickerNavigator, {
        ref: 'navigator',
        props: {
          value: this.localActiveMonth,
          getElementCssClass: this.getElementCssClass,
          showSelector: this.isFirstMonth,
          currentView: this.currentView,
          parse: this.parse,
          formatNative: this.formatNative,
          dateFormat: this.dateFormat,
          yearsPerView: this.yearsPerView,
          minDate: this.minDate,
          maxDate: this.maxDate,
          locale: this.locale
        },
        on: {
          input: this.inputActiveDateHandler,
          'update-view': function updateView(newView) {
            _this45.$emit('update-view', newView);
          }
        }
      }));

      if (this.currentView === CalendarView.Day) {
        subElements.push(createElement(TDatepickerViewsViewCalendar, {
          ref: 'calendar',
          props: {
            value: this.value,
            activeMonth: this.localActiveMonth,
            activeDate: this.localActiveDate,
            weekStart: this.weekStart,
            getElementCssClass: this.getElementCssClass,
            showDaysForOtherMonth: this.showDaysForOtherMonth,
            parse: this.parse,
            format: this.format,
            formatNative: this.formatNative,
            dateFormat: this.dateFormat,
            userFormat: this.userFormat,
            monthsPerView: this.monthsPerView,
            showActiveDate: this.showActiveDate,
            disabledDates: this.disabledDates,
            highlightDates: this.highlightDates,
            minDate: this.minDate,
            maxDate: this.maxDate,
            range: this.range,
            timepicker: this.timepicker,
            dateWithoutTime: this.dateWithoutTime
          },
          scopedSlots: this.$scopedSlots,
          on: {
            input: this.inputHandler,
            'input-date': this.inputDateHandler
          }
        }));
      } else if (this.currentView === CalendarView.Month) {
        subElements.push(createElement(TDatepickerViewsViewMonths, {
          ref: 'months',
          props: {
            value: this.value,
            activeDate: this.localActiveDate,
            getElementCssClass: this.getElementCssClass,
            showActiveDate: this.showActiveDate,
            formatNative: this.formatNative
          },
          scopedSlots: this.$scopedSlots,
          on: {
            input: this.viewInputActiveDateHandler
          }
        }));
      } else if (this.currentView === CalendarView.Year) {
        subElements.push(createElement(TDatepickerViewsViewYears, {
          ref: 'years',
          props: {
            value: this.value,
            activeDate: this.localActiveDate,
            getElementCssClass: this.getElementCssClass,
            yearsPerView: this.yearsPerView,
            showActiveDate: this.showActiveDate,
            formatNative: this.formatNative
          },
          scopedSlots: this.$scopedSlots,
          on: {
            input: this.viewInputActiveDateHandler
          }
        }));
      }

      return createElement('div', {
        class: this.getElementCssClass('view')
      }, subElements);
    }
  });
  var TDatepickerViews = Vue__default['default'].extend({
    name: 'TDatepickerViews',
    props: {
      value: {
        type: [Date, Array],
        default: null
      },
      activeDate: {
        type: Date,
        required: true
      },
      weekStart: {
        type: Number,
        required: true
      },
      monthsPerView: {
        type: Number,
        required: true
      },
      lang: {
        type: String,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      },
      parse: {
        type: Function,
        required: true
      },
      format: {
        type: Function,
        required: true
      },
      formatNative: {
        type: Function,
        required: true
      },
      dateFormat: {
        type: String,
        required: true
      },
      userFormat: {
        type: String,
        required: true
      },
      initialView: {
        type: String,
        required: true
      },
      currentView: {
        type: String,
        required: true
      },
      yearsPerView: {
        type: Number,
        required: true
      },
      showActiveDate: {
        type: Boolean,
        required: true
      },
      showDaysForOtherMonth: {
        type: Boolean,
        required: true
      },
      disabledDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      highlightDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      maxDate: {
        type: [Date, String],
        default: undefined
      },
      minDate: {
        type: [Date, String],
        default: undefined
      },
      range: {
        type: Boolean,
        required: true
      },
      locale: {
        type: Object,
        required: true
      },
      timepicker: {
        type: Boolean,
        required: true
      },
      dateWithoutTime: {
        type: Date,
        default: null
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf())
      };
    },
    computed: {
      activeMonths: function activeMonths() {
        var _this46 = this;

        return Array.from({
          length: this.monthsPerView
        }, function (_x, i) {
          return i;
        }).map(function (i) {
          return addMonths(_this46.localActiveDate, i);
        });
      }
    },
    watch: {
      activeDate: function activeDate(_activeDate8) {
        this.localActiveDate = new Date(_activeDate8.valueOf());
      }
    },
    render: function render(createElement) {
      var _this47 = this;

      var subElements = this.activeMonths.map(function (activeMonth, index) {
        return createElement(TDatepickerViewsView, {
          ref: 'view',
          props: {
            value: _this47.value,
            activeMonth: activeMonth,
            activeDate: _this47.localActiveDate,
            weekStart: _this47.weekStart,
            lang: _this47.lang,
            getElementCssClass: _this47.getElementCssClass,
            parse: _this47.parse,
            format: _this47.format,
            dateFormat: _this47.dateFormat,
            userFormat: _this47.userFormat,
            formatNative: _this47.formatNative,
            monthsPerView: _this47.monthsPerView,
            monthIndex: index,
            currentView: index === 0 ? _this47.currentView : _this47.initialView,
            yearsPerView: _this47.yearsPerView,
            showActiveDate: _this47.showActiveDate,
            disabledDates: _this47.disabledDates,
            highlightDates: _this47.highlightDates,
            minDate: _this47.minDate,
            maxDate: _this47.maxDate,
            range: _this47.range,
            showDaysForOtherMonth: _this47.showDaysForOtherMonth,
            locale: _this47.locale,
            timepicker: _this47.timepicker,
            dateWithoutTime: _this47.dateWithoutTime
          },
          scopedSlots: _this47.$scopedSlots,
          on: {
            input: function input(date) {
              _this47.$emit('input', date);
            },
            'input-date': function inputDate(date) {
              _this47.$emit('input-date', date);
            },
            'input-time': function inputTime(date) {
              _this47.$emit('input-time', date);
            },
            'input-active-date': function inputActiveDate(date) {
              _this47.$emit('input-active-date', date);
            },
            'update-view': function updateView(newView) {
              _this47.$emit('update-view', newView);
            },
            'reset-view': function resetView() {
              _this47.$emit('reset-view');
            },
            'reset-focus': function resetFocus() {
              _this47.$emit('reset-focus');
            }
          }
        });
      });
      return createElement('div', {
        class: this.getElementCssClass('viewGroup')
      }, subElements);
    }
  });

  var isChecked = function isChecked(model, value) {
    if (Array.isArray(model)) {
      return model.indexOf(value) >= 0;
    }

    return model === value;
  };

  var TToggle = HtmlInput.extend({
    name: 'TToggle',
    props: {
      value: {
        type: [String, Object, Number, Boolean, Array],
        default: true
      },
      uncheckedValue: {
        type: [String, Object, Number, Boolean, Array],
        default: false
      },
      model: {
        // v-model
        type: [String, Object, Number, Boolean, Array],
        default: undefined
      },
      checked: {
        type: Boolean,
        default: undefined
      },
      tabindex: {
        type: [String, Number],
        default: 0
      },
      uncheckedPlaceholder: {
        type: String,
        default: undefined
      },
      checkedPlaceholder: {
        type: String,
        default: undefined
      },
      uncheckedLabel: {
        type: String,
        default: undefined
      },
      checkedLabel: {
        type: String,
        default: undefined
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            wrapper: 'bg-gray-100 rounded-full border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            wrapperChecked: 'bg-blue-500 rounded-full border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            wrapperDisabled: 'bg-gray-100 rounded-full border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            wrapperCheckedDisabled: 'bg-blue-500 rounded-full border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            button: 'h-5 w-5 rounded-full bg-white shadow flex items-center justify-center text-gray-400 text-xs',
            buttonChecked: 'h-5 w-5 rounded-full bg-white shadow flex items-center justify-center text-blue-500 text-xs',
            checkedPlaceholder: 'rounded-full w-5 h-5 flex items-center justify-center text-gray-400 text-xs',
            uncheckedPlaceholder: 'rounded-full w-5 h-5 flex items-center justify-center text-gray-400 text-xs'
          };
        }
      },
      fixedClasses: {
        type: [String, Array, Object],
        default: function _default() {
          return {
            wrapper: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200',
            wrapperChecked: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200',
            wrapperDisabled: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200 opacity-50 cursor-not-allowed',
            wrapperCheckedDisabled: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200 opacity-50 cursor-not-allowed',
            button: 'inline-block absolute transform translate-x-0 transition ease-in-out duration-200',
            buttonChecked: 'inline-block absolute transform translate-x-full transition ease-in-out duration-200',
            checkedPlaceholder: 'inline-block',
            uncheckedPlaceholder: 'inline-block'
          };
        }
      }
    },
    model: {
      prop: 'model',
      event: 'input'
    },
    data: function data() {
      var checked = typeof this.checked === 'boolean' && typeof this.model === 'undefined' ? this.checked : isChecked(this.model, this.value);
      return {
        isChecked: checked
      };
    },
    computed: {
      isDisabled: function isDisabled() {
        return this.disabled || this.readonly;
      },
      currentValue: function currentValue() {
        return this.isChecked ? this.value : this.uncheckedValue;
      }
    },
    watch: {
      model: function model(_model2) {
        this.isChecked = isChecked(_model2, this.value);
      },
      isChecked: function isChecked(checked) {
        var localValue;

        if (Array.isArray(this.model)) {
          localValue = _toConsumableArray(this.model);
          var index = localValue.indexOf(this.value);

          if (checked && index < 0) {
            localValue.push(this.value);
          } else if (!checked && index >= 0) {
            localValue.splice(index, 1);
          }
        } else {
          localValue = this.currentValue;
        }

        this.$emit('input', localValue);
        this.$emit('change', localValue); // Emit update event to prop

        this.$emit('update:checked', checked);
      }
    },
    methods: {
      blurHandler: function blurHandler(e) {
        this.$emit('blur', e);
      },
      focusHandler: function focusHandler(e) {
        this.$emit('focus', e);
      },
      getElement: function getElement() {
        return this.$el;
      },
      blur: function blur() {
        this.getElement().blur();
      },
      click: function click() {
        this.getElement().click();
      },
      spaceHandler: function spaceHandler(e) {
        e.preventDefault();
        this.toggleValue();
      },
      clickHandler: function clickHandler() {
        this.toggleValue();
      },
      toggleValue: function toggleValue() {
        if (this.isDisabled) {
          return;
        }

        this.isChecked = !this.isChecked;
      },
      setChecked: function setChecked(checked) {
        this.isChecked = checked;
      },
      focus: function focus(options) {
        this.getElement().focus(options);
      }
    },
    render: function render(createElement) {
      var _this48 = this;

      var wrapperClass;

      if (this.isDisabled) {
        if (this.isChecked) {
          wrapperClass = this.getElementCssClass('wrapperCheckedDisabled');
        } else {
          wrapperClass = this.getElementCssClass('wrapperDisabled');
        }
      } else if (this.isChecked) {
        wrapperClass = this.getElementCssClass('wrapperChecked');
      } else {
        wrapperClass = this.getElementCssClass('wrapper');
      }

      var defaultSlot = this.$scopedSlots.default ? this.$scopedSlots.default({
        value: this.currentValue,
        uncheckedValue: this.uncheckedValue,
        isChecked: this.isChecked
      }) : null;

      if (!defaultSlot) {
        defaultSlot = this.isChecked ? this.checkedLabel : this.uncheckedLabel;
      }

      var checkedslot = this.$scopedSlots.checked ? this.$scopedSlots.checked({
        value: this.currentValue,
        uncheckedValue: this.uncheckedValue,
        isChecked: this.isChecked
      }) : null;

      if (this.checkedPlaceholder && !checkedslot) {
        checkedslot = this.checkedPlaceholder;
      }

      var uncheckedSlot = this.$scopedSlots.unchecked ? this.$scopedSlots.unchecked({
        value: this.currentValue,
        uncheckedValue: this.uncheckedValue,
        isChecked: this.isChecked
      }) : null;

      if (this.uncheckedPlaceholder && !uncheckedSlot) {
        uncheckedSlot = this.uncheckedPlaceholder;
      }

      return createElement('span', {
        class: wrapperClass,
        attrs: {
          role: 'checkbox',
          id: this.id,
          tabindex: this.tabindex,
          autofocus: this.autofocus,
          'aria-checked': this.isChecked ? 'true' : 'false'
        },
        on: {
          blur: this.blurHandler,
          focus: this.focusHandler,
          click: function click(e) {
            _this48.clickHandler();

            _this48.$emit('click', e);
          },
          keydown: function keydown(e) {
            if (e.keyCode === Key$1.SPACE) {
              _this48.spaceHandler(e);
            }

            _this48.$emit('keydown', e);
          }
        }
      }, [createElement('input', {
        ref: 'input',
        attrs: {
          value: this.currentValue,
          type: 'hidden',
          name: this.name,
          disabled: this.disabled,
          readonly: this.readonly,
          required: this.required
        }
      }), createElement('span', {
        class: this.getElementCssClass('checkedPlaceholder'),
        attrs: {
          'aria-hidden': 'true'
        }
      }, checkedslot), createElement('span', {
        class: this.getElementCssClass('uncheckedPlaceholder'),
        attrs: {
          'aria-hidden': 'true'
        }
      }, uncheckedSlot), createElement('span', {
        ref: 'button',
        class: this.isChecked ? this.getElementCssClass('buttonChecked') : this.getElementCssClass('button'),
        attrs: {
          'aria-hidden': 'true'
        }
      }, defaultSlot)]);
    }
  });

  var isNumeric = function isNumeric(char) {
    return /^\d+$/.test(String(char));
  };

  var TDatepickerTimeSelector = Vue__default['default'].extend({
    name: 'TDatepickerTimeSelector',
    props: {
      parse: {
        type: Function,
        required: true
      },
      format: {
        type: Function,
        required: true
      },
      amPm: {
        type: Boolean,
        required: true
      },
      showSeconds: {
        type: Boolean,
        required: true
      },
      activeDate: {
        type: Date,
        required: true
      },
      locale: {
        type: Object,
        required: true
      },
      getElementCssClass: {
        type: Function,
        required: true
      }
    },
    data: function data() {
      return {
        localActiveDate: new Date(this.activeDate.valueOf()),
        alreadyTriedAnInvalidValue: false,
        lastValidValue: '',
        timeInputKeys: []
      };
    },
    computed: {
      amPmFormatted: function amPmFormatted() {
        if (!this.amPm) {
          return null;
        }

        return this.format(this.localActiveDate, 'K');
      },
      minutesFormatted: function minutesFormatted() {
        return this.format(this.localActiveDate, 'i');
      },
      hoursFormatted: function hoursFormatted() {
        if (this.amPm) {
          return this.format(this.localActiveDate, 'G');
        }

        return this.format(this.localActiveDate, 'H');
      },
      secondsFormatted: function secondsFormatted() {
        return this.format(this.localActiveDate, 'S');
      }
    },
    watch: {
      timeInputKeys: function timeInputKeys(_timeInputKeys) {
        var numbers = _timeInputKeys.join('').substr(this.showSeconds ? -6 : -4);

        var minutesInput = this.$refs.minutes;
        var hoursInput = this.$refs.hours;
        var fullTime = numbers.padStart(this.showSeconds ? 6 : 4, ' ').substr(this.showSeconds ? -6 : -4);

        if (this.showSeconds) {
          var secondsInput = this.$refs.seconds;
          secondsInput.value = fullTime.substr(4, 2).trim();
          minutesInput.value = fullTime.substr(2, 2).trim();
          hoursInput.value = fullTime.substr(0, 2).trim();
        } else {
          minutesInput.value = fullTime.substr(2, 2).trim();
          hoursInput.value = fullTime.substr(0, 2).trim();
        }
      },
      activeDate: function activeDate(_activeDate9) {
        this.localActiveDate = new Date(_activeDate9.valueOf());
        this.lastValidValue = '';
        this.alreadyTriedAnInvalidValue = false;
        this.timeInputKeys = [];
      }
    },
    methods: {
      handleFullTimeBlur: function handleFullTimeBlur(e) {
        var _this49 = this;

        this.$emit('blur', e);

        if (!this.timeInputKeys.length) {
          return;
        }

        var numbers = this.timeInputKeys.filter(function (key) {
          return isNumeric(key);
        }).join('').substr(this.showSeconds ? -6 : -4);
        var fullTime = numbers.padStart(this.showSeconds ? 6 : 4, '0').substr(this.showSeconds ? -6 : -4);
        var time;

        if (this.showSeconds) {
          if (this.amPm && Number(fullTime.substr(0, 2)) <= 12) {
            var formattedIntendedTime = "".concat(fullTime.substr(0, 2), ":").concat(fullTime.substr(2, 2), ":").concat(fullTime.substr(4, 2), " ").concat(this.amPmFormatted);
            time = this.parse(formattedIntendedTime, 'H:i:S K');
          } else {
            var _formattedIntendedTime = "".concat(fullTime.substr(0, 2), ":").concat(fullTime.substr(2, 2), ":").concat(fullTime.substr(4, 2));

            time = this.parse(_formattedIntendedTime, 'G:i:S');
          }
        } else if (this.amPm && Number(fullTime.substr(0, 2)) <= 12) {
          var _formattedIntendedTime2 = "".concat(fullTime.substr(0, 2), ":").concat(fullTime.substr(2, 2), " ").concat(this.amPmFormatted);

          time = this.parse(_formattedIntendedTime2, 'H:i K');
        } else {
          var _formattedIntendedTime3 = "".concat(fullTime.substr(0, 2), ":").concat(fullTime.substr(2, 2));

          time = this.parse(_formattedIntendedTime3, 'G:i');
        }

        if (time instanceof Date && !Number.isNaN(time)) {
          this.setHours(time.getHours());
          this.setMinutes(time.getMinutes());
          this.setSeconds(time.getSeconds());
          this.$emit('input', this.localActiveDate);
          this.$nextTick(function () {
            _this49.updateSecondsInput();

            _this49.updateMinutesInput();

            _this49.updateHoursInput();
          });
        }

        this.focusNextElementFullTimeSelector();
      },
      focusNextElementFullTimeSelector: function focusNextElementFullTimeSelector() {
        if (this.amPm) {
          this.$refs.amPm.focus();
        } else {
          this.focusOkButton();
        }
      },
      focusOkButton: function focusOkButton() {
        this.$refs.okButton.focus();
      },
      handleTimeInputFocus: function handleTimeInputFocus(e) {
        var input = e.target;
        input.focus();
        setTimeout(function () {
          input.setSelectionRange(0, 2);
        }, 1);
      },
      handleTimeInput: function handleTimeInput(e, maxValue, minValue, valueHandler) {
        var input = e.target;
        var value = input.value;

        if (value === '') {
          return;
        }

        var numericValue = Number(value);
        var keyPressed = Number(e.data);

        if (!isNumeric(numericValue)) {
          input.value = this.lastValidValue;
          return;
        }

        if (numericValue > maxValue || numericValue < minValue) {
          if (isNumeric(keyPressed)) {
            if (this.alreadyTriedAnInvalidValue) {
              input.value = String(keyPressed);
              input.dispatchEvent(new Event('input'));
              this.alreadyTriedAnInvalidValue = false;
              return;
            }

            this.alreadyTriedAnInvalidValue = true;
          }

          input.value = this.lastValidValue;
          return;
        }

        valueHandler(numericValue);
        this.alreadyTriedAnInvalidValue = false;
        this.lastValidValue = value;
      },
      setHours: function setHours(hours) {
        var newDate = new Date(this.localActiveDate.valueOf());
        newDate.setHours(hours);
        this.localActiveDate = newDate;
      },
      setMinutes: function setMinutes(minutes) {
        var newDate = new Date(this.localActiveDate.valueOf());
        newDate.setMinutes(minutes);
        this.localActiveDate = newDate;
      },
      setSeconds: function setSeconds(seconds) {
        var newDate = new Date(this.localActiveDate.valueOf());
        newDate.setSeconds(seconds);
        this.localActiveDate = newDate;
      },
      updateSecondsInput: function updateSecondsInput() {
        if (!this.showSeconds) {
          return;
        }

        var seconds = this.$refs.seconds;

        if (seconds) {
          seconds.value = this.secondsFormatted;
        }
      },
      updateMinutesInput: function updateMinutesInput() {
        var minutes = this.$refs.minutes;

        if (minutes) {
          minutes.value = this.minutesFormatted;
        }
      },
      updateHoursInput: function updateHoursInput() {
        var hours = this.$refs.hours;

        if (hours) {
          hours.value = this.hoursFormatted;
        }
      },
      focus: function focus() {
        var timeInput = this.$refs.timeInput;

        if (timeInput) {
          timeInput.focus();
        }
      }
    },
    render: function render(createElement) {
      var _this50 = this;

      var subElements = [];
      var label = createElement('label', {
        class: this.getElementCssClass('timepickerTimeLabel')
      }, this.locale.timeLabel);
      var timePickerInputs = [createElement('input', {
        ref: 'hours',
        class: this.getElementCssClass('timepickerInput'),
        domProps: {
          value: this.hoursFormatted
        },
        attrs: {
          inputmode: 'numeric',
          type: 'text',
          contenteditable: false
        },
        on: {
          input: function input(e) {
            var maxHours = _this50.amPm ? 12 : 23;
            var minHours = _this50.amPm ? 1 : 0;

            _this50.handleTimeInput(e, maxHours, minHours, function (hours) {
              if (_this50.amPm) {
                if (hours === 12) {
                  _this50.setHours(_this50.amPmFormatted === _this50.locale.amPM[1] ? hours : 0);
                } else {
                  _this50.setHours(_this50.amPmFormatted === _this50.locale.amPM[1] ? hours + 12 : hours);
                }
              } else {
                _this50.setHours(hours);
              }
            });
          },
          blur: function blur(e) {
            _this50.$emit('blur', e);

            _this50.$emit('input', _this50.localActiveDate);

            _this50.$nextTick(function () {
              _this50.updateHoursInput();
            });
          },
          focus: function focus(e) {
            _this50.handleTimeInputFocus(e);
          }
        }
      }), createElement('span', {
        class: this.getElementCssClass('timepickerTimeSeparator'),
        attrs: {
          contenteditable: false
        }
      }, ':'), createElement('input', {
        ref: 'minutes',
        class: this.getElementCssClass('timepickerInput'),
        domProps: {
          value: this.minutesFormatted
        },
        attrs: {
          inputmode: 'numeric',
          type: 'text',
          contenteditable: false
        },
        on: {
          input: function input(e) {
            var maxMinutes = 59;
            var minMinutes = 0;

            _this50.handleTimeInput(e, maxMinutes, minMinutes, _this50.setMinutes);
          },
          blur: function blur(e) {
            _this50.$emit('blur', e);

            _this50.$emit('input', _this50.localActiveDate);

            _this50.$nextTick(function () {
              _this50.updateMinutesInput();
            });
          },
          focus: function focus(e) {
            _this50.handleTimeInputFocus(e);
          }
        }
      })];

      if (this.showSeconds) {
        timePickerInputs.push(createElement('span', {
          class: this.getElementCssClass('timepickerTimeSeparator'),
          attrs: {
            contenteditable: false
          }
        }, ':'));
        timePickerInputs.push(createElement('input', {
          ref: 'seconds',
          class: this.getElementCssClass('timepickerInput'),
          domProps: {
            value: this.secondsFormatted
          },
          attrs: {
            inputmode: 'numeric',
            type: 'text',
            contenteditable: false
          },
          on: {
            input: function input(e) {
              var maxSeconds = 59;
              var minSeconds = 0;

              _this50.handleTimeInput(e, maxSeconds, minSeconds, _this50.setSeconds);
            },
            blur: function blur(e) {
              _this50.$emit('blur', e);

              _this50.$emit('input', _this50.localActiveDate);

              _this50.$nextTick(function () {
                _this50.updateSecondsInput();
              });
            },
            focus: function focus(e) {
              _this50.handleTimeInputFocus(e);
            }
          }
        }));
      }

      var timePickerElements = [createElement('div', {
        ref: 'timeInput',
        class: this.getElementCssClass('timepickerTimeFieldsWrapper'),
        style: {
          caretColor: 'transparent'
        },
        attrs: {
          tabindex: 0,
          inputmode: 'numeric',
          contenteditable: true
        },
        on: {
          keydown: function keydown(e) {
            if (e.target !== _this50.$refs.timeInput) {
              return;
            }

            e.preventDefault();
            var key = e.key;

            if (key === 'Enter') {
              _this50.focusNextElementFullTimeSelector();
            } else if (key === 'Backspace') {
              _this50.timeInputKeys.pop();
            }

            if (isNumeric(key)) {
              _this50.timeInputKeys.push(key);
            }
          },
          blur: this.handleFullTimeBlur
        }
      }, timePickerInputs)];

      if (this.amPm) {
        timePickerElements.push(createElement(TToggle, {
          ref: 'amPm',
          props: {
            model: this.amPmFormatted,
            value: this.locale.amPM[1],
            uncheckedValue: this.locale.amPM[0],
            checkedPlaceholder: this.locale.amPM[0],
            uncheckedPlaceholder: this.locale.amPM[1],
            checkedLabel: this.locale.amPM[1],
            uncheckedLabel: this.locale.amPM[0],
            fixedClasses: {
              wrapper: '',
              wrapperChecked: '',
              wrapperDisabled: '',
              wrapperCheckedDisabled: '',
              button: '',
              buttonChecked: '',
              checkedPlaceholder: '',
              uncheckedPlaceholder: ''
            },
            classes: {
              wrapper: this.getElementCssClass('timepickerAmPmWrapper'),
              wrapperChecked: this.getElementCssClass('timepickerAmPmWrapperChecked'),
              wrapperDisabled: this.getElementCssClass('timepickerAmPmWrapperDisabled'),
              wrapperCheckedDisabled: this.getElementCssClass('timepickerAmPmWrapperCheckedDisabled'),
              button: this.getElementCssClass('timepickerAmPmButton'),
              buttonChecked: this.getElementCssClass('timepickerAmPmButtonChecked'),
              checkedPlaceholder: this.getElementCssClass('timepickerAmPmCheckedPlaceholder'),
              uncheckedPlaceholder: this.getElementCssClass('timepickerAmPmUncheckedPlaceholder')
            }
          },
          on: {
            blur: function blur(e) {
              return _this50.$emit('blur', e);
            },
            input: function input(amOrPM) {
              var formattedDate = _this50.format(new Date(_this50.localActiveDate.valueOf()), 'Y-m-d G:i:S');

              var newActiveDate = _this50.parse("".concat(formattedDate, " ").concat(amOrPM), 'Y-m-d G:i:S K');

              _this50.$emit('input', newActiveDate);
            },
            keydown: function keydown(e) {
              var key = e.key;

              if (key === 'Enter') {
                _this50.focusOkButton();
              }
            }
          }
        }));
      }

      timePickerElements.push(createElement('a', {
        ref: 'okButton',
        attrs: {
          href: '#'
        },
        class: this.getElementCssClass('timepickerOkButton'),
        on: {
          blur: function blur(e) {
            return _this50.$emit('blur', e);
          },
          click: function click(e) {
            e.preventDefault();

            _this50.$emit('submit', _this50.localActiveDate);
          }
        }
      }, this.locale.okLabel));
      var timePickerWrapper = createElement('div', {
        class: this.getElementCssClass('timepickerTimeWrapper')
      }, timePickerElements);
      subElements.push(label);
      subElements.push(timePickerWrapper);
      return createElement('div', {
        class: this.getElementCssClass('timepickerWrapper')
      }, subElements);
    }
  });

  var getInitialActiveDate = function getInitialActiveDate(localValue, initialDate, dateFormat, parse, amPm, initialTime) {
    if (Array.isArray(localValue) && localValue.length) {
      return localValue[localValue.length - 1];
    }

    if (localValue instanceof Date) {
      return localValue;
    }

    var activeDate = parse(initialDate, dateFormat) || new Date();

    if (initialTime) {
      var parsedDateWithTime = parse(initialTime, amPm ? 'G:i:S K' : 'H:i:S');

      if (parsedDateWithTime) {
        activeDate.setHours(parsedDateWithTime.getHours());
        activeDate.setMinutes(parsedDateWithTime.getMinutes());
        activeDate.setSeconds(parsedDateWithTime.getSeconds());
      }
    }

    return activeDate;
  };

  var TDatepicker = HtmlInput.extend({
    name: 'TDatepicker',
    props: {
      value: {
        type: [Date, String, Number, Array],
        default: null
      },
      placeholder: {
        type: String,
        default: undefined
      },
      inputName: {
        type: String,
        default: undefined
      },
      weekStart: {
        type: Number,
        default: 0
      },
      monthsPerView: {
        type: Number,
        default: 1,
        validator: function validator(value) {
          return value >= 1;
        }
      },
      lang: {
        type: String,
        default: 'en'
      },
      locale: {
        type: Object,
        default: function _default() {
          return English;
        }
      },
      locales: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      dateFormat: {
        type: String,
        default: 'Y-m-d'
      },
      userFormat: {
        type: String,
        default: 'F j, Y'
      },
      dateFormatter: {
        type: Function,
        default: undefined
      },
      dateParser: {
        type: Function,
        default: undefined
      },
      closeOnSelect: {
        type: Boolean,
        default: true
      },
      showDaysForOtherMonth: {
        type: Boolean,
        default: true
      },
      show: {
        type: Boolean,
        default: false
      },
      inline: {
        type: Boolean,
        default: false
      },
      initialView: {
        type: String,
        default: CalendarView.Day,
        validator: function validator(value) {
          return [CalendarView.Day, CalendarView.Month, CalendarView.Year].includes(value);
        }
      },
      yearsPerView: {
        type: Number,
        default: 12
      },
      disabledDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      highlightDates: {
        type: [Date, Array, Function, String],
        default: undefined
      },
      maxDate: {
        type: [Date, String],
        default: undefined
      },
      minDate: {
        type: [Date, String],
        default: undefined
      },
      initialDate: {
        type: [Date, String],
        default: undefined
      },
      initialTime: {
        type: String,
        default: undefined
      },
      conjunction: {
        type: String,
        default: ','
      },
      multiple: {
        type: Boolean,
        default: false
      },
      range: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      datepicker: {
        type: Boolean,
        default: true
      },
      timepicker: {
        type: Boolean,
        default: false
      },
      amPm: {
        type: Boolean,
        default: false
      },
      showSeconds: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            wrapper: 'flex flex-col',
            dropdownWrapper: 'relative z-10',
            // Dropdown related classes
            dropdown: 'origin-top-left absolute rounded shadow bg-white overflow-hidden mt-1',
            enterClass: 'opacity-0 scale-95',
            enterActiveClass: 'transition transform ease-out duration-100',
            enterToClass: 'opacity-100 scale-100',
            leaveClass: 'opacity-100 scale-100',
            leaveActiveClass: 'transition transform ease-in duration-75',
            leaveToClass: 'opacity-0 scale-95',
            // Wrapper for inline calendar
            inlineWrapper: '',
            inlineViews: 'rounded bg-white border mt-1 inline-flex flex-col',
            // Text input related classes
            inputWrapper: '',
            input: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
            clearButton: 'hover:bg-gray-100 rounded transition duration-100 ease-in-out text-gray-600',
            clearButtonIcon: '',
            // Picker views
            viewGroup: '',
            view: '',
            // Navigator
            navigator: 'pt-2 px-3',
            navigatorViewButton: 'transition ease-in-out duration-100 inline-flex cursor-pointer rounded-full px-2 py-1 -ml-1 hover:bg-gray-100',
            navigatorViewButtonIcon: 'fill-current text-gray-400',
            navigatorViewButtonBackIcon: 'fill-current text-gray-400',
            navigatorViewButtonMonth: 'text-gray-700 font-semibold',
            navigatorViewButtonYear: 'text-gray-500 ml-1',
            navigatorViewButtonYearRange: 'text-gray-500 ml-1',
            navigatorLabel: 'py-1',
            navigatorLabelMonth: 'text-gray-700 font-semibold',
            navigatorLabelYear: 'text-gray-500 ml-1',
            navigatorPrevButton: 'transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-100 rounded-full p-1 ml-2 ml-auto disabled:opacity-50 disabled:cursor-not-allowed',
            navigatorNextButton: 'transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-100 rounded-full p-1 -mr-1 disabled:opacity-50 disabled:cursor-not-allowed',
            navigatorPrevButtonIcon: 'text-gray-400',
            navigatorNextButtonIcon: 'text-gray-400',
            // Calendar View
            calendarWrapper: 'px-3 py-2',
            calendarHeaderWrapper: '',
            calendarHeaderWeekDay: 'uppercase text-xs text-gray-500 w-8 h-8 flex items-center justify-center',
            calendarDaysWrapper: '',
            calendarDaysDayWrapper: 'w-full h-8 flex flex-shrink-0 items-center',
            // Day item
            otherMonthDay: 'text-sm rounded-full w-8 h-8 mx-auto hover:bg-blue-100 text-gray-400 disabled:opacity-50 disabled:cursor-not-allowed',
            emptyDay: '',
            inRangeFirstDay: 'text-sm bg-blue-500 text-white w-full h-8 rounded-l-full',
            inRangeLastDay: 'text-sm bg-blue-500 text-white w-full h-8 rounded-r-full',
            inRangeDay: 'text-sm bg-blue-200 w-full h-8 disabled:opacity-50 disabled:cursor-not-allowed',
            selectedDay: 'text-sm rounded-full w-8 h-8 mx-auto bg-blue-500 text-white disabled:opacity-50 disabled:cursor-not-allowed',
            activeDay: 'text-sm rounded-full bg-blue-100 w-8 h-8 mx-auto disabled:opacity-50 disabled:cursor-not-allowed',
            highlightedDay: 'text-sm rounded-full bg-blue-200 w-8 h-8 mx-auto disabled:opacity-50 disabled:cursor-not-allowed',
            day: 'text-sm rounded-full w-8 h-8 mx-auto hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed',
            today: 'text-sm rounded-full w-8 h-8 mx-auto hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed border border-blue-500',
            // Months View
            monthWrapper: 'px-3 py-2',
            selectedMonth: 'text-sm rounded w-full h-12 mx-auto bg-blue-500 text-white',
            activeMonth: 'text-sm rounded w-full h-12 mx-auto bg-blue-100',
            month: 'text-sm rounded w-full h-12 mx-auto hover:bg-blue-100',
            // Years View
            yearWrapper: 'px-3 py-2',
            year: 'text-sm rounded w-full h-12 mx-auto hover:bg-blue-100',
            selectedYear: 'text-sm rounded w-full h-12 mx-auto bg-blue-500 text-white',
            activeYear: 'text-sm rounded w-full h-12 mx-auto bg-blue-100',
            // Time selector
            timepickerWrapper: 'flex items-center px-4 py-2 space-x-2',
            timepickerTimeWrapper: 'flex items-center space-x-2',
            timepickerTimeFieldsWrapper: 'bg-gray-100 rounded-md w-full text-right flex items-center border border-gray-100 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            timepickerOkButton: 'text-blue-600 text-sm uppercase font-semibold transition duration-100 ease-in-out border border-transparent focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 rounded cursor-pointer',
            timepickerInput: 'text-center w-8 border-transparent bg-transparent p-0 h-6 text-sm transition duration-100 ease-in-out border border-transparent focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 rounded',
            timepickerTimeLabel: 'flex-grow text-sm text-gray-500',
            timepickerAmPmWrapper: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out bg-gray-100 border border-transparent rounded cursor-pointer focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            timepickerAmPmWrapperChecked: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out bg-gray-100 border border-transparent rounded cursor-pointer focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            timepickerAmPmWrapperDisabled: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out opacity-50 cursor-not-allowed',
            timepickerAmPmWrapperCheckedDisabled: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out opacity-50 cursor-not-allowed',
            timepickerAmPmButton: 'absolute flex items-center justify-center w-6 h-6 text-xs text-gray-800 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded shadow',
            timepickerAmPmButtonChecked: 'absolute flex items-center justify-center w-6 h-6 text-xs text-gray-800 transition duration-200 ease-in-out transform translate-x-full bg-white rounded shadow',
            timepickerAmPmCheckedPlaceholder: 'flex items-center justify-center w-6 h-6 text-xs text-gray-500 rounded-sm',
            timepickerAmPmUncheckedPlaceholder: 'flex items-center justify-center w-6 h-6 text-xs text-gray-500 rounded-sm'
          };
        }
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {
            navigator: 'flex',
            navigatorViewButton: 'flex items-center',
            navigatorViewButtonIcon: 'flex-shrink-0 h-5 w-5',
            navigatorViewButtonBackIcon: 'flex-shrink-0 h-5 w-5',
            navigatorLabel: 'flex items-center py-1',
            navigatorPrevButtonIcon: 'h-6 w-6 inline-flex',
            navigatorNextButtonIcon: 'h-6 w-6 inline-flex',
            inputWrapper: 'relative',
            viewGroup: 'inline-flex flex-wrap',
            view: 'w-64',
            calendarDaysWrapper: 'grid grid-cols-7',
            calendarHeaderWrapper: 'grid grid-cols-7',
            monthWrapper: 'grid grid-cols-4',
            yearWrapper: 'grid grid-cols-4',
            clearButton: 'flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6',
            clearButtonIcon: 'fill-current h-3 w-3'
          };
        }
      }
    },
    data: function data() {
      var _this51 = this;

      var currentLocale = extractLocaleFromProps(this.lang, this.locales, this.locale);
      var dateFormatter = this.dateFormatter;
      var parse = buildDateParser(currentLocale, this.dateParser);
      var format = buildDateFormatter(currentLocale, dateFormatter); // Keep a native formatter for the different views

      var formatNative = !dateFormatter ? format : buildDateFormatter(currentLocale);
      var localValue = this.multiple || this.range ? [] : null;

      if (Array.isArray(this.value)) {
        localValue = this.value.map(function (value) {
          return parse(value, _this51.dateFormat) || null;
        }).filter(function (value) {
          return !!value;
        });
      } else {
        localValue = parse(this.value, this.dateFormat) || localValue;
      }

      var formatedDate = Array.isArray(localValue) ? localValue.map(function (d) {
        return format(d, _this51.dateFormat);
      }) : format(localValue, this.dateFormat);
      var userFormatedDate = Array.isArray(localValue) ? localValue.map(function (d) {
        return format(d, _this51.userFormat);
      }) : format(localValue, this.userFormat);
      var activeDate = getInitialActiveDate(localValue, this.initialDate, this.dateFormat, parse, this.amPm, this.initialTime); // Used to show the selected month/year

      var currentView = this.initialView;
      var dateWithoutTime = null;

      if (this.timepicker) {
        dateWithoutTime = Array.isArray(localValue) ? localValue[0] : localValue;
      }

      return {
        localValue: localValue,
        formatedDate: formatedDate,
        userFormatedDate: userFormatedDate,
        activeDate: activeDate,
        shown: this.show,
        showActiveDate: false,
        currentView: currentView,
        parse: parse,
        format: format,
        formatNative: formatNative,
        currentLocale: currentLocale,
        hasFocus: false,
        dateWithoutTime: dateWithoutTime,
        timeWithoutDate: null
      };
    },
    computed: {
      visibleRange: function visibleRange() {
        var start = new Date(this.activeDate.valueOf());
        var end = new Date(this.activeDate.valueOf());
        start.setDate(1);
        end.setMonth(end.getMonth() + this.monthsPerView, 0);
        return [start, end];
      },
      latestDate: function latestDate() {
        if (Array.isArray(this.localValue)) {
          if (this.localValue.length) {
            return this.localValue[this.localValue.length - 1] || null;
          }

          return null;
        }

        return this.localValue;
      },
      currentValueIsInTheView: function currentValueIsInTheView() {
        // eslint-disable-next-line no-restricted-globals
        if (this.latestDate) {
          var _this$visibleRange = _slicedToArray(this.visibleRange, 2),
              start = _this$visibleRange[0],
              end = _this$visibleRange[1];

          return compareDates(end, this.latestDate) >= 0 && compareDates(this.latestDate, start) >= 0;
        }

        return true;
      }
    },
    watch: {
      shown: function shown(_shown) {
        this.$emit('update:show', _shown);
      },
      activeDate: function activeDate(_activeDate10) {
        this.$emit('active-change', _activeDate10);
      },
      formatedDate: function formatedDate(_formatedDate) {
        this.$emit('input', _formatedDate);
        this.$emit('change', _formatedDate);
      },
      userFormatedDate: function userFormatedDate(_userFormatedDate) {
        this.$emit('user-date-changed', _userFormatedDate);
      },
      localValue: function localValue(_localValue7) {
        if (this.monthsPerView === 1 || !this.currentValueIsInTheView) {
          this.resetActiveDate(_localValue7);
        }

        this.refreshFormattedDate();
      },
      value: function value(_value9) {
        var _this52 = this;

        if (Array.isArray(_value9)) {
          var localValue = _value9.map(function (v) {
            return _this52.parse(v, _this52.dateFormat) || null;
          }).filter(function (v) {
            return !!v;
          });

          if (!isEqual__default['default'](localValue, this.localValue)) {
            this.localValue = localValue;
          }
        } else {
          this.localValue = this.parse(_value9, this.dateFormat) || (this.multiple || this.range ? [] : null);
        }
      },
      dateParser: function dateParser() {
        this.refreshParser();
      },
      dateFormatter: function dateFormatter() {
        this.refreshFormatter();
      },
      lang: function lang() {
        this.refreshCurrentLocale();
      },
      locale: function locale() {
        this.refreshCurrentLocale();
      },
      locales: {
        handler: function handler() {
          this.refreshCurrentLocale();
        },
        deep: true
      }
    },
    methods: {
      refreshFormattedDate: function refreshFormattedDate() {
        var _this53 = this;

        var formatedDate = Array.isArray(this.localValue) ? this.localValue.map(function (d) {
          return _this53.format(d, _this53.dateFormat);
        }) : this.format(this.localValue, this.dateFormat);
        var userFormatedDate = Array.isArray(this.localValue) ? this.localValue.map(function (d) {
          return _this53.format(d, _this53.userFormat);
        }) : this.format(this.localValue, this.userFormat);
        this.formatedDate = formatedDate;
        this.userFormatedDate = userFormatedDate;
      },
      refreshCurrentLocale: function refreshCurrentLocale() {
        this.currentLocale = extractLocaleFromProps(this.lang, this.locales, this.locale);
        this.refreshParser();
        this.refreshFormatter();
        this.refreshFormattedDate();
      },
      refreshParser: function refreshParser() {
        var parse = buildDateParser(this.currentLocale, this.dateParser);
        this.parse = parse;
      },
      refreshFormatter: function refreshFormatter() {
        var dateFormatter = this.dateFormatter;
        var format = buildDateFormatter(this.currentLocale, dateFormatter); // Keep a native formatter for the different views

        var formatNative = !dateFormatter ? format : buildDateFormatter(this.currentLocale);
        this.format = format;
        this.formatNative = formatNative;
      },
      focus: function focus(options) {
        var wrapper = this.$el;
        var input = wrapper.querySelector('input[type=text]');

        if (!input) {
          throw new Error('Input not found');
        }

        input.focus(options);
      },
      doHide: function doHide() {
        var dropdown = this.getDropdown();

        if (dropdown) {
          dropdown.doHide();
        }
      },
      doShow: function doShow() {
        var dropdown = this.getDropdown();

        if (dropdown) {
          dropdown.doShow();
        }
      },
      toggle: function toggle() {
        var dropdown = this.getDropdown();

        if (dropdown) {
          dropdown.doToggle();
        }
      },
      arrowKeyHandler: function arrowKeyHandler(e) {
        e.preventDefault();
        this.showActiveDate = true;

        if (!this.inline && !this.shown) {
          this.doShow();
          return;
        }

        var newActiveDate;

        if (this.currentView === CalendarView.Day) {
          if (e.keyCode === Key$1.DOWN) {
            newActiveDate = addDays(this.activeDate, 7);
          } else if (e.keyCode === Key$1.LEFT) {
            newActiveDate = addDays(this.activeDate, -1);
          } else if (e.keyCode === Key$1.UP) {
            newActiveDate = addDays(this.activeDate, -7);
          } else if (e.keyCode === Key$1.RIGHT) {
            newActiveDate = addDays(this.activeDate, 1);
          }
        } else if (this.currentView === CalendarView.Month) {
          if (e.keyCode === Key$1.DOWN) {
            newActiveDate = addMonths(this.activeDate, 4);
          } else if (e.keyCode === Key$1.LEFT) {
            newActiveDate = addMonths(this.activeDate, -1);
          } else if (e.keyCode === Key$1.UP) {
            newActiveDate = addMonths(this.activeDate, -4);
          } else if (e.keyCode === Key$1.RIGHT) {
            newActiveDate = addMonths(this.activeDate, 1);
          }
        } else if (this.currentView === CalendarView.Year) {
          if (e.keyCode === Key$1.DOWN) {
            newActiveDate = addYears(this.activeDate, 4);
          } else if (e.keyCode === Key$1.LEFT) {
            newActiveDate = addYears(this.activeDate, -1);
          } else if (e.keyCode === Key$1.UP) {
            newActiveDate = addYears(this.activeDate, -4);
          } else if (e.keyCode === Key$1.RIGHT) {
            newActiveDate = addYears(this.activeDate, 1);
          }
        }

        if (newActiveDate && !dateIsOutOfRange(newActiveDate, this.minDate, this.maxDate, this.parse, this.dateFormat)) {
          this.activeDate = newActiveDate;
        }
      },
      focusTimePicker: function focusTimePicker() {
        this.$refs.timePicker.focus();
      },
      inputDateHandler: function inputDateHandler(date) {
        this.dateWithoutTime = date;
        this.dateTimeInputHandler();
      },
      inputTimeHandler: function inputTimeHandler(date) {
        this.timeWithoutDate = date;

        if (this.datepicker) {
          this.dateTimeInputHandler();
        } else {
          this.inputHandler(date);
        }
      },
      dateTimeInputHandler: function dateTimeInputHandler() {
        if (this.dateWithoutTime === null || this.timeWithoutDate === null) {
          if (this.timeWithoutDate === null) {
            this.focusTimePicker();
          } else if (this.dateWithoutTime === null) {
            this.focus();
          }

          return;
        }

        var dateWithoutTime = this.dateWithoutTime,
            timeWithoutDate = this.timeWithoutDate;
        var dateTime = new Date(dateWithoutTime.getFullYear(), dateWithoutTime.getMonth(), dateWithoutTime.getDate(), timeWithoutDate.getHours(), timeWithoutDate.getMinutes(), timeWithoutDate.getSeconds());
        this.inputHandler(dateTime);
      },
      inputHandler: function inputHandler(newDate) {
        var date = new Date(newDate.valueOf());
        var disabledDates = this.disabledDates;

        if (dayIsPartOfTheConditions(date, disabledDates, this.parse, this.dateFormat) || dateIsOutOfRange(date, this.minDate, this.maxDate, this.parse, this.dateFormat)) {
          return;
        }

        if (this.range) {
          var _range = []; // Reset the range when
          // 1. Is not an array
          // 2. The range already have both values
          // 3. The range has the first value and the second value is before

          if (!this.localValue || !Array.isArray(this.localValue) || Array.isArray(this.localValue) && (this.localValue.length === 0 || this.localValue.length === 2) || Array.isArray(this.localValue) && this.localValue.length === 1 && this.localValue[0] && this.localValue[0].getTime() > date.getTime()) {
            _range = [date];
          } else if (this.localValue.length === 1) {
            _range = [this.localValue[0], date];
          }

          this.localValue = _range; // Range is complete

          if (!this.inline && this.localValue.length === 2 && this.closeOnSelect) {
            this.doHide();
          }
        } else if (Array.isArray(this.localValue)) {
          var index = this.localValue.findIndex(function (d) {
            return isSameDay(d, date);
          });

          if (index >= 0) {
            this.localValue.splice(index, 1);
          } else {
            this.localValue.push(date);
          }
        } else {
          this.focus();
          this.localValue = date;
        }

        if (!this.inline && this.closeOnSelect && !Array.isArray(this.localValue)) {
          this.doHide();
        }
      },
      inputActiveDateHandler: function inputActiveDateHandler(newDate) {
        this.activeDate = new Date(newDate.valueOf());
      },
      setView: function setView(newView) {
        this.currentView = newView;
        this.focus();
      },
      resetView: function resetView() {
        if (this.currentView === CalendarView.Month) {
          this.setView(CalendarView.Day);
        } else if (this.currentView === CalendarView.Year) {
          this.setView(CalendarView.Month);
        } else {
          this.setView(CalendarView.Day);
        }
      },
      enterHandler: function enterHandler(e) {
        e.preventDefault();

        if (!this.inline && !this.shown) {
          this.doShow();
        } else if (this.showActiveDate) {
          if (this.currentView === CalendarView.Day) {
            if (this.timepicker) {
              this.inputDateHandler(new Date(this.activeDate.valueOf()));
            } else {
              this.inputHandler(new Date(this.activeDate.valueOf()));
            }
          } else {
            this.resetView();
          }
        }
      },
      escapeHandler: function escapeHandler(e) {
        e.preventDefault();
        var dropdown = this.getDropdown();

        if (dropdown) {
          dropdown.escapeHandler(e);
        }
      },
      spaceHandler: function spaceHandler(e) {
        e.preventDefault();
        this.toggle();
      },
      getDropdown: function getDropdown() {
        return this.$refs.dropdown;
      },
      resetInitialState: function resetInitialState() {
        this.shown = false;
        this.currentView = this.initialView;
        this.showActiveDate = false;

        if (this.timepicker) {
          this.dateWithoutTime = Array.isArray(this.localValue) ? this.localValue[0] : this.localValue;
        } else {
          this.dateWithoutTime = null;
        }

        this.timeWithoutDate = null;
        this.resetActiveDate(this.localValue);
      },
      resetActiveDate: function resetActiveDate(localValue) {
        this.activeDate = getInitialActiveDate(localValue, this.initialDate, this.dateFormat, this.parse, this.amPm, this.initialTime);
      },
      clearHandler: function clearHandler() {
        if (this.multiple || this.range) {
          this.localValue = [];
        } else {
          this.localValue = null;
        }

        this.resetActiveDate(this.localValue);
      },
      focusHandler: function focusHandler(e) {
        this.hasFocus = true;
        this.$emit('focus', e);
      },
      blurHandler: function blurHandler(e) {
        this.hasFocus = false;
        this.$emit('blur', e);
      },
      hideIfFocusOutside: function hideIfFocusOutside(e) {
        var dropdown = this.getDropdown();

        if (dropdown) {
          dropdown.hideIfFocusOutside(e);
        }
      }
    },
    render: function render(createElement) {
      var _this54 = this;

      var views = [];

      if (this.datepicker) {
        views.push(createElement(TDatepickerViews, {
          ref: 'views',
          props: {
            value: this.localValue,
            activeDate: this.activeDate,
            weekStart: this.weekStart,
            monthsPerView: this.monthsPerView,
            lang: this.lang,
            locale: this.currentLocale,
            getElementCssClass: this.getElementCssClass,
            parse: this.parse,
            format: this.format,
            formatNative: this.formatNative,
            dateFormat: this.dateFormat,
            userFormat: this.userFormat,
            initialView: this.initialView,
            currentView: this.currentView,
            yearsPerView: this.yearsPerView,
            showActiveDate: this.showActiveDate,
            disabledDates: this.disabledDates,
            highlightDates: this.highlightDates,
            minDate: this.minDate,
            maxDate: this.maxDate,
            range: this.range,
            showDaysForOtherMonth: this.showDaysForOtherMonth,
            datepicker: this.datepicker,
            timepicker: this.timepicker,
            dateWithoutTime: this.dateWithoutTime
          },
          scopedSlots: this.$scopedSlots,
          on: {
            input: this.inputHandler,
            'input-date': this.inputDateHandler,
            'input-time': this.inputTimeHandler,
            'input-active-date': this.inputActiveDateHandler,
            'update-view': this.setView,
            'reset-view': this.resetView,
            'reset-focus': this.focus
          }
        }));
      }

      if (this.timepicker && this.currentView === CalendarView.Day) {
        views.push(createElement(TDatepickerTimeSelector, {
          ref: 'timePicker',
          props: {
            parse: this.parse,
            format: this.format,
            amPm: this.amPm,
            showSeconds: this.showSeconds,
            activeDate: this.activeDate,
            locale: this.currentLocale,
            getElementCssClass: this.getElementCssClass
          },
          on: {
            input: this.inputActiveDateHandler,
            submit: this.inputTimeHandler,
            blur: this.hideIfFocusOutside
          }
        }));
      }

      var triggerSettings = {
        ref: 'trigger',
        props: {
          id: this.id,
          name: this.name,
          inputName: this.inputName,
          disabled: this.disabled,
          readonly: this.readonly,
          autofocus: this.autofocus,
          required: this.required,
          placeholder: this.placeholder,
          tabindex: this.tabindex,
          userFormatedDate: this.userFormatedDate,
          formatedDate: this.formatedDate,
          conjunction: this.conjunction,
          multiple: this.multiple,
          range: this.range,
          clearable: this.clearable,
          locale: this.currentLocale,
          value: this.localValue,
          activeDate: this.activeDate,
          hasFocus: this.hasFocus,
          getElementCssClass: this.getElementCssClass
        },
        scopedSlots: this.$scopedSlots,
        on: {
          clear: this.clearHandler,
          focus: this.focusHandler,
          blur: this.blurHandler,
          keydown: function keydown(e) {
            if ([Key$1.LEFT, Key$1.UP, Key$1.RIGHT, Key$1.DOWN].includes(e.keyCode) && _this54.datepicker) {
              _this54.arrowKeyHandler(e);
            } else if (e.keyCode === Key$1.ENTER) {
              _this54.enterHandler(e);
            } else if (e.keyCode === Key$1.ESC) {
              _this54.escapeHandler(e);
            } else if (e.keyCode === Key$1.SPACE) {
              _this54.spaceHandler(e);
            }

            if (isNumeric(e.key)) {
              _this54.focusTimePicker();
            }

            _this54.$emit('keydown', e);
          }
        }
      };

      if (this.inline) {
        return createElement('div', {
          class: this.getElementCssClass('inlineWrapper')
        }, [createElement(TDatepickerTrigger, triggerSettings), createElement('div', {
          class: this.getElementCssClass('inlineViews')
        }, views)]);
      }

      return createElement(TDropdown, {
        ref: 'dropdown',
        props: {
          fixedClasses: undefined,
          classes: {
            wrapper: this.getElementCssClass('wrapper'),
            dropdownWrapper: this.getElementCssClass('dropdownWrapper'),
            dropdown: this.getElementCssClass('dropdown'),
            enterClass: this.getElementCssClass('enterClass'),
            enterActiveClass: this.getElementCssClass('enterActiveClass'),
            enterToClass: this.getElementCssClass('enterToClass'),
            leaveClass: this.getElementCssClass('leaveClass'),
            leaveActiveClass: this.getElementCssClass('leaveActiveClass'),
            leaveToClass: this.getElementCssClass('leaveToClass')
          },
          show: this.show
        },
        on: {
          hidden: function hidden() {
            _this54.$emit('hidden');

            _this54.resetInitialState();
          },
          shown: function shown() {
            _this54.$emit('shown');

            _this54.shown = true;

            if (_this54.timepicker && !_this54.datepicker) {
              _this54.$nextTick(function () {
                _this54.focusTimePicker();
              });
            }
          }
        },
        scopedSlots: {
          trigger: function trigger(props) {
            var settings = cloneDeep__default['default'](triggerSettings);
            settings.props = Object.assign(Object.assign({}, settings.props), {
              hideIfFocusOutside: props.hideIfFocusOutside,
              show: props.show
            });
            return [createElement(TDatepickerTrigger, settings)];
          }
        }
      }, views);
    }
  });
  /* eslint-disable no-shadow */

  var HideReason;

  (function (HideReason) {
    HideReason["Outside"] = "outside";
    HideReason["Close"] = "close";
    HideReason["Esc"] = "esc";
    HideReason["Cancel"] = "cancel";
    HideReason["Ok"] = "ok";
    HideReason["Method"] = "method";
    HideReason["Value"] = "value";
  })(HideReason || (HideReason = {}));

  var DialogType;

  (function (DialogType) {
    DialogType["Alert"] = "alert";
    DialogType["Confirm"] = "confirm";
    DialogType["Prompt"] = "prompt";
  })(DialogType || (DialogType = {}));

  var uniqid = function uniqid() {
    return Math.random().toString(36).substring(7);
  };

  var TDialogOverlayWrapperTransitionDialogContentInput = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogContentInput',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      }
    },
    data: function data() {
      return {
        errorMessage: null
      };
    },
    mounted: function mounted() {
      this.inputHandler();
    },
    methods: {
      getInputValue: function getInputValue() {
        var input = this.$refs.input;

        if (!input) {
          return undefined;
        }

        var inputName = input.name;

        if (input.type === 'radio') {
          var checkedRadio = this.$refs.inputWrapper.querySelector("input[name=\"".concat(inputName, "\"]:checked"));
          return checkedRadio ? checkedRadio.value : null;
        }

        if (input.type === 'checkbox') {
          if (this.inputOptions) {
            var checkedCheckboxes = this.$refs.inputWrapper.querySelectorAll("input[name=\"".concat(inputName, "\"]:checked"));
            var inititalValue = Array.from(checkedCheckboxes).map(function (checkbox) {
              return checkbox.value;
            });
            return inititalValue;
          }

          return input.checked ? input.value : null;
        }

        return input.value;
      },
      inputHandler: function inputHandler() {
        this.errorMessage = null;
        var inputValue = this.getInputValue();
        this.$emit('input', inputValue);
      }
    },
    render: function render(createElement) {
      var _this55 = this;

      var input;

      if (this.inputType === 'select') {
        var options = _normalizeOptions(this.inputOptions || []).map(function (option) {
          var isSelected = _this55.inputValue === option.value;
          return createElement('option', {
            domProps: {
              value: option.value,
              selected: isSelected
            }
          }, String(option.text));
        });

        input = createElement('select', {
          class: this.getElementCssClass('select'),
          ref: 'input',
          attrs: Object.assign({
            name: 'input'
          }, this.inputAttributes),
          on: {
            change: this.inputHandler
          }
        }, options);
      } else if (this.inputType === 'radio') {
        input = _normalizeOptions(this.inputOptions || []).map(function (option) {
          var isChecked = _this55.inputValue === option.value;
          return createElement('label', {
            class: _this55.getElementCssClass('radioWrapper'),
            attrs: {
              for: "input-".concat(String(option.value))
            }
          }, [createElement('input', {
            class: _this55.getElementCssClass('radio'),
            ref: 'input',
            attrs: Object.assign({
              type: 'radio',
              name: 'input',
              id: "input-".concat(String(option.value)),
              value: option.value,
              checked: isChecked
            }, _this55.inputAttributes),
            on: {
              change: _this55.inputHandler
            }
          }), createElement('span', {
            class: _this55.getElementCssClass('radioText')
          }, String(option.text))]);
        });
      } else if (this.inputType === 'checkbox') {
        if (this.inputOptions) {
          input = _normalizeOptions(this.inputOptions || []).map(function (option) {
            var isChecked = Array.isArray(_this55.inputValue) ? _this55.inputValue.includes(option.value) : _this55.inputValue === option.value;
            return createElement('label', {
              class: _this55.getElementCssClass('checkboxWrapper'),
              attrs: {
                for: "input-".concat(String(option.value))
              }
            }, [createElement('input', {
              class: _this55.getElementCssClass('checkbox'),
              ref: 'input',
              attrs: Object.assign({
                type: 'checkbox',
                name: 'input[]',
                id: "input-".concat(String(option.value)),
                value: option.value,
                checked: isChecked
              }, _this55.inputAttributes),
              on: {
                change: _this55.inputHandler
              }
            }), createElement('span', {
              class: _this55.getElementCssClass('checkboxText')
            }, String(option.text))]);
          });
        } else {
          var id = uniqid();
          input = createElement('label', {
            class: this.getElementCssClass('checkboxWrapper'),
            attrs: {
              for: "input-".concat(id)
            }
          }, [createElement('input', {
            class: this.getElementCssClass('checkbox'),
            ref: 'input',
            attrs: Object.assign({
              type: 'checkbox',
              name: 'input',
              id: "input-".concat(id),
              value: this.inputValue
            }, this.inputAttributes),
            on: {
              change: this.inputHandler
            }
          }), createElement('span', {
            class: this.getElementCssClass('checkboxText')
          }, this.inputPlaceholder ? String(this.inputPlaceholder) : '')]);
        }
      } else {
        input = createElement('input', {
          class: this.getElementCssClass('input'),
          ref: 'input',
          domProps: {
            value: this.inputValue
          },
          attrs: Object.assign({
            name: 'input',
            type: this.inputType,
            placeholder: this.inputPlaceholder
          }, this.inputAttributes),
          on: {
            input: this.inputHandler
          }
        });
      }

      return createElement('div', {
        ref: 'inputWrapper',
        class: this.getElementCssClass('inputWrapper')
      }, Array.isArray(input) ? input : [input]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogContent = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogContent',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      errorMessage: {
        type: String,
        required: true
      }
    },
    render: function render(createElement) {
      var _this56 = this;

      var subElements = [];

      if (this.title || this.$scopedSlots.title) {
        if (this.$scopedSlots.title) {
          subElements.push(createElement('div', {
            class: this.getElementCssClass('titleWrapper')
          }, [this.$scopedSlots.title({
            class: this.getElementCssClass('title')
          })]));
        } else {
          subElements.push(createElement('div', {
            class: this.getElementCssClass('titleWrapper')
          }, [createElement(this.titleTag, {
            class: this.getElementCssClass('title')
          }, this.title || '')]));
        }
      }

      if (this.$slots.default) {
        subElements.push(createElement('div', {
          class: this.getElementCssClass('textWrapper')
        }, this.$slots.default));
      } else if (this.text) {
        subElements.push(createElement('div', {
          class: this.getElementCssClass('textWrapper')
        }, this.text ? [createElement(this.textTag, {
          class: this.getElementCssClass('text')
        }, this.text)] : undefined));
      }

      if (this.type === DialogType.Prompt) {
        subElements.push(createElement(TDialogOverlayWrapperTransitionDialogContentInput, {
          props: {
            getElementCssClass: this.getElementCssClass,
            inputAttributes: this.inputAttributes,
            inputType: this.inputType,
            inputValue: this.inputValue,
            inputOptions: this.inputOptions,
            inputPlaceholder: this.inputPlaceholder
          },
          on: {
            input: function input(val) {
              return _this56.$emit('input', val);
            }
          }
        }));
      }

      if (this.errorMessage && typeof this.errorMessage === 'string') {
        subElements.push(createElement('div', {
          class: this.getElementCssClass('errorMessage')
        }, this.errorMessage));
      }

      return createElement('div', {
        class: this.getElementCssClass('content')
      }, subElements);
    }
  });
  var IconName;

  (function (IconName) {
    IconName["Success"] = "success";
    IconName["Error"] = "error";
    IconName["Warning"] = "warning";
    IconName["Info"] = "info";
    IconName["Question"] = "question";
  })(IconName || (IconName = {}));

  function getHtmlSvgPath(iconName) {
    if (!iconName) {
      return undefined;
    }

    var icons = {};
    icons[IconName.Success] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>';
    icons[IconName.Error] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>';
    icons[IconName.Warning] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>';
    icons[IconName.Info] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>';
    icons[IconName.Question] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>';
    return icons[iconName];
  }

  var TDialogOverlayWrapperTransitionDialogIcon = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogIcon',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      icon: {
        type: String,
        default: undefined
      }
    },
    render: function render(createElement) {
      if (this.$scopedSlots.icon) {
        return createElement('div', {
          class: this.getElementCssClass('iconWrapper')
        }, [this.$scopedSlots.icon({})]);
      }

      var htmlSvgPath = getHtmlSvgPath(this.icon);

      if (!htmlSvgPath) {
        return createElement();
      }

      return createElement('div', {
        class: this.getElementCssClass('iconWrapper')
      }, [createElement('svg', {
        class: this.getElementCssClass('icon'),
        attrs: {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24',
          xmlns: 'http://www.w3.org/2000/svg'
        },
        domProps: {
          innerHTML: htmlSvgPath
        }
      })]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogClose = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogClose',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      showCloseButton: {
        type: Boolean,
        required: true
      }
    },
    render: function render(createElement) {
      var _this57 = this;

      if (!this.showCloseButton) {
        return createElement();
      }

      if (this.$scopedSlots.closeButton) {
        return createElement('button', {
          class: this.getElementCssClass('close'),
          attrs: {
            type: 'button'
          },
          on: {
            click: function click(e) {
              return _this57.$emit('dismiss', e);
            }
          }
        }, [this.$scopedSlots.closeButton({})]);
      }

      return createElement('button', {
        class: this.getElementCssClass('close'),
        attrs: {
          type: 'button'
        },
        on: {
          click: function click(e) {
            return _this57.$emit('dismiss', e);
          }
        }
      }, [createElement('svg', {
        attrs: {
          fill: 'currentColor',
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 20 20'
        },
        class: this.getElementCssClass('closeIcon')
      }, [createElement('path', {
        attrs: {
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          d: 'M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
        }
      })])]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogLoader = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogLoader',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      busy: {
        type: Boolean,
        required: true
      }
    },
    render: function render(createElement) {
      if (!this.busy) {
        return createElement();
      }

      if (this.$scopedSlots.loader) {
        return createElement('div', {
          class: this.getElementCssClass('busyWrapper')
        }, [this.$scopedSlots.loader({})]);
      }

      return createElement('div', {
        class: this.getElementCssClass('busyWrapper')
      }, [createElement('svg', {
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          width: 32,
          height: 32,
          viewBox: '0 0 32 32'
        },
        class: this.getElementCssClass('busyIcon')
      }, [createElement('g', {
        attrs: {
          transform: 'scale(0.03125 0.03125)'
        }
      }, [createElement('path', {
        attrs: {
          d: 'M512 1024c-136.76 0-265.334-53.258-362.040-149.96-96.702-96.706-149.96-225.28-149.96-362.040 0-96.838 27.182-191.134 78.606-272.692 50-79.296 120.664-143.372 204.356-185.3l43 85.832c-68.038 34.084-125.492 86.186-166.15 150.67-41.746 66.208-63.812 142.798-63.812 221.49 0 229.382 186.618 416 416 416s416-186.618 416-416c0-78.692-22.066-155.282-63.81-221.49-40.66-64.484-98.114-116.584-166.15-150.67l43-85.832c83.692 41.928 154.358 106.004 204.356 185.3 51.422 81.558 78.604 175.854 78.604 272.692 0 136.76-53.258 265.334-149.96 362.040-96.706 96.702-225.28 149.96-362.040 149.96z'
        }
      })])])]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogButtons = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogButtons',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    methods: {
      cancel: function cancel(e) {
        this.$emit('cancel', e);
      },
      ok: function ok(e) {
        this.$emit('submit', e);
      }
    },
    render: function render(createElement) {
      var type = this.type;

      if (this.$scopedSlots.buttons) {
        return createElement('div', {
          class: this.getElementCssClass('buttons')
        }, [this.$scopedSlots.buttons({
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonAriaLabel: this.okButtonAriaLabel,
          cancelButtonText: this.cancelButtonText,
          okButtonText: this.okButtonText,
          okButtonClass: this.getElementCssClass('okButton'),
          cancelButtonClass: this.getElementCssClass('cancelButton'),
          dialogType: type,
          cancel: this.cancel,
          ok: this.ok
        })]);
      }

      var subElements = [];
      var buttons = {
        cancel: createElement('button', {
          attrs: {
            type: 'button',
            'aria-label': this.cancelButtonAriaLabel
          },
          class: this.getElementCssClass('cancelButton'),
          on: {
            click: this.cancel
          }
        }, this.cancelButtonText),
        ok: createElement('button', {
          attrs: {
            type: 'button',
            'aria-label': this.okButtonAriaLabel
          },
          class: this.getElementCssClass('okButton'),
          on: {
            click: this.ok
          }
        }, this.okButtonText)
      };

      if (type === DialogType.Alert) {
        subElements.push(buttons.ok);
      } else if (type === DialogType.Confirm || type === DialogType.Prompt) {
        subElements.push(buttons.cancel);
        subElements.push(buttons.ok);
      }

      return createElement('div', {
        class: this.getElementCssClass('buttons')
      }, subElements);
    }
  });
  var TDialogOverlayWrapperTransitionDialog = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialog',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    data: function data() {
      return {
        currentValue: null,
        errorMessage: '',
        busy: false
      };
    },
    methods: {
      submitHandler: function submitHandler(e) {
        var _this58 = this;

        return this.resolveParam(this.inputValidator, this.currentValue).then(function (errorMessage) {
          if (errorMessage && typeof errorMessage === 'string') {
            _this58.errorMessage = String(errorMessage);
            return;
          }

          _this58.resolveParam(_this58.preConfirm, _this58.currentValue).then(function (response) {
            _this58.$emit('submit', e, _this58.currentValue, response);
          }).catch(function (error) {
            _this58.$emit('submit-error', e, _this58.currentValue, error);
          }).then(function () {
            _this58.busy = false;
          });
        }).catch(function (errorMessage) {
          _this58.errorMessage = String(errorMessage);
        });
      },
      inputHandler: function inputHandler(input) {
        this.errorMessage = '';
        this.currentValue = input;
      },
      resolveParam: function resolveParam(resolvable, input) {
        if (typeof resolvable === 'function') {
          var result = resolvable(input);

          if (result instanceof Promise) {
            this.busy = true;
            return result;
          }

          return new Promise(function (resolve) {
            resolve(result);
          });
        }

        return new Promise(function (resolve) {
          return resolve();
        });
      }
    },
    render: function render(createElement) {
      var _this59 = this;

      if (!this.dialogShow) {
        return createElement();
      }

      return createElement('div', {
        ref: 'dialog',
        class: this.getElementCssClass('dialog')
      }, [createElement(TDialogOverlayWrapperTransitionDialogLoader, {
        props: {
          getElementCssClass: this.getElementCssClass,
          busy: this.busy
        },
        scopedSlots: {
          loader: this.$scopedSlots.loader
        }
      }), createElement(TDialogOverlayWrapperTransitionDialogClose, {
        props: {
          getElementCssClass: this.getElementCssClass,
          showCloseButton: this.showCloseButton
        },
        on: {
          dismiss: function dismiss(e) {
            return _this59.$emit('dismiss', e);
          }
        },
        scopedSlots: {
          closeButton: this.$scopedSlots.closeButton
        }
      }), createElement('div', {
        ref: 'body',
        class: this.getElementCssClass('body')
      }, [createElement(TDialogOverlayWrapperTransitionDialogIcon, {
        props: {
          getElementCssClass: this.getElementCssClass,
          icon: this.icon
        },
        scopedSlots: {
          icon: this.$scopedSlots.icon
        }
      }), createElement(TDialogOverlayWrapperTransitionDialogContent, {
        props: {
          getElementCssClass: this.getElementCssClass,
          titleTag: this.titleTag,
          title: this.title,
          textTag: this.textTag,
          text: this.text,
          type: this.type,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder,
          errorMessage: this.errorMessage
        },
        on: {
          input: this.inputHandler
        },
        scopedSlots: {
          title: this.$scopedSlots.title
        }
      }, this.$slots.default)]), createElement(TDialogOverlayWrapperTransitionDialogButtons, {
        props: {
          getElementCssClass: this.getElementCssClass,
          type: this.type,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel
        },
        on: {
          cancel: function cancel(e) {
            return _this59.$emit('cancel', e);
          },
          submit: this.submitHandler
        },
        scopedSlots: {
          buttons: this.$scopedSlots.buttons
        }
      })]);
    }
  });
  var TDialogOverlayWrapperTransition = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransition',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    render: function render(createElement) {
      var _this60 = this;

      return createElement('transition', {
        props: {
          enterClass: this.getElementCssClass('enterClass'),
          enterActiveClass: this.getElementCssClass('enterActiveClass'),
          enterToClass: this.getElementCssClass('enterToClass'),
          leaveClass: this.getElementCssClass('leaveClass'),
          leaveActiveClass: this.getElementCssClass('leaveActiveClass'),
          leaveToClass: this.getElementCssClass('leaveToClass')
        }
      }, [createElement(TDialogOverlayWrapperTransitionDialog, {
        props: {
          getElementCssClass: this.getElementCssClass,
          dialogShow: this.dialogShow,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder,
          type: this.type
        },
        scopedSlots: this.$scopedSlots,
        on: {
          dismiss: function dismiss(e) {
            return _this60.$emit('dismiss', e);
          },
          cancel: function cancel(e) {
            return _this60.$emit('cancel', e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this60.$emit('submit', e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this60.$emit('submit-error', e, input, error);
          }
        }
      }, this.$slots.default)]);
    }
  });
  var TDialogOverlayWrapper = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapper',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    render: function render(createElement) {
      var _this61 = this;

      return createElement('div', {
        ref: 'wrapper',
        class: this.getElementCssClass('wrapper')
      }, [createElement(TDialogOverlayWrapperTransition, {
        props: {
          type: this.type,
          dialogShow: this.dialogShow,
          getElementCssClass: this.getElementCssClass,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder
        },
        scopedSlots: this.$scopedSlots,
        on: {
          dismiss: function dismiss(e) {
            return _this61.$emit('dismiss', e);
          },
          cancel: function cancel(e) {
            return _this61.$emit('cancel', e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this61.$emit('submit', e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this61.$emit('submit-error', e, input, error);
          }
        }
      }, this.$slots.default)]);
    }
  });
  var TDialogOverlay = Vue__default['default'].extend({
    name: 'TDialogOverlay',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      overlayShow: {
        type: Boolean,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        default: null
      }
    },
    methods: {
      clickHandler: function clickHandler(e) {
        if (e.target !== this.$el) {
          return;
        }

        this.$emit('outside-click', e);
      },
      keyupHandler: function keyupHandler(e) {
        this.$emit('keyup', e);
      },
      focus: function focus() {
        var overlay = this.$el;

        if (overlay && overlay.focus) {
          overlay.focus();
        }
      },
      enableBodyScroll: function enableBodyScroll() {
        var mdl = this.$el;
        bodyScrollLock.enableBodyScroll(mdl);
      },
      disableBodyScroll: function disableBodyScroll() {
        var mdl = this.$el;
        bodyScrollLock.disableBodyScroll(mdl, {
          reserveScrollBarGap: true
        });
      }
    },
    render: function render(createElement) {
      var _this62 = this;

      if (!this.overlayShow) {
        return createElement();
      }

      return createElement('div', {
        attrs: {
          tabindex: 0
        },
        class: this.getElementCssClass('overlay'),
        on: {
          keyup: this.keyupHandler,
          click: this.clickHandler
        }
      }, [createElement(TDialogOverlayWrapper, {
        props: {
          type: this.type,
          getElementCssClass: this.getElementCssClass,
          dialogShow: this.dialogShow,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder
        },
        scopedSlots: this.$scopedSlots,
        on: {
          dismiss: function dismiss(e) {
            return _this62.$emit('dismiss', e);
          },
          cancel: function cancel(e) {
            return _this62.$emit('cancel', e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this62.$emit('submit', e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this62.$emit('submit-error', e, input, error);
          }
        }
      }, this.$slots.default)]);
    }
  });

  var getInitialData = function getInitialData(vm) {
    return {
      overlayShow: vm.value,
      dialogShow: vm.value,
      params: undefined,
      preventAction: false,
      hideReason: undefined,
      input: undefined,
      resolve: null,
      reject: null,
      preConfirmResponse: undefined,
      preConfirmError: undefined
    };
  };

  var TDialog = Component.extend({
    name: 'TDialog',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: undefined
      },
      titleTag: {
        type: String,
        default: 'h3'
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        default: 'p'
      },
      text: {
        type: String,
        default: undefined
      },
      clickToClose: {
        type: Boolean,
        default: true
      },
      escToClose: {
        type: Boolean,
        default: true
      },
      cancelButtonText: {
        type: String,
        default: 'Cancel'
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        default: 'OK'
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        default: false
      },
      disableBodyScroll: {
        type: Boolean,
        default: true
      },
      focusOnOpen: {
        type: Boolean,
        default: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        default: 'text'
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        default: DialogType.Alert
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {
            overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed',
            wrapper: 'relative mx-auto',
            modal: 'overflow-visible relative ',
            close: 'flex items-center justify-center',
            dialog: 'overflow-visible relative'
          };
        }
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            close: 'bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            closeIcon: 'fill-current h-4 w-4',
            overlay: 'z-40 bg-black bg-opacity-50',
            wrapper: 'z-50 max-w-lg px-3 py-12',
            dialog: 'bg-white shadow rounded text-left',
            body: 'p-3 space-y-3',
            buttons: 'p-3 flex space-x-4 justify-center bg-gray-100 rounded-b',
            iconWrapper: 'bg-gray-100 flex flex-shrink-0 h-12 items-center justify-center rounded-full w-12 mx-auto',
            icon: 'w-6 h-6 text-gray-500',
            content: 'w-full flex justify-center flex-col',
            titleWrapper: '',
            title: 'text-lg font-semibold text-center',
            textWrapper: 'text-left w-full',
            text: '',
            cancelButton: 'block px-4 py-2 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm hover:bg-gray-100 focus:border-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full max-w-xs',
            okButton: 'block px-4 py-2 text-white transition duration-100 ease-in-out bg-blue-500 border border-transparent rounded shadow-sm hover:bg-blue-600 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full max-w-xs',
            inputWrapper: 'mt-3 flex items-center space-x-3',
            input: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full',
            select: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50  disabled:opacity-50 disabled:cursor-not-allowed w-full',
            radioWrapper: 'flex items-center space-x-2',
            radio: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
            radioText: '',
            checkboxWrapper: 'flex items-center space-x-2',
            checkbox: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
            checkboxText: '',
            errorMessage: 'text-red-500 block text-sm',
            busyWrapper: 'absolute bg-opacity-50 bg-white flex h-full items-center justify-center left-0 top-0 w-full',
            busyIcon: 'animate-spin h-6 w-6 fill-current text-gray-500',
            overlayEnterClass: 'opacity-0',
            overlayEnterActiveClass: 'transition ease-out duration-100',
            overlayEnterToClass: 'opacity-100',
            overlayLeaveClass: 'opacity-100',
            overlayLeaveActiveClass: 'transition ease-in duration-75',
            overlayLeaveToClass: 'opacity-0',
            enterClass: '',
            enterActiveClass: '',
            enterToClass: '',
            leaveClass: '',
            leaveActiveClass: '',
            leaveToClass: ''
          };
        }
      }
    },
    data: function data() {
      return getInitialData(this);
    },
    watch: {
      value: function value(_value10) {
        if (_value10) {
          this.show();
        } else {
          this.hideReason = HideReason.Value;
          this.close();
        }
      },
      overlayShow: function overlayShow(shown) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  if (!shown) {
                    _context14.next = 8;
                    break;
                  }

                  this.$emit('input', shown);
                  this.$emit('change', shown);
                  _context14.next = 5;
                  return this.$nextTick();

                case 5:
                  this.dialogShow = true;
                  _context14.next = 9;
                  break;

                case 8:
                  this.closed();

                case 9:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this);
        }));
      },
      dialogShow: function dialogShow(shown) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  if (shown) {
                    _context15.next = 8;
                    break;
                  }

                  this.$emit('input', shown);
                  this.$emit('change', shown);
                  _context15.next = 5;
                  return this.$nextTick();

                case 5:
                  this.overlayShow = false;
                  _context15.next = 9;
                  break;

                case 8:
                  this.opened();

                case 9:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        }));
      }
    },
    beforeDestroy: function beforeDestroy() {
      var overlay = this.getOverlay();

      if (this.disableBodyScroll && overlay) {
        overlay.focus();
        overlay.enableBodyScroll();
      }
    },
    created: function created() {
      var _this63 = this;

      if (this.name) {
        this.$dialog.$on("show-".concat(this.name), function (resolve, reject) {
          var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
          _this63.resolve = resolve;
          _this63.reject = reject;

          _this63.show(params);
        });
        this.$dialog.$on("hide-".concat(this.name), function () {
          _this63.hideReason = HideReason.Method;

          _this63.close();
        });
      }
    },
    render: function render(createElement) {
      var _this64 = this;

      return createElement('transition', {
        props: {
          enterClass: this.getElementCssClass('overlayEnterClass'),
          enterActiveClass: this.getElementCssClass('overlayEnterActiveClass'),
          enterToClass: this.getElementCssClass('overlayEnterToClass'),
          leaveClass: this.getElementCssClass('overlayLeaveClass'),
          leaveActiveClass: this.getElementCssClass('overlayLeaveActiveClass'),
          leaveToClass: this.getElementCssClass('overlayLeaveToClass')
        }
      }, [createElement(TDialogOverlay, {
        ref: 'overlay',
        props: {
          type: this.type,
          overlayShow: this.overlayShow,
          dialogShow: this.dialogShow,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder,
          getElementCssClass: this.getElementCssClass
        },
        scopedSlots: this.$scopedSlots,
        on: {
          'outside-click': this.outsideClick,
          keyup: this.keyupHandler,
          dismiss: function dismiss(e) {
            return _this64.dismiss(e);
          },
          cancel: function cancel(e) {
            return _this64.cancel(e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this64.submit(e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this64.submitError(e, input, error);
          }
        }
      }, this.$slots.default)]);
    },
    methods: {
      getOverlay: function getOverlay() {
        return this.$refs.overlay;
      },
      keyupHandler: function keyupHandler(e) {
        if (e.keyCode === Key$1.ESC && this.escToClose) {
          this.esc(e);
        }
      },
      beforeOpen: function beforeOpen() {
        this.$emit('before-open', {
          params: this.params,
          cancel: this.closeCancel
        });
      },
      opened: function opened() {
        this.$emit('opened', {
          params: this.params
        });
        this.prepareDomForDialog();
      },
      beforeClose: function beforeClose(event) {
        if (this.disableBodyScroll) {
          var overlay = this.getOverlay();

          if (overlay) {
            overlay.focus();
            overlay.enableBodyScroll();
          }
        }

        var beforeCloseParams = {
          cancel: this.closeCancel,
          event: event,
          reason: this.hideReason
        };

        if (this.input !== undefined) {
          beforeCloseParams.input = this.input;
        }

        if (this.preConfirmResponse !== undefined) {
          beforeCloseParams.response = this.preConfirmResponse;
        }

        this.$emit('before-close', beforeCloseParams);
      },
      closed: function closed() {
        var response = {
          hideReason: this.hideReason,
          isOk: this.hideReason === HideReason.Ok,
          isCancel: this.hideReason === HideReason.Cancel,
          isDismissed: typeof this.hideReason === 'string' && [HideReason.Close, HideReason.Esc, HideReason.Outside].includes(this.hideReason)
        };

        if (this.type === DialogType.Prompt && this.hideReason === HideReason.Ok && this.input !== undefined) {
          response.input = this.input;
        }

        if (this.preConfirmResponse !== undefined) {
          response.response = this.preConfirmResponse;
        } else if (this.preConfirmError !== undefined) {
          response.response = this.preConfirmError;
        }

        this.$emit('closed', response);

        if (this.reject && this.preConfirmError !== undefined) {
          this.reject(this.preConfirmError);
        } else if (this.resolve) {
          this.resolve(response);
        }

        this.reset();
      },
      prepareDomForDialog: function prepareDomForDialog() {
        var overlay = this.getOverlay();

        if (!overlay) {
          return;
        }

        if (this.disableBodyScroll) {
          overlay.disableBodyScroll();
        }

        if (this.focusOnOpen) {
          overlay.focus();
        }
      },
      dismiss: function dismiss(e) {
        this.hideReason = HideReason.Close;
        this.close(e);
      },
      esc: function esc(e) {
        this.hideReason = HideReason.Esc;
        this.close(e);
      },
      cancel: function cancel(e) {
        this.hideReason = HideReason.Cancel;
        this.close(e);
      },
      hide: function hide(e) {
        this.hideReason = HideReason.Method;
        this.close(e);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      submit: function submit(e, input, response) {
        this.hideReason = HideReason.Ok;
        this.input = input;
        this.preConfirmResponse = response;
        this.close(e);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      submitError: function submitError(e, input, error) {
        this.hideReason = HideReason.Ok;
        this.input = input;
        this.preConfirmError = error;
        this.close(e);
      },
      close: function close(e) {
        this.beforeClose(e);

        if (!this.preventAction) {
          this.dialogShow = false;
        } else {
          this.preventAction = false;
        }
      },
      show: function show() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        this.params = params;
        this.beforeOpen();

        if (!this.preventAction) {
          this.overlayShow = true;
        } else {
          this.preventAction = false;
        }
      },
      closeCancel: function closeCancel() {
        this.preventAction = true;
      },
      reset: function reset() {
        Object.assign(this.$data, getInitialData(this));
      },
      outsideClick: function outsideClick(e) {
        if (this.clickToClose) {
          this.hideReason = HideReason.Outside;
          this.close(e);
        }
      }
    }
  });
  exports.TAlert = TAlert;
  exports.TButton = TButton;
  exports.TCard = TCard;
  exports.TCheckbox = TCheckbox;
  exports.TCheckboxGroup = TCheckboxGroup;
  exports.TDatepicker = TDatepicker;
  exports.TDialog = TDialog;
  exports.TDropdown = TDropdown;
  exports.TInput = TInput;
  exports.TInputGroup = TInputGroup;
  exports.TModal = TModal;
  exports.TPagination = TPagination;
  exports.TRadio = TRadio;
  exports.TRadioGroup = TRadioGroup;
  exports.TRichSelect = TRichSelect;
  exports.TSelect = TSelect;
  exports.TTable = TTable;
  exports.TTag = TTag;
  exports.TTextarea = TTextarea;
  exports.TToggle = TToggle;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});